(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/basic-editor.component.html":
/*!********************************************************************************************************************************************************!*\
  !*** C:/WebstormProjects/livechartsDogfight/node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/basic-editor.component.html ***!
  \********************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"basic-editor-wrapper\">\r\n  <div class=\"basic-editor-controls\">\r\n    <lib-controls [params]=\"params\"></lib-controls>\r\n  </div>\r\n  <div class=\"basic-editor-output\">\r\n    <div class=\"basic-editor-playback\">\r\n      <lib-playback\r\n        [metadata]=\"getMetadata()\"\r\n        [labelsForStills]=\"labelsForStills\"\r\n        (render)=\"renderOfType($event)\"\r\n      ></lib-playback>\r\n      <lib-scrub *ngIf=\"getCategory() === 'animation'\"></lib-scrub>\r\n      <lib-timer *ngIf=\"getCategory() === 'animation'\"></lib-timer>\r\n      <hr />\r\n      <br />\r\n    </div>\r\n    <div class=\"basic-editor-visualisation\">\r\n      <ng-template #livechart></ng-template>\r\n    </div>\r\n    <div class=\"basic-editor-canvas\">\r\n      <!-- <canvas #canvas></canvas> -->\r\n    </div>\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/control-group/control-group.component.html":
/*!********************************************************************************************************************************************************************************!*\
  !*** C:/WebstormProjects/livechartsDogfight/node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/control-group/control-group.component.html ***!
  \********************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"basic-editor-control-group\">\r\n  <mat-expansion-panel [expanded]=\"!group['collapsed']\">\r\n    <mat-expansion-panel-header>\r\n      <mat-panel-title *ngIf=\"group['title']\">\r\n        {{ group['title'] }}\r\n      </mat-panel-title>\r\n      <mat-panel-description *ngIf=\"group['description']\">\r\n        {{ group['description'] }}\r\n      </mat-panel-description>\r\n    </mat-expansion-panel-header>\r\n    <lib-control-wrapper\r\n      *ngFor=\"let id of group['ids'] || group['keys']\"\r\n      [id]=\"id\"\r\n      [settings]=\"controls[id]\"\r\n    >\r\n    </lib-control-wrapper>\r\n  </mat-expansion-panel>\r\n</div>\r\n");

/***/ }),

/***/ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/control-wrapper/control-wrapper.component.html":
/*!************************************************************************************************************************************************************************************!*\
  !*** C:/WebstormProjects/livechartsDogfight/node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/control-wrapper/control-wrapper.component.html ***!
  \************************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<ng-template #anchor></ng-template>\r\n<p class=\"control-wrapper-error-message\" *ngIf=\"errorMessage\">\r\n  {{ errorMessage }}\r\n</p>\r\n");

/***/ }),

/***/ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/controls.component.html":
/*!*************************************************************************************************************************************************************!*\
  !*** C:/WebstormProjects/livechartsDogfight/node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/controls.component.html ***!
  \*************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-tab-group>\r\n  <mat-tab *ngIf=\"parameterGroups\" label=\"Parameters\">\r\n    <lib-settings [metadata]=\"this.parameters['metadata']\"></lib-settings>\r\n    <lib-control-group\r\n      *ngFor=\"let parameterGroup of parameterGroups\"\r\n      [group]=\"parameterGroup\"\r\n      [controls]=\"this.parameters['parameters']\"\r\n    ></lib-control-group>\r\n  </mat-tab>\r\n  <mat-tab *ngIf=\"timingGroups\" label=\"Timing\">\r\n    <lib-control-group\r\n      *ngFor=\"let timingGroup of timingGroups\"\r\n      [group]=\"timingGroup\"\r\n      [controls]=\"this.parameters['timings']\"\r\n    ></lib-control-group>\r\n  </mat-tab>\r\n  <mat-tab *ngIf=\"data\" label=\"Data\"> </mat-tab>\r\n</mat-tab-group>\r\n");

/***/ }),

/***/ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/standard-checkbox/standard-checkbox.component.html":
/*!****************************************************************************************************************************************************************************************!*\
  !*** C:/WebstormProjects/livechartsDogfight/node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/standard-checkbox/standard-checkbox.component.html ***!
  \****************************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-checkbox>{{ settings['label'] }}</mat-checkbox>\r\n");

/***/ }),

/***/ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/standard-control/standard-control.component.html":
/*!**************************************************************************************************************************************************************************************!*\
  !*** C:/WebstormProjects/livechartsDogfight/node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/standard-control/standard-control.component.html ***!
  \**************************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-form-field class=\"basic-editor-form-field\">\r\n  <input matInput [placeholder]=\"settings['label']\" [formControl]=\"form\" />\r\n  <mat-icon\r\n    *ngIf=\"description\"\r\n    matSuffix\r\n    matTooltip=\"{{ description }}\"\r\n    style=\"color:rgba(0,0,0,.3)\"\r\n    >info_outline</mat-icon\r\n  >\r\n  <mat-hint *ngIf=\"settings['hint']\">{{ settings['hint'] }}</mat-hint>\r\n  <mat-error *ngIf=\"form.invalid\">{{ errorMessage }}</mat-error>\r\n</mat-form-field>\r\n");

/***/ }),

/***/ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/standard-number/standard-number.component.html":
/*!************************************************************************************************************************************************************************************!*\
  !*** C:/WebstormProjects/livechartsDogfight/node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/standard-number/standard-number.component.html ***!
  \************************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- [(ngModel)]=\"value\" (ngModelChange)=\"valueChanged($event)\" -->\r\n<mat-form-field class=\"basic-editor-form-field\">\r\n  <input\r\n    matInput\r\n    class=\"basic-editor-control\"\r\n    [placeholder]=\"settings['label']\"\r\n    [formControl]=\"form\"\r\n    type=\"number\"\r\n    [attr.step]=\"settings['step']\"\r\n    [attr.min]=\"settings['min']\"\r\n    [attr.max]=\"settings['max']\"\r\n    [name]=\"id\"\r\n  />\r\n  <mat-icon\r\n    *ngIf=\"description\"\r\n    matSuffix\r\n    matTooltip=\"{{ description }}\"\r\n    style=\"color:rgba(0,0,0,.3)\"\r\n    >info_outline</mat-icon\r\n  >\r\n  <mat-hint *ngIf=\"settings['hint']\">{{ settings['hint'] }}</mat-hint>\r\n  <mat-error *ngIf=\"form.invalid\">{{ errorMessage }}</mat-error>\r\n</mat-form-field>\r\n");

/***/ }),

/***/ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/standard-photo/standard-photo.component.html":
/*!**********************************************************************************************************************************************************************************!*\
  !*** C:/WebstormProjects/livechartsDogfight/node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/standard-photo/standard-photo.component.html ***!
  \**********************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"photo\" *ngIf=\"photo\">\r\n  <img [src]=\"photo.url\" />\r\n  <p class=\"photo-name\">{{photo.name}}</p>\r\n  <p class=\"photo-controls\">\r\n    <span class=\"photo-control-x\" (click)=\"remove($event)\">X</span>\r\n  </p>\r\n</div>\r\n<div class=\"dropzone\" (drop)=\"dropHandler($event)\" (dragover)=\"dragOverHandler($event)\" *ngIf=\"!photo\">\r\n  Drop afbeelding hier\r\n</div>\r\n<!--<div *ngIf=\"photo\">-->\r\n  <!--<p class=\"photo-control\" (click)=\"clear()\">-->\r\n    <!--Verwijder-->\r\n  <!--</p>-->\r\n<!--</div>-->\r\n<div class=\"dropzoneErrors\">\r\n  <ul>\r\n    <li *ngFor=\"let error of errors\" class=\"dropzoneError\">{{error}}</li>\r\n  </ul>\r\n</div>\r\n");

/***/ }),

/***/ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/standard-select/standard-select.component.html":
/*!************************************************************************************************************************************************************************************!*\
  !*** C:/WebstormProjects/livechartsDogfight/node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/standard-select/standard-select.component.html ***!
  \************************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-form-field class=\"basic-editor-form-field\">\r\n  <mat-label>{{ settings['label'] }}</mat-label>\r\n  <mat-select [formControl]=\"form\">\r\n    <mat-option\r\n      *ngFor=\"let value of settings['values']; let i = index\"\r\n      [value]=\"i\"\r\n    >\r\n      {{ value['label'] }}\r\n    </mat-option>\r\n  </mat-select>\r\n  <mat-icon\r\n    *ngIf=\"description\"\r\n    matSuffix\r\n    matTooltip=\"{{ description }}\"\r\n    style=\"color:rgba(0,0,0,.3)\"\r\n    >info_outline</mat-icon\r\n  >\r\n  <mat-hint *ngIf=\"settings['hint']\">{{ settings['hint'] }}</mat-hint>\r\n  <mat-error *ngIf=\"form.invalid\">{{ errorMessage }}</mat-error>\r\n</mat-form-field>\r\n");

/***/ }),

/***/ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/standard-slide/standard-slide.component.html":
/*!**********************************************************************************************************************************************************************************!*\
  !*** C:/WebstormProjects/livechartsDogfight/node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/standard-slide/standard-slide.component.html ***!
  \**********************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-slide-toggle\r\n  class=\"basic-editor-form-field\"\r\n  [color]=\"settings['color']\"\r\n  [labelPosition]=\"settings['labelPosition']\"\r\n  [formControl]=\"form\"\r\n  >{{ settings['label'] }}</mat-slide-toggle\r\n>\r\n");

/***/ }),

/***/ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/standard-slider/standard-slider.component.html":
/*!************************************************************************************************************************************************************************************!*\
  !*** C:/WebstormProjects/livechartsDogfight/node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/standard-slider/standard-slider.component.html ***!
  \************************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"basic-editor-form-field\">\r\n  <span *ngIf=\"settings['label']\">{{ settings['label'] }}</span>\r\n  <mat-slider\r\n    [invert]=\"settings['invert']\"\r\n    [max]=\"settings['max']\"\r\n    [min]=\"settings['min']\"\r\n    [formControl]=\"form\"\r\n    [step]=\"settings['step']\"\r\n    [thumbLabel]=\"settings['thumbLabel']\"\r\n    [tickInterval]=\"settings['tickInterval']\"\r\n    [vertical]=\"settings['vertical']\"\r\n  >\r\n  </mat-slider>\r\n</div>\r\n");

/***/ }),

/***/ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/standard-textarea/standard-textarea.component.html":
/*!****************************************************************************************************************************************************************************************!*\
  !*** C:/WebstormProjects/livechartsDogfight/node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/standard-textarea/standard-textarea.component.html ***!
  \****************************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- [(ngModel)]=\"value\" (ngModelChange)=\"valueChanged($event)\" -->\r\n<mat-form-field class=\"basic-editor-form-field\">\r\n  <textarea\r\n    matInput\r\n    class=\"basic-editor-control\"\r\n    [placeholder]=\"settings['label']\"\r\n    [formControl]=\"form\"\r\n    [attr.rows]=\"settings['rows'] || 3\"\r\n    [name]=\"id\"\r\n  ></textarea>\r\n  <mat-icon\r\n    *ngIf=\"description\"\r\n    matSuffix\r\n    matTooltip=\"{{ description }}\"\r\n    style=\"color:rgba(0,0,0,.3)\"\r\n    >info_outline</mat-icon\r\n  >\r\n  <mat-hint *ngIf=\"settings['hint']\">{{ settings['hint'] }}</mat-hint>\r\n  <mat-error *ngIf=\"form.invalid\">{{ errorMessage }}</mat-error>\r\n</mat-form-field>\r\n");

/***/ }),

/***/ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/playback/playback.component.html":
/*!*************************************************************************************************************************************************************!*\
  !*** C:/WebstormProjects/livechartsDogfight/node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/playback/playback.component.html ***!
  \*************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- Material does not seem to provide for nice button groups -->\r\n<!-- TODO CSS - figure out something better here... -->\r\n<div id=\"playback-wrapper\">\r\n  <div\r\n    *ngIf=\"metadata['category'] === 'animation'\"\r\n    id=\"playback-buttons\"\r\n    class=\"playback-group\"\r\n  >\r\n    <button mat-flat-button color=\"primary\" (click)=\"playPause()\">\r\n      {{ (playing$ | async) === 'playing' ? 'Pause' : 'Play' }}\r\n    </button>\r\n    <!-- <button mat-flat-button color=\"primary\" (click)=\"play()\">Play</button> -->\r\n    <!-- <button mat-flat-button color=\"primary\" (click)=\"pause()\">Pause</button> -->\r\n    <button mat-flat-button color=\"primary\" (click)=\"restart()\">Restart</button>\r\n  </div>\r\n  <div id=\"still-buttons\" class=\"playback-group\">\r\n    <button\r\n      *ngFor=\"let labelForStill of labelsForStills\"\r\n      mat-flat-button\r\n      color=\"primary\"\r\n      (click)=\"stopForStill(labelForStill)\"\r\n    >\r\n      Still {{ labelForStill.nr }}\r\n    </button>\r\n  </div>\r\n  <div id=\"render-buttons\" class=\"playback-group\">\r\n    <button\r\n      *ngIf=\"outputType('png')\"\r\n      [disabled]=\"\r\n        metadata['category'] === 'animation' && (playing$ | async) === 'playing'\r\n      \"\r\n      mat-flat-button\r\n      color=\"accent\"\r\n      (click)=\"renderOfType('png')\"\r\n    >\r\n      PNG\r\n    </button>\r\n    <button\r\n      *ngIf=\"outputType('svg')\"\r\n      [disabled]=\"\r\n        metadata['category'] === 'animation' && (playing$ | async) === 'playing'\r\n      \"\r\n      mat-flat-button\r\n      color=\"accent\"\r\n      (click)=\"renderOfType('svg')\"\r\n    >\r\n      SVG\r\n    </button>\r\n    <button\r\n      *ngIf=\"metadata['category'] === 'animation' && outputType('gif')\"\r\n      mat-flat-button\r\n      color=\"accent\"\r\n      (click)=\"renderOfType('gif')\"\r\n    >\r\n      Gif\r\n    </button>\r\n    <button\r\n      *ngIf=\"metadata['category'] === 'animation' && outputType('video')\"\r\n      mat-flat-button\r\n      color=\"accent\"\r\n      (click)=\"renderOfType('video')\"\r\n    >\r\n      Video\r\n    </button>\r\n    <button\r\n      *ngIf=\"metadata['category'] === 'still' && outputType('pngs')\"\r\n      mat-flat-button\r\n      color=\"accent\"\r\n      (click)=\"renderOfType('pngs')\"\r\n    >\r\n      Slices\r\n    </button>\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/render-video-dialog/render-video-dialog.component.html":
/*!***********************************************************************************************************************************************************************************!*\
  !*** C:/WebstormProjects/livechartsDogfight/node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/render-video-dialog/render-video-dialog.component.html ***!
  \***********************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<h2 mat-dialog-title>Render video</h2>\r\n<div *ngIf=\"!finished && !rendering && !aborted && !errored\">\r\n  <mat-dialog-content>\r\n    <div class=\"wrapper\">\r\n      <div class=\"left\">\r\n        <span class=\"main\">\r\n          Creates a WebM-video for the web, in the browser.\r\n        </span>\r\n        <span class=\"sub\">\r\n          No data will leave the computer.\r\n        </span>\r\n      </div>\r\n      <div class=\"right\">\r\n        <button class=\"mat-raised-button mat-accent\" (click)=\"renderWebM()\">\r\n          WebM\r\n        </button>\r\n      </div>\r\n    </div>\r\n    <div class=\"wrapper\">\r\n      <div class=\"left\">\r\n        <span class=\"main\">\r\n          Creates a small and compatible MP4-video for the web, on our server.\r\n        </span>\r\n        <span class=\"sub\">\r\n          Data will be sent securely across the internet and deleted once the\r\n          video is finished.\r\n        </span>\r\n      </div>\r\n      <div class=\"right\">\r\n        <button class=\"mat-raised-button mat-warn\" (click)=\"renderMP4()\">\r\n          MP4\r\n        </button>\r\n      </div>\r\n    </div>\r\n    <div class=\"wrapper\">\r\n      <div class=\"left\">\r\n        <span class=\"main\">\r\n          Creates a high quality and transparent Apple ProRes MOV-video for\r\n          editing, on our server.\r\n        </span>\r\n        <span class=\"sub\">\r\n          Data will be sent securely across the internet and deleted once the\r\n          video is finished.\r\n        </span>\r\n      </div>\r\n      <div class=\"right\">\r\n        <button class=\"mat-raised-button mat-warn\" (click)=\"renderMov()\">\r\n          MOV\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </mat-dialog-content>\r\n  <mat-dialog-actions>\r\n    <button class=\"mat-raised-button\" (click)=\"close()\">Close</button>\r\n  </mat-dialog-actions>\r\n</div>\r\n<div *ngIf=\"!finished && rendering && !aborted && !errored\">\r\n  <div class=\"top\">\r\n    <span class=\"main\">\r\n      Rendering\r\n    </span>\r\n  </div>\r\n  <div class=\"msg\">\r\n    <span class=\"sub\">\r\n      {{ renderService.messageObservable | async }}\r\n    </span>\r\n  </div>\r\n  <mat-dialog-actions>\r\n    <button class=\"mat-raised-button mat-warn\" (click)=\"abort()\">Abort</button>\r\n  </mat-dialog-actions>\r\n</div>\r\n<div *ngIf=\"!finished && !rendering && (aborted || errored)\">\r\n  <div class=\"top\">\r\n    <span class=\"main\">\r\n      Aborted\r\n    </span>\r\n  </div>\r\n  <div class=\"msg\" *ngIf=\"errored\">\r\n    <span class=\"sub\">\r\n      <!-- {{ renderService.errorObservable | async }} -->\r\n      {{ error }}\r\n    </span>\r\n  </div>\r\n  <div class=\"msg\" *ngIf=\"aborted\">\r\n    <span class=\"sub\">\r\n      {{ renderService.messageObservable | async }}\r\n    </span>\r\n  </div>\r\n  <mat-dialog-actions>\r\n    <button class=\"mat-raised-button\" (click)=\"close()\">Close</button>\r\n  </mat-dialog-actions>\r\n</div>\r\n<div *ngIf=\"finished && !rendering && !aborted && !errored\">\r\n  <div class=\"top\">\r\n    <span class=\"main\">\r\n      Finished\r\n    </span>\r\n  </div>\r\n  <mat-dialog-actions>\r\n    <button class=\"mat-raised-button\" (click)=\"close()\">Close</button>\r\n  </mat-dialog-actions>\r\n</div>\r\n");

/***/ }),

/***/ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/scrub/scrub.component.html":
/*!*******************************************************************************************************************************************************!*\
  !*** C:/WebstormProjects/livechartsDogfight/node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/scrub/scrub.component.html ***!
  \*******************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div id=\"lcs-progress-scrubber\" (click)=\"clickScrubber($event)\">\r\n  <div id=\"lcs-progress-scrubber-spacer\"></div>\r\n  <div id=\"lcs-progress-scrubber-done\"></div>\r\n  <div id=\"lcs-progress-scrubber-todo\"></div>\r\n  <div id=\"lcs-progress-thumb-container\">\r\n    <span id=\"lcs-progress-thumb-spacer\"></span>\r\n    <span id=\"lcs-progress-thumb\"></span>\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/settings/frame-rate/frame-rate.component.html":
/*!**************************************************************************************************************************************************************************!*\
  !*** C:/WebstormProjects/livechartsDogfight/node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/settings/frame-rate/frame-rate.component.html ***!
  \**************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"basic-editor-form-field lcs-framerate-slider\">\r\n  <span>Framerate</span>\r\n  <mat-slider\r\n    [min]=\"min\"\r\n    [max]=\"max\"\r\n    [formControl]=\"formControl\"\r\n    [step]=\"1\"\r\n    [thumbLabel]=\"true\"\r\n  >\r\n  </mat-slider>\r\n</div>\r\n");

/***/ }),

/***/ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/settings/scalable/scalable.component.html":
/*!**********************************************************************************************************************************************************************!*\
  !*** C:/WebstormProjects/livechartsDogfight/node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/settings/scalable/scalable.component.html ***!
  \**********************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-slide-toggle\r\n  class=\"basic-editor-form-field\"\r\n  [formControl]=\"formControl\"\r\n  labelPosition=\"before\"\r\n>\r\n  Scalable\r\n</mat-slide-toggle>\r\n");

/***/ }),

/***/ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/settings/settings.component.html":
/*!*************************************************************************************************************************************************************!*\
  !*** C:/WebstormProjects/livechartsDogfight/node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/settings/settings.component.html ***!
  \*************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-card class=\"basic-editor-settings\">\r\n  <mat-card-content>\r\n    <lib-frame-rate></lib-frame-rate>\r\n    <lib-scalable></lib-scalable>\r\n    <lib-slices *ngIf=\"hasSlices\"></lib-slices>\r\n  </mat-card-content>\r\n</mat-card>\r\n");

/***/ }),

/***/ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/settings/slices/slices.component.html":
/*!******************************************************************************************************************************************************************!*\
  !*** C:/WebstormProjects/livechartsDogfight/node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/settings/slices/slices.component.html ***!
  \******************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-slide-toggle\r\n  class=\"basic-editor-form-field\"\r\n  [formControl]=\"formControl\"\r\n  labelPosition=\"before\"\r\n>\r\n  Show slices\r\n</mat-slide-toggle>\r\n");

/***/ }),

/***/ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/timer/timer.component.html":
/*!*******************************************************************************************************************************************************!*\
  !*** C:/WebstormProjects/livechartsDogfight/node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/timer/timer.component.html ***!
  \*******************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"lcs-timer-wrapper\">\r\n  <div class=\"lcs-timer-progress\">\r\n    Progress: {{ progress * 100 | number: '1.0-0' }}%\r\n  </div>\r\n  <div class=\"lcs-timer-time\">Time: {{ time | number: '1.1-1' }} seconds</div>\r\n  <div class=\"lcs-timer-duration\">\r\n    Duration: {{ duration | number: '1.1-1' }} seconds\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/overview/basic-overview/basic-overview-element/basic-overview-element.component.html":
/*!*********************************************************************************************************************************************************************************************!*\
  !*** C:/WebstormProjects/livechartsDogfight/node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/overview/basic-overview/basic-overview-element/basic-overview-element.component.html ***!
  \*********************************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- <p>{{ animation.name }}</p>\r\n<ng-template #anchor></ng-template>\r\n<button (click)=\"navigateToLivechart()\">{{ animation.name }}</button> -->\r\n\r\n<mat-card class=\"basic-overview-element\" (click)=\"navigateToLivechart()\">\r\n  <mat-card-header>\r\n    <mat-card-title>{{ animation.name }}</mat-card-title>\r\n  </mat-card-header>\r\n  <ng-template #anchor></ng-template>\r\n</mat-card>\r\n");

/***/ }),

/***/ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/overview/basic-overview/basic-overview.component.html":
/*!**************************************************************************************************************************************************************!*\
  !*** C:/WebstormProjects/livechartsDogfight/node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/overview/basic-overview/basic-overview.component.html ***!
  \**************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div *ngIf=\"errorMessage\">\r\n  <p>{{ errorMessage }}</p>\r\n</div>\r\n\r\n<mat-tab-group>\r\n  <mat-tab *ngFor=\"let group of animations\" label=\"{{ group.label }}\">\r\n    <!-- The ng-template below with matTabContent makes sure the content \r\n    of the tabs is lazy loaded. Otherwise we get an error from GSAP\r\n    trying to find elements not yet on the page, see:\r\n    https://material.angular.io/components/tabs/overview \r\n    Tab contents can be lazy loaded by declaring the body\r\n    in a ng-template with the matTabContent attribute.-->\r\n    <ng-template matTabContent>\r\n      <div class=\"basic-overview-wrapper\">\r\n        <lib-basic-overview-element\r\n          *ngFor=\"let animation of group.values\"\r\n          [animation]=\"animation\"\r\n        ></lib-basic-overview-element>\r\n      </div>\r\n    </ng-template>\r\n  </mat-tab>\r\n</mat-tab-group>\r\n");

/***/ }),

/***/ "../../node_modules/raw-loader/dist/cjs.js!./src/app/animations/test/test.component.html":
/*!********************************************************************************************************************************!*\
  !*** C:/WebstormProjects/livechartsDogfight/node_modules/raw-loader/dist/cjs.js!./src/app/animations/test/test.component.html ***!
  \********************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- <p>test works!</p> -->\r\n<svg\r\n  #svg\r\n  [attr.width]=\"scalable ? '100%' : values['size'][0]\"\r\n  [attr.height]=\"scalable ? '100%' : values['size'][1]\"\r\n  [attr.viewBox]=\"'0 0 ' + values['width'] + ' ' + values['height']\"\r\n>\r\n  <defs>\r\n    <pattern [id]=\"'pattern-' + id\" patternUnits=\"userSpaceOnUse\" [attr.width]=\"values['width']\" [attr.height]=\"values['height']\">\r\n    </pattern>\r\n    <filter id=\"blur\" x=\"0\" y=\"0\">\r\n      <feGaussianBlur in=\"SourceGraphic\" stdDeviation=\"10\" />\r\n\r\n\r\n      <!--<feGaussianBlur in=\"SourceGraphic\" [stdDeviation]= values['blurImage'] />-->\r\n    </filter>\r\n    <filter id=\"noblur\" x=\"0\" y=\"0\">\r\n      <feGaussianBlur in=\"SourceGraphic\" stdDeviation=\"0\" />\r\n\r\n\r\n      <!--<feGaussianBlur in=\"SourceGraphic\" [stdDeviation]= values['blurImage'] />-->\r\n    </filter>\r\n  </defs>\r\n  <!-- <rect x=\"0\" y=\"0\" width=\"1080\" height=\"1080\" style=\"fill: #DDD\" /> -->\r\n  <!--<g [id]=\"'background-' + id\" [style]=\"values['blurImage'] === 0 ? filter: url('#noblur') : filter: url('#blur')\">-->\r\n    <g [id]=\"'background-' + id\" [style.filter]=\"'url(' + blurme + ')'\">\r\n  </g>\r\n  <g [id]=\"'content-' + id\"></g>\r\n  <g>\r\n    <svg\r\n      [attr.id]=\"'logo-' + id\"\r\n      [attr.x]=\"-648 / 2 + values['width'] / 2\"\r\n      [attr.opacity]=\"0\"\r\n      [attr.y]=\"-429 / 2 +  values['height'] / 2\"\r\n      [attr.scale]=\"0\"\r\n      width=\"648px\"\r\n      height=\"429px\"\r\n      viewBox=\"0 0 648 429\"\r\n    >\r\n      <g\r\n        transform=\"matrix(1.3333333,0,0,-1.3333333,-73.354665,498.26532)\"\r\n        id=\"g10\"><g\r\n        transform=\"scale(0.1)\"\r\n        id=\"g12\"><path\r\n        [attr.id]=\"'logoIcon1-' + id\"\r\n        [style.fill]=\"values['fillLogo'] ? '#ffffff' : '#b10f1f'\" style=\"fill-opacity:1;fill-rule:nonzero;stroke:none\"\r\n        d=\"m 3451.51,2965.48 c 0,114.35 70.86,211.78 170.91,251.85 96.98,41.13 165.1,137.06 165.1,249.05 0,149.45 -121.16,270.61 -270.61,270.61 -149.45,0 -270.61,-121.16 -270.61,-270.61 0,-51.93 15.36,-99.97 40.72,-141.17 l -0.23,-0.14 c 8.21,-13.01 13.14,-28.31 13.14,-44.84 0,-44.72 -34.17,-81.37 -78.15,-84.26 l -0.73,-0.2 h -699.07 c -436.39,0 -436.39,-436.39 -436.39,-436.39 v -829.15 c 0,-436.39 436.39,-436.39 436.39,-436.39 h 829.14 c 436.4,0 436.4,436.39 436.4,436.39 v 772.11 c -20.73,-5.06 -42.08,-8.5 -64.37,-8.5 -150.02,0 -271.64,121.61 -271.64,271.64 z m -0.13,-871.49 c 0,0 0,-264.02 -264.02,-264.02 h -501.63 c 0,0 -264.01,0 -264.01,264.02 v 501.64 c 0,0 0,264.01 264.01,264.01 h 501.63 c 0,0 264.02,0 264.02,-264.01 v -501.64\" /><path\r\n        [attr.id]=\"'logoIcon2-' + id\"\r\n        [style.fill]=\"values['fillLogo'] ? '#ffffff' : '#00609c'\" style=\"fill-opacity:1;fill-rule:nonzero;stroke:none\"\r\n        d=\"m 2514.39,2139.14 v 411.34 c 0,0 0,216.49 216.49,216.49 h 411.34 c 0,0 216.49,0 216.49,-216.49 v -411.34 c 0,0 0,-216.5 -216.49,-216.5 h -411.34 c 0,0 -216.49,0 -216.49,216.5\" /><path\r\n        [attr.id]=\"'logoTextRechts-' + id\"\r\n        [style.fill]=\"values['fillLogo'] ? '#ffffff' : '#00609c'\" style=\"fill-opacity:1;fill-rule:nonzero;stroke:none\"\r\n        d=\"M 3475.16,898.41 V 519.52 h 118.53 c 118.04,0 177.54,63.519 177.54,189.73 0,125.641 -59.5,189.16 -177.54,189.16 z m 115.69,-340.379 h -74.91 V 860.48 h 74.91 c 96.47,0 139.6,-46.621 139.6,-151.23 0,-104.602 -43.13,-151.219 -139.6,-151.219 z M 3855.26,898.41 V 519.52 h 40.77 v 378.89 z m 295,-212.672 h 91.34 V 567.68 c -27.81,-9.078 -56.75,-13.621 -86.83,-13.621 -95.91,0 -139.03,47.679 -139.03,154.902 0,106.668 43.12,154.918 139.03,154.918 40.29,0 78.88,-8.508 114.58,-24.41 v 39.699 c -37.44,15.863 -77.7,23.781 -119.09,23.781 -116.36,0 -175.3,-65.179 -175.3,-193.988 0,-128.789 58.94,-193.981 175.3,-193.981 46.49,0 90.72,9.629 132.11,29.45 V 725.391 H 4150.26 Z M 4373.77,898.41 V 519.52 h 40.78 v 378.89 z m 104.38,0 v -39.64 h 133.88 V 519.52 h 40.78 v 339.25 h 133.32 v 39.64 z m 490.69,0 h -40.85 l -150.9,-378.89 h 44.25 l 45.38,118 h 163.39 l 45.38,-118 h 43.68 z m -86.8,-221.808 66.37,173.468 66.38,-173.468 z M 5224.08,559.16 V 898.41 H 5183.3 V 519.52 h 234.23 v 39.64 h -193.45\" /><path\r\n        [attr.id]=\"'logoTextLinks-' + id\"\r\n        [style.fill]=\"values['fillLogo'] ? '#ffffff' : '#b10f1f'\" style=\"fill-opacity:1;fill-rule:nonzero;stroke:none\"\r\n        d=\"M 686.266,898.41 H 550.16 V 519.52 h 136.106 c 117.457,0 179.816,65.191 179.816,189.16 0,124.55 -62.359,189.73 -179.816,189.73 z m 0,-298.969 h -38.598 v 219.618 h 38.598 c 58.468,0 82.308,-40.957 82.308,-110.379 0,-68.84 -23.84,-109.239 -82.308,-109.239 z M 1112.89,901.82 c -81.16,0 -177.535,-33.441 -177.535,-192.851 0,-159.41 96.375,-192.848 177.535,-192.848 81.16,0 177.53,33.438 177.53,192.848 0,159.41 -96.37,192.851 -177.53,192.851 z m 0,-302.379 c -41.43,0 -80.03,19.297 -80.03,109.528 0,90.23 38.6,109.519 80.03,109.519 41.43,0 80.02,-19.289 80.02,-109.519 0,-90.231 -38.59,-109.528 -80.02,-109.528 z m 417.54,143.528 V 670.43 h 67.54 v -62.469 c -18.16,-7.953 -37.46,-8.52 -52.22,-8.52 -48.24,0 -91.95,19.879 -91.95,109.528 0,89.082 45.98,109.519 95.36,109.519 36.89,0 72.61,-5.668 115.69,-23.277 v 78.269 c -39.11,17.571 -85.61,28.34 -130.45,28.34 -81.16,0 -177.54,-33.441 -177.54,-193.422 0,-159.41 96.38,-192.847 177.54,-192.847 55.62,0 102.68,13.609 141.22,36.277 v 191.141 z m 493.51,76.09 V 898.41 H 1767.02 V 519.52 h 97.51 v 142.398 h 137.85 v 79.922 h -137.85 v 77.219 z M 2194.13,519.52 v 378.89 h -97.51 V 519.52 Z m 252.48,223.449 V 670.43 h 67.55 v -62.469 c -18.16,-7.953 -37.46,-8.52 -52.22,-8.52 -48.24,0 -91.95,19.879 -91.95,109.528 0,89.082 45.98,109.519 95.36,109.519 36.89,0 72.61,-5.668 115.69,-23.277 v 78.269 c -39.11,17.571 -85.61,28.34 -130.45,28.34 -81.17,0 -177.54,-33.441 -177.54,-193.422 0,-159.41 96.37,-192.847 177.54,-192.847 55.62,0 102.68,13.609 141.22,36.277 V 742.969 Z M 2902.76,898.41 V 748.648 H 2781.28 V 898.41 h -97.5 V 519.52 h 97.5 v 149.21 h 121.48 V 519.52 h 97.51 v 378.89 z m 154.3,0 v -88.422 h 108.93 V 519.52 h 97.5 v 290.468 h 110.06 v 88.422 h -316.49\" /><path\r\n        [attr.id]=\"'logoIcon3-' + id\"\r\n        [style.fill]=\"values['fillLogo'] ? '#ffffff' : '#00609c'\" style=\"fill-opacity:1;fill-rule:nonzero;stroke:none\"\r\n        d=\"m 3844.66,2965.75 c 0,67.25 -54.52,121.77 -121.77,121.77 -67.26,0 -121.78,-54.52 -121.78,-121.77 0,-67.25 54.52,-121.77 121.78,-121.77 67.25,0 121.77,54.52 121.77,121.77\" /></g></g>\r\n    </svg>\r\n  </g>\r\n  <g [style.visibility]=\"values['animationMic'] === 'doNotShowAtAll' ? 'hidden' : 'visible'\" [attr.id]=\"'micGroup-' + id\" [attr.x]=\"0\"\r\n     [attr.y]=\"0\">\r\n    <svg\r\n      [attr.id]=\"'mic-' + id\"\r\n    [attr.x]=\"this.xLogo\"\r\n    [attr.y]=\"this.yLogo\"\r\n    width=\"190px\"\r\n    height=\"190px\"\r\n    viewBox=\"0 0 190 190\"\r\n    ><circle cx=\"624.686\" cy=\"73.113\" transform=\"matrix(1.33333 0 0 1.33333 -737.915 -2.484)\" r=\"71.25\" fill=\"#ffffff\"/>\r\n      <g fill=\"#1e488d\">\r\n        <path d=\"M101.079 33.736c1.255.345 2.548.59 3.759 1.052 4.844 1.852 8.793 6.62 9.444 11.4H99.526v4.971h15.024v5.03H99.523v4.952h15.03v4.96H99.559v5.022h14.996v4.959h-15v5.026h15.002v4.953H99.552v5.029h15.008v4.95H99.547v5.009h14.773c-.482 2.875-1.739 5.255-3.594 7.307-3.136 3.468-7.045 5.248-11.77 5.195-3.087-.035-6.176-.002-9.265-.008-7.331-.015-13.926-5.813-14.883-13.095a18.395 18.395 0 01-.168-2.375c-.01-16.28-.008-32.56-.007-48.839 0-7.809 5.436-14.135 13.166-15.33.128-.02.246-.11.368-.168h12.912\"/>\r\n        <path d=\"M57.163 81.165h9.97v17.239c.002 10.988 8.19 20.627 19.034 22.372 1.022.165 2.068.232 3.104.24 3.47.03 6.94.02 10.41.01 10.622-.026 20.155-7.987 22.017-18.426.247-1.387.384-2.81.396-4.219.045-5.333.019-10.666.019-16V81.19h9.877c.042.09.094.15.094.21.004 6.164.225 12.338-.046 18.49-.403 9.132-4.246 16.754-11.073 22.855-4.957 4.429-10.762 7.056-17.337 7.99-1.293.183-2.607.225-3.958.337v17.39H120.797v9.924H68.462v-9.909h21.111v-17.362c-1.526-.167-3.069-.28-4.594-.512-7.721-1.173-14.154-4.76-19.385-10.498-4.195-4.602-6.841-9.998-7.967-16.12-.23-1.254-.435-2.535-.444-3.805-.045-6.3-.02-12.6-.02-19.015\"/>\r\n      </g></svg>\r\n  </g>\r\n</svg>\r\n");

/***/ }),

/***/ "../../node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!***************************************************************************************************************!*\
  !*** C:/WebstormProjects/livechartsDogfight/node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \***************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-toolbar color=\"primary\">\r\n  <span (click)=\"home()\" id=\"livecharts-home\">Livecharts</span>\r\n</mat-toolbar>\r\n<router-outlet></router-outlet>\r\n");

/***/ }),

/***/ "../../node_modules/tslib/tslib.es6.js":
/*!******************************************************************************!*\
  !*** C:/WebstormProjects/livechartsDogfight/node_modules/tslib/tslib.es6.js ***!
  \******************************************************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/basic-editor.component.scss":
/*!*****************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/basic-editor.component.scss ***!
  \*****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".basic-editor-wrapper {\n  display: flex;\n  flex-flow: row wrap;\n}\n\n.basic-editor-controls {\n  flex-grow: 1;\n  flex-basis: 300px;\n}\n\n.basic-editor-output {\n  flex-grow: 3;\n  flex-basis: 500px;\n}\n\n.basic-editor-control {\n  margin: 1px;\n}\n\nhr {\n  border: 0;\n  height: 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.3);\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInByb2plY3RzL2xpdmVjaGFydHMvc3JjL2xpYi9lZGl0b3IvYmFzaWMtZWRpdG9yL0M6XFxXZWJzdG9ybVByb2plY3RzXFxsaXZlY2hhcnRzRG9nZmlnaHQvcHJvamVjdHNcXGxpdmVjaGFydHNcXHNyY1xcbGliXFxlZGl0b3JcXGJhc2ljLWVkaXRvclxcYmFzaWMtZWRpdG9yLmNvbXBvbmVudC5zY3NzIiwicHJvamVjdHMvbGl2ZWNoYXJ0cy9zcmMvbGliL2VkaXRvci9iYXNpYy1lZGl0b3IvYmFzaWMtZWRpdG9yLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBRUUsYUFBQTtFQUNBLG1CQUFBO0FDQUY7O0FER0E7RUFDRSxZQUFBO0VBQ0EsaUJBQUE7QUNBRjs7QURHQTtFQUNFLFlBQUE7RUFDQSxpQkFBQTtBQ0FGOztBREdBO0VBQ0UsV0FBQTtBQ0FGOztBREdBO0VBQ0UsU0FBQTtFQUNBLFNBQUE7RUFDQSx3Q0FBQTtFQUNBLGlEQUFBO0FDQUYiLCJmaWxlIjoicHJvamVjdHMvbGl2ZWNoYXJ0cy9zcmMvbGliL2VkaXRvci9iYXNpYy1lZGl0b3IvYmFzaWMtZWRpdG9yLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmJhc2ljLWVkaXRvci13cmFwcGVyIHtcclxuICAvLyBtYXJnaW46IDEwcHg7XHJcbiAgZGlzcGxheTogZmxleDtcclxuICBmbGV4LWZsb3c6IHJvdyB3cmFwO1xyXG59XHJcblxyXG4uYmFzaWMtZWRpdG9yLWNvbnRyb2xzIHtcclxuICBmbGV4LWdyb3c6IDE7XHJcbiAgZmxleC1iYXNpczogMzAwcHg7XHJcbn1cclxuXHJcbi5iYXNpYy1lZGl0b3Itb3V0cHV0IHtcclxuICBmbGV4LWdyb3c6IDM7XHJcbiAgZmxleC1iYXNpczogNTAwcHg7XHJcbn1cclxuXHJcbi5iYXNpYy1lZGl0b3ItY29udHJvbCB7XHJcbiAgbWFyZ2luOiAxcHg7XHJcbn1cclxuXHJcbmhyIHtcclxuICBib3JkZXI6IDA7XHJcbiAgaGVpZ2h0OiAwO1xyXG4gIGJvcmRlci10b3A6IDFweCBzb2xpZCByZ2JhKDAsIDAsIDAsIDAuMSk7XHJcbiAgYm9yZGVyLWJvdHRvbTogMXB4IHNvbGlkIHJnYmEoMjU1LCAyNTUsIDI1NSwgMC4zKTtcclxufVxyXG4iLCIuYmFzaWMtZWRpdG9yLXdyYXBwZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWZsb3c6IHJvdyB3cmFwO1xufVxuXG4uYmFzaWMtZWRpdG9yLWNvbnRyb2xzIHtcbiAgZmxleC1ncm93OiAxO1xuICBmbGV4LWJhc2lzOiAzMDBweDtcbn1cblxuLmJhc2ljLWVkaXRvci1vdXRwdXQge1xuICBmbGV4LWdyb3c6IDM7XG4gIGZsZXgtYmFzaXM6IDUwMHB4O1xufVxuXG4uYmFzaWMtZWRpdG9yLWNvbnRyb2wge1xuICBtYXJnaW46IDFweDtcbn1cblxuaHIge1xuICBib3JkZXI6IDA7XG4gIGhlaWdodDogMDtcbiAgYm9yZGVyLXRvcDogMXB4IHNvbGlkIHJnYmEoMCwgMCwgMCwgMC4xKTtcbiAgYm9yZGVyLWJvdHRvbTogMXB4IHNvbGlkIHJnYmEoMjU1LCAyNTUsIDI1NSwgMC4zKTtcbn0iXX0= */");

/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/basic-editor.component.ts":
/*!***************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/basic-editor.component.ts ***!
  \***************************************************************************/
/*! exports provided: BasicEditorComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BasicEditorComponent", function() { return BasicEditorComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material */ "../../node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _render_video_dialog_render_video_dialog_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./render-video-dialog/render-video-dialog.component */ "../livecharts/src/lib/editor/basic-editor/render-video-dialog/render-video-dialog.component.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "../../node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _livecharts_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../livecharts.service */ "../livecharts/src/lib/livecharts.service.ts");
/* harmony import */ var _services_util_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../services/util.service */ "../livecharts/src/lib/services/util.service.ts");
/* harmony import */ var _services_render_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../services/render.service */ "../livecharts/src/lib/services/render.service.ts");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! lodash */ "../../node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! file-saver */ "../../node_modules/file-saver/dist/FileSaver.min.js");
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(file_saver__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var jszip__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! jszip */ "../../node_modules/jszip/dist/jszip.min.js");
/* harmony import */ var jszip__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(jszip__WEBPACK_IMPORTED_MODULE_10__);











let BasicEditorComponent = class BasicEditorComponent {
    constructor(componentFactoryResolver, changeDetectorRef, livechartsService, utilService, renderService, route, dialog) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.changeDetectorRef = changeDetectorRef;
        this.livechartsService = livechartsService;
        this.utilService = utilService;
        this.renderService = renderService;
        this.route = route;
        this.dialog = dialog;
    }
    ngOnInit() {
        this.livechartsService.setPlaybackCommand(this.livechartsService.settings.editor.playing);
        this.route.params.subscribe(params => {
            this.animationID = params['animationID'];
            this.animation = this.livechartsService.getAnimationById(this.animationID);
        });
    }
    ngAfterViewInit() {
        // console.log(this.canvasContainerRef.element.nativeElement);
        let componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.animation['component']);
        this.livechartContainerRef.clear();
        this.componentRef = this.livechartContainerRef.createComponent(componentFactory);
        this.instance = this.componentRef.instance;
        // Set parameters on the instance of the Livechart
        this.instance.parameters = this.animation['params'];
        // Set the default value from the settings on the
        this.instance.scalable = this.livechartsService.settings.editor.scalable;
        this.instance.showSlices = this.livechartsService.settings.editor.slices;
        // this.instance.showHideSlices(this.livechartsService.settings.editor.slices);
        // Set parameters on the controls component
        this.params = this.animation['params'];
        // Because bindings have been changed in the CD loop
        // manually kick-off CD again
        this.changeDetectorRef.detectChanges(); // Necessary for OnInit on the instance to fire
        this.labelsForStills = this.instance.findLabelsForStills() || []; // Get the positions where stills can be taken
        this.changeDetectorRef.detectChanges(); // As these labels need to be represented in the view, run CD again
    }
    ngOnDestroy() {
        this.instance.kill();
        this.changeDetectorRef.detach();
    }
    getCategory() {
        let category = lodash__WEBPACK_IMPORTED_MODULE_8__["get"](this.animation, ['params', 'metadata', 'category']);
        return category;
    }
    getMetadata() {
        let metadata = lodash__WEBPACK_IMPORTED_MODULE_8__["get"](this.animation, ['params', 'metadata']);
        return metadata;
    }
    renderOfType(type) {
        // console.log(type);
        let promise;
        switch (type) {
            case 'png':
                this.instance.beforeRender();
                // promise = this.renderService.renderPNGToBlob(
                //   this.instance.svgElement,
                //   this.instance.getParameterValue('size')[0],
                //   this.instance.getParameterValue('size')[1],
                //   null, // this.canvasContainerRef.element.nativeElement
                // );
                promise = this.renderService.renderPNGToBlob(this.instance.svgElement, this.instance.getParameterValue('size')[0], this.instance.getParameterValue('size')[1], 
                // 'blob',
                null);
                promise.then(blob => {
                    Object(file_saver__WEBPACK_IMPORTED_MODULE_9__["saveAs"])(blob, `${this.animationID}.png`);
                    this.instance.afterRender();
                });
                break;
            case 'svg':
                // let p = this.utilService.test();
                break;
            case 'video':
                this.showRenderVideoDialog();
                break;
            case 'pngs':
                this.instance.beforeRender();
                promise = this.renderService.renderSlicesToBlobs(this.instance.svgElement, this.instance.getParameterValue('width'), this.instance.getParameterValue('height'), this.instance.getParameterValue('size')[0], this.instance.getParameterValue('size')[1], this.instance.parameters.metadata.frame, this.instance.parameters.metadata.slices, null);
                promise.then(list => {
                    // saveAs(list[0], `${this.animationID}.png`);
                    let zip = new jszip__WEBPACK_IMPORTED_MODULE_10__();
                    list.map((img, i) => {
                        zip.file(`${this.animationID}-slice-${i}.png`, img);
                    });
                    zip.generateAsync({ type: 'blob' }).then(zipBlob => {
                        Object(file_saver__WEBPACK_IMPORTED_MODULE_9__["saveAs"])(zipBlob, `${this.animationID}-slices.zip`);
                    });
                    this.instance.afterRender();
                });
                break;
        }
    }
    showRenderVideoDialog() {
        let dialogConfig = new _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatDialogConfig"]();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '500px';
        dialogConfig.data = {
            instance: this.instance,
        };
        this.dialog.open(_render_video_dialog_render_video_dialog_component__WEBPACK_IMPORTED_MODULE_3__["RenderVideoDialogComponent"], dialogConfig);
    }
};
BasicEditorComponent.ctorParameters = () => [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ComponentFactoryResolver"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectorRef"] },
    { type: _livecharts_service__WEBPACK_IMPORTED_MODULE_5__["LivechartsService"] },
    { type: _services_util_service__WEBPACK_IMPORTED_MODULE_6__["UtilService"] },
    { type: _services_render_service__WEBPACK_IMPORTED_MODULE_7__["RenderService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["ActivatedRoute"] },
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatDialog"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('livechart', { read: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewContainerRef"], static: false })
], BasicEditorComponent.prototype, "livechartContainerRef", void 0);
BasicEditorComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'lib-basic-editor',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./basic-editor.component.html */ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/basic-editor.component.html")).default,
        encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].None,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./basic-editor.component.scss */ "../livecharts/src/lib/editor/basic-editor/basic-editor.component.scss")).default]
    })
], BasicEditorComponent);



/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/basic-editor.module.ts":
/*!************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/basic-editor.module.ts ***!
  \************************************************************************/
/*! exports provided: BasicEditorModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BasicEditorModule", function() { return BasicEditorModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser */ "../../node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "../../node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _material_material_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../material/material.module */ "../livecharts/src/lib/material/material.module.ts");
/* harmony import */ var _controls_controls_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./controls/controls.service */ "../livecharts/src/lib/editor/basic-editor/controls/controls.service.ts");
/* harmony import */ var _basic_editor_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./basic-editor.component */ "../livecharts/src/lib/editor/basic-editor/basic-editor.component.ts");
/* harmony import */ var _controls_controls_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./controls/controls.component */ "../livecharts/src/lib/editor/basic-editor/controls/controls.component.ts");
/* harmony import */ var _controls_control_group_control_group_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./controls/control-group/control-group.component */ "../livecharts/src/lib/editor/basic-editor/controls/control-group/control-group.component.ts");
/* harmony import */ var _controls_control_wrapper_control_wrapper_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./controls/control-wrapper/control-wrapper.component */ "../livecharts/src/lib/editor/basic-editor/controls/control-wrapper/control-wrapper.component.ts");
/* harmony import */ var _controls_standard_control_standard_control_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./controls/standard-control/standard-control.component */ "../livecharts/src/lib/editor/basic-editor/controls/standard-control/standard-control.component.ts");
/* harmony import */ var _controls_standard_number_standard_number_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./controls/standard-number/standard-number.component */ "../livecharts/src/lib/editor/basic-editor/controls/standard-number/standard-number.component.ts");
/* harmony import */ var _controls_standard_checkbox_standard_checkbox_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./controls/standard-checkbox/standard-checkbox.component */ "../livecharts/src/lib/editor/basic-editor/controls/standard-checkbox/standard-checkbox.component.ts");
/* harmony import */ var _controls_standard_select_standard_select_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./controls/standard-select/standard-select.component */ "../livecharts/src/lib/editor/basic-editor/controls/standard-select/standard-select.component.ts");
/* harmony import */ var _controls_standard_textarea_standard_textarea_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./controls/standard-textarea/standard-textarea.component */ "../livecharts/src/lib/editor/basic-editor/controls/standard-textarea/standard-textarea.component.ts");
/* harmony import */ var _controls_standard_photo_standard_photo_component__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./controls/standard-photo/standard-photo.component */ "../livecharts/src/lib/editor/basic-editor/controls/standard-photo/standard-photo.component.ts");
/* harmony import */ var _controls_standard_slide_standard_slide_component__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./controls/standard-slide/standard-slide.component */ "../livecharts/src/lib/editor/basic-editor/controls/standard-slide/standard-slide.component.ts");
/* harmony import */ var _controls_standard_slider_standard_slider_component__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./controls/standard-slider/standard-slider.component */ "../livecharts/src/lib/editor/basic-editor/controls/standard-slider/standard-slider.component.ts");
/* harmony import */ var _playback_playback_component__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./playback/playback.component */ "../livecharts/src/lib/editor/basic-editor/playback/playback.component.ts");
/* harmony import */ var _scrub_scrub_component__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./scrub/scrub.component */ "../livecharts/src/lib/editor/basic-editor/scrub/scrub.component.ts");
/* harmony import */ var _timer_timer_component__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./timer/timer.component */ "../livecharts/src/lib/editor/basic-editor/timer/timer.component.ts");
/* harmony import */ var _settings_settings_component__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./settings/settings.component */ "../livecharts/src/lib/editor/basic-editor/settings/settings.component.ts");
/* harmony import */ var _settings_frame_rate_frame_rate_component__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./settings/frame-rate/frame-rate.component */ "../livecharts/src/lib/editor/basic-editor/settings/frame-rate/frame-rate.component.ts");
/* harmony import */ var _settings_scalable_scalable_component__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./settings/scalable/scalable.component */ "../livecharts/src/lib/editor/basic-editor/settings/scalable/scalable.component.ts");
/* harmony import */ var _settings_slices_slices_component__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./settings/slices/slices.component */ "../livecharts/src/lib/editor/basic-editor/settings/slices/slices.component.ts");
/* harmony import */ var _render_video_dialog_render_video_dialog_component__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./render-video-dialog/render-video-dialog.component */ "../livecharts/src/lib/editor/basic-editor/render-video-dialog/render-video-dialog.component.ts");






// Service

// Components




// Controls
















let BasicEditorModule = class BasicEditorModule {
};
BasicEditorModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [
            _basic_editor_component__WEBPACK_IMPORTED_MODULE_6__["BasicEditorComponent"],
            _controls_controls_component__WEBPACK_IMPORTED_MODULE_7__["ControlsComponent"],
            _controls_control_group_control_group_component__WEBPACK_IMPORTED_MODULE_8__["ControlGroupComponent"],
            _controls_control_wrapper_control_wrapper_component__WEBPACK_IMPORTED_MODULE_9__["ControlWrapperComponent"],
            _controls_standard_control_standard_control_component__WEBPACK_IMPORTED_MODULE_10__["StandardControlComponent"],
            _controls_standard_number_standard_number_component__WEBPACK_IMPORTED_MODULE_11__["StandardNumberComponent"],
            _controls_standard_checkbox_standard_checkbox_component__WEBPACK_IMPORTED_MODULE_12__["StandardCheckboxComponent"],
            _controls_standard_select_standard_select_component__WEBPACK_IMPORTED_MODULE_13__["StandardSelectComponent"],
            _controls_standard_textarea_standard_textarea_component__WEBPACK_IMPORTED_MODULE_14__["StandardTextareaComponent"],
            _controls_standard_photo_standard_photo_component__WEBPACK_IMPORTED_MODULE_15__["StandardPhotoComponent"],
            _controls_standard_slide_standard_slide_component__WEBPACK_IMPORTED_MODULE_16__["StandardSlideComponent"],
            _controls_standard_slider_standard_slider_component__WEBPACK_IMPORTED_MODULE_17__["StandardSliderComponent"],
            _playback_playback_component__WEBPACK_IMPORTED_MODULE_18__["PlaybackComponent"],
            _scrub_scrub_component__WEBPACK_IMPORTED_MODULE_19__["ScrubComponent"],
            _timer_timer_component__WEBPACK_IMPORTED_MODULE_20__["TimerComponent"],
            _settings_settings_component__WEBPACK_IMPORTED_MODULE_21__["SettingsComponent"],
            _settings_frame_rate_frame_rate_component__WEBPACK_IMPORTED_MODULE_22__["FrameRateComponent"],
            _settings_scalable_scalable_component__WEBPACK_IMPORTED_MODULE_23__["ScalableComponent"],
            _settings_slices_slices_component__WEBPACK_IMPORTED_MODULE_24__["SlicesComponent"],
            _render_video_dialog_render_video_dialog_component__WEBPACK_IMPORTED_MODULE_25__["RenderVideoDialogComponent"],
        ],
        entryComponents: [
            _controls_standard_control_standard_control_component__WEBPACK_IMPORTED_MODULE_10__["StandardControlComponent"],
            _controls_standard_number_standard_number_component__WEBPACK_IMPORTED_MODULE_11__["StandardNumberComponent"],
            _controls_standard_checkbox_standard_checkbox_component__WEBPACK_IMPORTED_MODULE_12__["StandardCheckboxComponent"],
            _controls_standard_select_standard_select_component__WEBPACK_IMPORTED_MODULE_13__["StandardSelectComponent"],
            _controls_standard_textarea_standard_textarea_component__WEBPACK_IMPORTED_MODULE_14__["StandardTextareaComponent"],
            _controls_standard_photo_standard_photo_component__WEBPACK_IMPORTED_MODULE_15__["StandardPhotoComponent"],
            _controls_standard_slide_standard_slide_component__WEBPACK_IMPORTED_MODULE_16__["StandardSlideComponent"],
            _controls_standard_slider_standard_slider_component__WEBPACK_IMPORTED_MODULE_17__["StandardSliderComponent"],
            _render_video_dialog_render_video_dialog_component__WEBPACK_IMPORTED_MODULE_25__["RenderVideoDialogComponent"],
        ],
        imports: [_angular_platform_browser__WEBPACK_IMPORTED_MODULE_2__["BrowserModule"], _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormsModule"], _angular_forms__WEBPACK_IMPORTED_MODULE_3__["ReactiveFormsModule"], _material_material_module__WEBPACK_IMPORTED_MODULE_4__["MaterialModule"]],
        exports: [_basic_editor_component__WEBPACK_IMPORTED_MODULE_6__["BasicEditorComponent"]],
        providers: [_controls_controls_service__WEBPACK_IMPORTED_MODULE_5__["ControlsService"]],
    })
], BasicEditorModule);



/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/controls/base/control.component.ts":
/*!************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/controls/base/control.component.ts ***!
  \************************************************************************************/
/*! exports provided: ControlComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ControlComponent", function() { return ControlComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "../../node_modules/@angular/forms/fesm2015/forms.js");




// Base class for all other controls
// Sets up wiring with LivechartsService
class ControlComponent {
    constructor(livechartsService) {
        this.livechartsService = livechartsService;
        this.form = new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"]();
    }
    ngOnInit() {
        // Create and set validations on formControl
        this.setValidations();
        // Initialize control with default value
        this.setDefault();
        this.description = this.settings['description'];
        this.formValueSubscription = this.form.valueChanges.subscribe(value => {
            this.formValueChanged();
        });
        // Subscribe to observable that tells the control to reset to the default value
        this.resetParameterSubscription = this.livechartsService.resetParameterObservable.subscribe(() => {
            this.reset();
        });
        // Subscribe to the observable that emits saved data when it needs to be loaded
        this.setParameterSubscription = this.livechartsService.setParameterObservable.subscribe(parameterObject => {
            this.setNewValue(parameterObject);
        });
    }
    ngOnDestroy() {
        this.formValueSubscription.unsubscribe();
        this.resetParameterSubscription.unsubscribe();
        this.setParameterSubscription.unsubscribe();
    }
    setDefault() {
        // Overwrite this message when the form does
        // not actually get the value assigned to it (i.e. select)
        this.form.setValue(this.settings['default']);
    }
    reset() {
        this.setDefault();
        this.pushNewValue();
    }
    getValue() {
        // Overwrite this method if the value cannot just be
        // taken from the form (like in a select for example)
        return this.form.value;
    }
    formValueChanged() {
        if (this.form.valid) {
            this.errorMessage = null;
            this.pushNewValue();
        }
        else {
            // console.log(this.form.errors);
            this.errorMessages = this.getErrorMessages(this.form.errors);
            this.errorMessage = this.errorMessages[0];
        }
    }
    getErrorMessages(errorObject) {
        let messages = [];
        let keys = Object.keys(errorObject);
        for (let key of keys) {
            let msg = this.getErrorMessage(key);
            messages.push(msg);
        }
        return messages;
    }
    getErrorMessage(key) {
        let message;
        switch (key) {
            case 'required':
                message = `Required`;
                break;
            case 'min':
                message = `Minimum value is ${this.settings['min']}`;
                break;
            case 'max':
                message = `Maximum value is ${this.settings['max']}`;
                break;
            default:
                throw new Error(`No error message for key: ${key}`);
                break;
        }
        return message;
    }
    setOutputData(event) {
        let value = this.getValue();
        let param = {
            id: this.id,
            value,
        };
        this.livechartsService.pushParameter(param);
    }
    pushNewValue() {
        // Push new value to LivechartService
        let value = this.getValue();
        let parameter = {
            id: this.id,
            value,
        };
        this.livechartsService.pushParameter(parameter);
    }
    setNewValue(parameterObject) {
        // TODO: at some higher level check to see that the saved data is compatible
        // with the current version of the animation and show an error if it isn't
        let value = parameterObject[this.id];
        if (value) {
            this.form.setValue(value);
        }
        else {
            let errorMessage = `Could not find id ${this.id} in parameterObject ${parameterObject}`;
            throw new Error(errorMessage);
        }
    }
    setValidations() {
        let validators = [];
        if (this.settings['required'] === true) {
            let v = _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required;
            validators.push(v);
        }
        if (this.settings['min'] !== undefined) {
            let v = _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].min(this.settings['min']);
            validators.push(v);
        }
        if (this.settings['max'] !== undefined) {
            let v = _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].max(this.settings['max']);
            validators.push(v);
        }
        // console.log(validators);
        this.form.setValidators(validators);
    }
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ControlComponent.prototype, "id", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ControlComponent.prototype, "control", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ControlComponent.prototype, "settings", void 0);


/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/controls/control-group/control-group.component.scss":
/*!*****************************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/controls/control-group/control-group.component.scss ***!
  \*****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".basic-editor-control-group {\n  margin: 10px;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInByb2plY3RzL2xpdmVjaGFydHMvc3JjL2xpYi9lZGl0b3IvYmFzaWMtZWRpdG9yL2NvbnRyb2xzL2NvbnRyb2wtZ3JvdXAvQzpcXFdlYnN0b3JtUHJvamVjdHNcXGxpdmVjaGFydHNEb2dmaWdodC9wcm9qZWN0c1xcbGl2ZWNoYXJ0c1xcc3JjXFxsaWJcXGVkaXRvclxcYmFzaWMtZWRpdG9yXFxjb250cm9sc1xcY29udHJvbC1ncm91cFxcY29udHJvbC1ncm91cC5jb21wb25lbnQuc2NzcyIsInByb2plY3RzL2xpdmVjaGFydHMvc3JjL2xpYi9lZGl0b3IvYmFzaWMtZWRpdG9yL2NvbnRyb2xzL2NvbnRyb2wtZ3JvdXAvY29udHJvbC1ncm91cC5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLFlBQUE7QUNDRiIsImZpbGUiOiJwcm9qZWN0cy9saXZlY2hhcnRzL3NyYy9saWIvZWRpdG9yL2Jhc2ljLWVkaXRvci9jb250cm9scy9jb250cm9sLWdyb3VwL2NvbnRyb2wtZ3JvdXAuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuYmFzaWMtZWRpdG9yLWNvbnRyb2wtZ3JvdXAge1xyXG4gIG1hcmdpbjogMTBweDtcclxufVxyXG4iLCIuYmFzaWMtZWRpdG9yLWNvbnRyb2wtZ3JvdXAge1xuICBtYXJnaW46IDEwcHg7XG59Il19 */");

/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/controls/control-group/control-group.component.ts":
/*!***************************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/controls/control-group/control-group.component.ts ***!
  \***************************************************************************************************/
/*! exports provided: ControlGroupComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ControlGroupComponent", function() { return ControlGroupComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");


// import { ControlsService } from '../controls.service';
// Wraps a group of controls
let ControlGroupComponent = class ControlGroupComponent {
    // constructor(private controlsService: ControlsService) {}
    ngOnInit() {
        // console.log(this.group);
        // console.log(this.controls);
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ControlGroupComponent.prototype, "group", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ControlGroupComponent.prototype, "controls", void 0);
ControlGroupComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'lib-control-group',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./control-group.component.html */ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/control-group/control-group.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./control-group.component.scss */ "../livecharts/src/lib/editor/basic-editor/controls/control-group/control-group.component.scss")).default]
    })
], ControlGroupComponent);



/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/controls/control-wrapper/control-wrapper.component.scss":
/*!*********************************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/controls/control-wrapper/control-wrapper.component.scss ***!
  \*********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".control-wrapper-error-message {\n  color: red;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInByb2plY3RzL2xpdmVjaGFydHMvc3JjL2xpYi9lZGl0b3IvYmFzaWMtZWRpdG9yL2NvbnRyb2xzL2NvbnRyb2wtd3JhcHBlci9DOlxcV2Vic3Rvcm1Qcm9qZWN0c1xcbGl2ZWNoYXJ0c0RvZ2ZpZ2h0L3Byb2plY3RzXFxsaXZlY2hhcnRzXFxzcmNcXGxpYlxcZWRpdG9yXFxiYXNpYy1lZGl0b3JcXGNvbnRyb2xzXFxjb250cm9sLXdyYXBwZXJcXGNvbnRyb2wtd3JhcHBlci5jb21wb25lbnQuc2NzcyIsInByb2plY3RzL2xpdmVjaGFydHMvc3JjL2xpYi9lZGl0b3IvYmFzaWMtZWRpdG9yL2NvbnRyb2xzL2NvbnRyb2wtd3JhcHBlci9jb250cm9sLXdyYXBwZXIuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxVQUFBO0FDQ0YiLCJmaWxlIjoicHJvamVjdHMvbGl2ZWNoYXJ0cy9zcmMvbGliL2VkaXRvci9iYXNpYy1lZGl0b3IvY29udHJvbHMvY29udHJvbC13cmFwcGVyL2NvbnRyb2wtd3JhcHBlci5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5jb250cm9sLXdyYXBwZXItZXJyb3ItbWVzc2FnZSB7XHJcbiAgY29sb3I6IHJlZDtcclxufVxyXG4iLCIuY29udHJvbC13cmFwcGVyLWVycm9yLW1lc3NhZ2Uge1xuICBjb2xvcjogcmVkO1xufSJdfQ== */");

/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/controls/control-wrapper/control-wrapper.component.ts":
/*!*******************************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/controls/control-wrapper/control-wrapper.component.ts ***!
  \*******************************************************************************************************/
/*! exports provided: ControlWrapperComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ControlWrapperComponent", function() { return ControlWrapperComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _controls_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../controls.service */ "../livecharts/src/lib/editor/basic-editor/controls/controls.service.ts");



// Wraps an individual control, receives the key and the settings
// for a control, looks it up, instantiates it and renders the control
let ControlWrapperComponent = class ControlWrapperComponent {
    constructor(controlsService, changeDetectorRef, componentFactoryResolver) {
        this.controlsService = controlsService;
        this.changeDetectorRef = changeDetectorRef;
        this.componentFactoryResolver = componentFactoryResolver;
    }
    ngOnInit() {
        this.control = this.controlsService.getControlByType(this.settings['control']);
        if (!this.control) {
            this.errorMessage = `Could not find control for control type: ${this.settings['control']} for control with id: ${this.id}`;
            // throw new Error(
            //   `Could not find control for key: ${this.settings['control']}`,
            // );
        }
        else {
            this.errorMessage = null;
        }
    }
    ngAfterViewInit() {
        if (this.control) {
            let componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.control['component']);
            this.viewContainerRef.clear();
            this.componentRef = this.viewContainerRef.createComponent(componentFactory);
            this.instance = this.componentRef.instance;
            this.instance.settings = this.settings;
            this.instance.id = this.id;
            this.instance.control = this.settings['control'];
            this.changeDetectorRef.detectChanges();
        }
    }
    ngOnDestroy() {
        this.changeDetectorRef.detach();
    }
};
ControlWrapperComponent.ctorParameters = () => [
    { type: _controls_service__WEBPACK_IMPORTED_MODULE_2__["ControlsService"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectorRef"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ComponentFactoryResolver"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ControlWrapperComponent.prototype, "id", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ControlWrapperComponent.prototype, "settings", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('anchor', { read: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewContainerRef"], static: false })
], ControlWrapperComponent.prototype, "viewContainerRef", void 0);
ControlWrapperComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'lib-control-wrapper',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./control-wrapper.component.html */ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/control-wrapper/control-wrapper.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./control-wrapper.component.scss */ "../livecharts/src/lib/editor/basic-editor/controls/control-wrapper/control-wrapper.component.scss")).default]
    })
], ControlWrapperComponent);



/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/controls/controls.component.scss":
/*!**********************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/controls/controls.component.scss ***!
  \**********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJwcm9qZWN0cy9saXZlY2hhcnRzL3NyYy9saWIvZWRpdG9yL2Jhc2ljLWVkaXRvci9jb250cm9scy9jb250cm9scy5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/controls/controls.component.ts":
/*!********************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/controls/controls.component.ts ***!
  \********************************************************************************/
/*! exports provided: ControlsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ControlsComponent", function() { return ControlsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _livecharts_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../livecharts.service */ "../livecharts/src/lib/livecharts.service.ts");



// Top-level component for the controls
// Creates a tab for parameters, timings and data
let ControlsComponent = class ControlsComponent {
    constructor(livechartsService) {
        this.livechartsService = livechartsService;
    }
    ngOnInit() { }
    set params(params) {
        this.parameters = params;
        console.log(this.parameters);
        if (this.parameters) {
            this.parameterGroups = this.parameters['parameterGroups'];
            this.timingGroups = this.parameters['timingGroups'];
            this.data = this.parameters['data'];
        }
    }
};
ControlsComponent.ctorParameters = () => [
    { type: _livecharts_service__WEBPACK_IMPORTED_MODULE_2__["LivechartsService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ControlsComponent.prototype, "params", null);
ControlsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'lib-controls',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./controls.component.html */ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/controls.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./controls.component.scss */ "../livecharts/src/lib/editor/basic-editor/controls/controls.component.scss")).default]
    })
], ControlsComponent);



/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/controls/controls.service.ts":
/*!******************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/controls/controls.service.ts ***!
  \******************************************************************************/
/*! exports provided: ControlsService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ControlsService", function() { return ControlsService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _controls__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./controls */ "../livecharts/src/lib/editor/basic-editor/controls/controls.ts");



let ControlsService = class ControlsService {
    constructor() {
        this.controls = _controls__WEBPACK_IMPORTED_MODULE_2__["controls"];
    }
    getControlByType(id) {
        let control = this.controls.find(obj => obj['id'] === id);
        return control;
    }
};
ControlsService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root',
    })
], ControlsService);



/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/controls/controls.ts":
/*!**********************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/controls/controls.ts ***!
  \**********************************************************************/
/*! exports provided: controls */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "controls", function() { return controls; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _standard_control_standard_control_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./standard-control/standard-control.component */ "../livecharts/src/lib/editor/basic-editor/controls/standard-control/standard-control.component.ts");
/* harmony import */ var _standard_number_standard_number_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./standard-number/standard-number.component */ "../livecharts/src/lib/editor/basic-editor/controls/standard-number/standard-number.component.ts");
/* harmony import */ var _standard_checkbox_standard_checkbox_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./standard-checkbox/standard-checkbox.component */ "../livecharts/src/lib/editor/basic-editor/controls/standard-checkbox/standard-checkbox.component.ts");
/* harmony import */ var _standard_select_standard_select_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./standard-select/standard-select.component */ "../livecharts/src/lib/editor/basic-editor/controls/standard-select/standard-select.component.ts");
/* harmony import */ var _standard_textarea_standard_textarea_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./standard-textarea/standard-textarea.component */ "../livecharts/src/lib/editor/basic-editor/controls/standard-textarea/standard-textarea.component.ts");
/* harmony import */ var _standard_photo_standard_photo_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./standard-photo/standard-photo.component */ "../livecharts/src/lib/editor/basic-editor/controls/standard-photo/standard-photo.component.ts");
/* harmony import */ var _standard_slide_standard_slide_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./standard-slide/standard-slide.component */ "../livecharts/src/lib/editor/basic-editor/controls/standard-slide/standard-slide.component.ts");
/* harmony import */ var _standard_slider_standard_slider_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./standard-slider/standard-slider.component */ "../livecharts/src/lib/editor/basic-editor/controls/standard-slider/standard-slider.component.ts");









let controls = [
    {
        name: 'Standard control',
        id: 'standard-control',
        component: _standard_control_standard_control_component__WEBPACK_IMPORTED_MODULE_1__["StandardControlComponent"],
    },
    {
        name: 'Standard number',
        id: 'standard-number',
        component: _standard_number_standard_number_component__WEBPACK_IMPORTED_MODULE_2__["StandardNumberComponent"],
    },
    {
        name: 'Standard checkbox',
        id: 'standard-checkbox',
        component: _standard_checkbox_standard_checkbox_component__WEBPACK_IMPORTED_MODULE_3__["StandardCheckboxComponent"],
    },
    {
        name: 'Standard select',
        id: 'standard-select',
        component: _standard_select_standard_select_component__WEBPACK_IMPORTED_MODULE_4__["StandardSelectComponent"],
    },
    {
        name: 'Standard textarea',
        id: 'standard-textarea',
        component: _standard_textarea_standard_textarea_component__WEBPACK_IMPORTED_MODULE_5__["StandardTextareaComponent"],
    },
    {
        name: 'Standard photo',
        id: 'standard-photo',
        component: _standard_photo_standard_photo_component__WEBPACK_IMPORTED_MODULE_6__["StandardPhotoComponent"],
    },
    {
        name: 'Standard slide',
        id: 'standard-slide',
        component: _standard_slide_standard_slide_component__WEBPACK_IMPORTED_MODULE_7__["StandardSlideComponent"],
    },
    {
        name: 'Standard slider',
        id: 'standard-slider',
        component: _standard_slider_standard_slider_component__WEBPACK_IMPORTED_MODULE_8__["StandardSliderComponent"],
    },
];


/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/controls/standard-checkbox/standard-checkbox.component.scss":
/*!*************************************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/controls/standard-checkbox/standard-checkbox.component.scss ***!
  \*************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJwcm9qZWN0cy9saXZlY2hhcnRzL3NyYy9saWIvZWRpdG9yL2Jhc2ljLWVkaXRvci9jb250cm9scy9zdGFuZGFyZC1jaGVja2JveC9zdGFuZGFyZC1jaGVja2JveC5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/controls/standard-checkbox/standard-checkbox.component.ts":
/*!***********************************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/controls/standard-checkbox/standard-checkbox.component.ts ***!
  \***********************************************************************************************************/
/*! exports provided: StandardCheckboxComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StandardCheckboxComponent", function() { return StandardCheckboxComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _base_control_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../base/control.component */ "../livecharts/src/lib/editor/basic-editor/controls/base/control.component.ts");
/* harmony import */ var _livecharts_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../livecharts.service */ "../livecharts/src/lib/livecharts.service.ts");




let StandardCheckboxComponent = class StandardCheckboxComponent extends _base_control_component__WEBPACK_IMPORTED_MODULE_2__["ControlComponent"] {
    constructor(livechartsService) {
        super(livechartsService);
        this.livechartsService = livechartsService;
    }
};
StandardCheckboxComponent.ctorParameters = () => [
    { type: _livecharts_service__WEBPACK_IMPORTED_MODULE_3__["LivechartsService"] }
];
StandardCheckboxComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'lib-standard-checkbox',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./standard-checkbox.component.html */ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/standard-checkbox/standard-checkbox.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./standard-checkbox.component.scss */ "../livecharts/src/lib/editor/basic-editor/controls/standard-checkbox/standard-checkbox.component.scss")).default]
    })
], StandardCheckboxComponent);



/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/controls/standard-control/standard-control.component.scss":
/*!***********************************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/controls/standard-control/standard-control.component.scss ***!
  \***********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJwcm9qZWN0cy9saXZlY2hhcnRzL3NyYy9saWIvZWRpdG9yL2Jhc2ljLWVkaXRvci9jb250cm9scy9zdGFuZGFyZC1jb250cm9sL3N0YW5kYXJkLWNvbnRyb2wuY29tcG9uZW50LnNjc3MifQ== */");

/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/controls/standard-control/standard-control.component.ts":
/*!*********************************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/controls/standard-control/standard-control.component.ts ***!
  \*********************************************************************************************************/
/*! exports provided: StandardControlComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StandardControlComponent", function() { return StandardControlComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _base_control_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../base/control.component */ "../livecharts/src/lib/editor/basic-editor/controls/base/control.component.ts");
/* harmony import */ var _livecharts_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../livecharts.service */ "../livecharts/src/lib/livecharts.service.ts");




let StandardControlComponent = class StandardControlComponent extends _base_control_component__WEBPACK_IMPORTED_MODULE_2__["ControlComponent"] {
    constructor(livechartsService) {
        super(livechartsService);
        this.livechartsService = livechartsService;
    }
};
StandardControlComponent.ctorParameters = () => [
    { type: _livecharts_service__WEBPACK_IMPORTED_MODULE_3__["LivechartsService"] }
];
StandardControlComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'lib-standard-control',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./standard-control.component.html */ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/standard-control/standard-control.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./standard-control.component.scss */ "../livecharts/src/lib/editor/basic-editor/controls/standard-control/standard-control.component.scss")).default]
    })
], StandardControlComponent);



/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/controls/standard-number/standard-number.component.scss":
/*!*********************************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/controls/standard-number/standard-number.component.scss ***!
  \*********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJwcm9qZWN0cy9saXZlY2hhcnRzL3NyYy9saWIvZWRpdG9yL2Jhc2ljLWVkaXRvci9jb250cm9scy9zdGFuZGFyZC1udW1iZXIvc3RhbmRhcmQtbnVtYmVyLmNvbXBvbmVudC5zY3NzIn0= */");

/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/controls/standard-number/standard-number.component.ts":
/*!*******************************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/controls/standard-number/standard-number.component.ts ***!
  \*******************************************************************************************************/
/*! exports provided: StandardNumberComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StandardNumberComponent", function() { return StandardNumberComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _base_control_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../base/control.component */ "../livecharts/src/lib/editor/basic-editor/controls/base/control.component.ts");
/* harmony import */ var _livecharts_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../livecharts.service */ "../livecharts/src/lib/livecharts.service.ts");




let StandardNumberComponent = class StandardNumberComponent extends _base_control_component__WEBPACK_IMPORTED_MODULE_2__["ControlComponent"] {
    constructor(livechartsService) {
        super(livechartsService);
        this.livechartsService = livechartsService;
    }
};
StandardNumberComponent.ctorParameters = () => [
    { type: _livecharts_service__WEBPACK_IMPORTED_MODULE_3__["LivechartsService"] }
];
StandardNumberComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'lib-standard-number',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./standard-number.component.html */ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/standard-number/standard-number.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./standard-number.component.scss */ "../livecharts/src/lib/editor/basic-editor/controls/standard-number/standard-number.component.scss")).default]
    })
], StandardNumberComponent);



/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/controls/standard-photo/standard-photo.component.scss":
/*!*******************************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/controls/standard-photo/standard-photo.component.scss ***!
  \*******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".dropzone {\n  height: 70px;\n  background-color: #CACACA;\n  border: 1px solid #666;\n  border-style: dashed;\n  border-width: 4px;\n  padding: 20px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  clear: left;\n}\n\n.dropzoneErrors {\n  color: red;\n}\n\n.photo {\n  clear: left;\n}\n\n.photo p.photo-name {\n  float: left;\n  width: 55%;\n}\n\n.photo p.photo-control {\n  float: left;\n  width: 10%;\n  text-align: right;\n}\n\n.photo span {\n  cursor: pointer;\n}\n\n.photo span.disabled {\n  color: #CACACA;\n  cursor: default;\n}\n\n.photo img {\n  float: left;\n  margin-right: 5%;\n  margin-bottom: 3px;\n  width: 30%;\n}\n\n.photo-control-x {\n  margin-left: 5px;\n}\n\n.photo-control {\n  cursor: pointer;\n  text-decoration: underline;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/controls/standard-photo/standard-photo.component.ts":
/*!*****************************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/controls/standard-photo/standard-photo.component.ts ***!
  \*****************************************************************************************************/
/*! exports provided: StandardPhotoComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StandardPhotoComponent", function() { return StandardPhotoComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _base_control_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../base/control.component */ "../livecharts/src/lib/editor/basic-editor/controls/base/control.component.ts");
/* harmony import */ var _livecharts_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../livecharts.service */ "../livecharts/src/lib/livecharts.service.ts");




let StandardPhotoComponent = class StandardPhotoComponent extends _base_control_component__WEBPACK_IMPORTED_MODULE_2__["ControlComponent"] {
    constructor(livechartsService) {
        super(livechartsService);
        this.livechartsService = livechartsService;
    }
    getValue() {
        let value = this.photo ? this.photo['url'] : null;
        return value;
    }
    dropHandler(event) {
        event.preventDefault();
        this.eventHandler = event.dataTransfer;
        let file = this.eventHandler.files[0];
        this.setupReader(file);
    }
    readerLoaded(event, file, obj) {
        obj['url'] = event.target.result;
        this.photo = obj;
        this.doneReading();
    }
    setupReader(file) {
        if (file.type.match('image/jpeg') || file.type.match('image/png')) {
            let obj = {
                name: file.name,
                type: file.type,
            };
            let reader = new FileReader();
            reader.onload = (event) => {
                this.readerLoaded(event, file, obj);
            };
            reader.readAsDataURL(file);
        }
        else {
            console.log('ELSE'); // ToDo error handeling
        }
    }
    doneReading() {
        // console.log(this.photo);
        this.setOutputData(this.photo);
    }
    dragOverHandler(event) {
        event.stopPropagation();
        event.preventDefault();
    }
    remove(event) {
        this.eventHandler.clearData();
        // this.setOutputData();
        this.photo = null;
        this.reset();
    }
    clear() {
        this.reset();
        this.setOutputData();
    }
};
StandardPhotoComponent.ctorParameters = () => [
    { type: _livecharts_service__WEBPACK_IMPORTED_MODULE_3__["LivechartsService"] }
];
StandardPhotoComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'lib-standard-photo',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./standard-photo.component.html */ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/standard-photo/standard-photo.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./standard-photo.component.scss */ "../livecharts/src/lib/editor/basic-editor/controls/standard-photo/standard-photo.component.scss")).default]
    })
], StandardPhotoComponent);



/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/controls/standard-select/standard-select.component.scss":
/*!*********************************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/controls/standard-select/standard-select.component.scss ***!
  \*********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJwcm9qZWN0cy9saXZlY2hhcnRzL3NyYy9saWIvZWRpdG9yL2Jhc2ljLWVkaXRvci9jb250cm9scy9zdGFuZGFyZC1zZWxlY3Qvc3RhbmRhcmQtc2VsZWN0LmNvbXBvbmVudC5zY3NzIn0= */");

/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/controls/standard-select/standard-select.component.ts":
/*!*******************************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/controls/standard-select/standard-select.component.ts ***!
  \*******************************************************************************************************/
/*! exports provided: StandardSelectComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StandardSelectComponent", function() { return StandardSelectComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _base_control_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../base/control.component */ "../livecharts/src/lib/editor/basic-editor/controls/base/control.component.ts");
/* harmony import */ var _livecharts_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../livecharts.service */ "../livecharts/src/lib/livecharts.service.ts");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lodash */ "../../node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);





let StandardSelectComponent = class StandardSelectComponent extends _base_control_component__WEBPACK_IMPORTED_MODULE_2__["ControlComponent"] {
    constructor(livechartsService) {
        super(livechartsService);
        this.livechartsService = livechartsService;
    }
    getValue() {
        let index = this.form.value;
        let value = this.settings.values[index]['value'];
        return value;
    }
    setDefault() {
        let index = this.settings.values.findIndex(element => lodash__WEBPACK_IMPORTED_MODULE_4__["isEqual"](element.value, this.settings['default']));
        if (index < 0) {
            throw new Error(`Value ${this.settings['default']} not found for parameter ${this.id}`);
        }
        this.form.setValue(index);
    }
};
StandardSelectComponent.ctorParameters = () => [
    { type: _livecharts_service__WEBPACK_IMPORTED_MODULE_3__["LivechartsService"] }
];
StandardSelectComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'lib-standard-select',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./standard-select.component.html */ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/standard-select/standard-select.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./standard-select.component.scss */ "../livecharts/src/lib/editor/basic-editor/controls/standard-select/standard-select.component.scss")).default]
    })
], StandardSelectComponent);



/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/controls/standard-slide/standard-slide.component.scss":
/*!*******************************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/controls/standard-slide/standard-slide.component.scss ***!
  \*******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJwcm9qZWN0cy9saXZlY2hhcnRzL3NyYy9saWIvZWRpdG9yL2Jhc2ljLWVkaXRvci9jb250cm9scy9zdGFuZGFyZC1zbGlkZS9zdGFuZGFyZC1zbGlkZS5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/controls/standard-slide/standard-slide.component.ts":
/*!*****************************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/controls/standard-slide/standard-slide.component.ts ***!
  \*****************************************************************************************************/
/*! exports provided: StandardSlideComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StandardSlideComponent", function() { return StandardSlideComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _base_control_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../base/control.component */ "../livecharts/src/lib/editor/basic-editor/controls/base/control.component.ts");
/* harmony import */ var _livecharts_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../livecharts.service */ "../livecharts/src/lib/livecharts.service.ts");




let StandardSlideComponent = class StandardSlideComponent extends _base_control_component__WEBPACK_IMPORTED_MODULE_2__["ControlComponent"] {
    constructor(livechartsService) {
        super(livechartsService);
        this.livechartsService = livechartsService;
    }
};
StandardSlideComponent.ctorParameters = () => [
    { type: _livecharts_service__WEBPACK_IMPORTED_MODULE_3__["LivechartsService"] }
];
StandardSlideComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'lib-standard-slide',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./standard-slide.component.html */ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/standard-slide/standard-slide.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./standard-slide.component.scss */ "../livecharts/src/lib/editor/basic-editor/controls/standard-slide/standard-slide.component.scss")).default]
    })
], StandardSlideComponent);



/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/controls/standard-slider/standard-slider.component.scss":
/*!*********************************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/controls/standard-slider/standard-slider.component.scss ***!
  \*********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("div {\n  display: flex;\n  align-items: center;\n}\n\nspan {\n  flex-basis: content;\n  padding-right: 5px;\n}\n\nmat-slider {\n  flex-grow: 1;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInByb2plY3RzL2xpdmVjaGFydHMvc3JjL2xpYi9lZGl0b3IvYmFzaWMtZWRpdG9yL2NvbnRyb2xzL3N0YW5kYXJkLXNsaWRlci9DOlxcV2Vic3Rvcm1Qcm9qZWN0c1xcbGl2ZWNoYXJ0c0RvZ2ZpZ2h0L3Byb2plY3RzXFxsaXZlY2hhcnRzXFxzcmNcXGxpYlxcZWRpdG9yXFxiYXNpYy1lZGl0b3JcXGNvbnRyb2xzXFxzdGFuZGFyZC1zbGlkZXJcXHN0YW5kYXJkLXNsaWRlci5jb21wb25lbnQuc2NzcyIsInByb2plY3RzL2xpdmVjaGFydHMvc3JjL2xpYi9lZGl0b3IvYmFzaWMtZWRpdG9yL2NvbnRyb2xzL3N0YW5kYXJkLXNsaWRlci9zdGFuZGFyZC1zbGlkZXIuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxhQUFBO0VBQ0EsbUJBQUE7QUNDRjs7QURFQTtFQUNFLG1CQUFBO0VBQ0Esa0JBQUE7QUNDRjs7QURFQTtFQUNFLFlBQUE7QUNDRiIsImZpbGUiOiJwcm9qZWN0cy9saXZlY2hhcnRzL3NyYy9saWIvZWRpdG9yL2Jhc2ljLWVkaXRvci9jb250cm9scy9zdGFuZGFyZC1zbGlkZXIvc3RhbmRhcmQtc2xpZGVyLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiZGl2IHtcclxuICBkaXNwbGF5OiBmbGV4O1xyXG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7IC8vIFZlcnRpY2FsbHkgYWxpZ24gY29udGVudFxyXG59XHJcblxyXG5zcGFuIHtcclxuICBmbGV4LWJhc2lzOiBjb250ZW50OyAvLyBTaXplIGJhc2VkIG9uIGNvbnRlbnRcclxuICBwYWRkaW5nLXJpZ2h0OiA1cHg7IC8vIExlYXZlIHNvbWUgc3BhY2UgYmV0d2VlbiBsYWJlbCBhbmQgc2xpZGVyXHJcbn1cclxuXHJcbm1hdC1zbGlkZXIge1xyXG4gIGZsZXgtZ3JvdzogMTsgLy8gR3JvdyB0aGUgc2xpZGVyIG5vdCB0aGUgbGFiZWxcclxufVxyXG4iLCJkaXYge1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xufVxuXG5zcGFuIHtcbiAgZmxleC1iYXNpczogY29udGVudDtcbiAgcGFkZGluZy1yaWdodDogNXB4O1xufVxuXG5tYXQtc2xpZGVyIHtcbiAgZmxleC1ncm93OiAxO1xufSJdfQ== */");

/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/controls/standard-slider/standard-slider.component.ts":
/*!*******************************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/controls/standard-slider/standard-slider.component.ts ***!
  \*******************************************************************************************************/
/*! exports provided: StandardSliderComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StandardSliderComponent", function() { return StandardSliderComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _base_control_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../base/control.component */ "../livecharts/src/lib/editor/basic-editor/controls/base/control.component.ts");
/* harmony import */ var _livecharts_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../livecharts.service */ "../livecharts/src/lib/livecharts.service.ts");




let StandardSliderComponent = class StandardSliderComponent extends _base_control_component__WEBPACK_IMPORTED_MODULE_2__["ControlComponent"] {
    constructor(livechartsService) {
        super(livechartsService);
        this.livechartsService = livechartsService;
    }
};
StandardSliderComponent.ctorParameters = () => [
    { type: _livecharts_service__WEBPACK_IMPORTED_MODULE_3__["LivechartsService"] }
];
StandardSliderComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'lib-standard-slider',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./standard-slider.component.html */ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/standard-slider/standard-slider.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./standard-slider.component.scss */ "../livecharts/src/lib/editor/basic-editor/controls/standard-slider/standard-slider.component.scss")).default]
    })
], StandardSliderComponent);



/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/controls/standard-textarea/standard-textarea.component.scss":
/*!*************************************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/controls/standard-textarea/standard-textarea.component.scss ***!
  \*************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJwcm9qZWN0cy9saXZlY2hhcnRzL3NyYy9saWIvZWRpdG9yL2Jhc2ljLWVkaXRvci9jb250cm9scy9zdGFuZGFyZC10ZXh0YXJlYS9zdGFuZGFyZC10ZXh0YXJlYS5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/controls/standard-textarea/standard-textarea.component.ts":
/*!***********************************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/controls/standard-textarea/standard-textarea.component.ts ***!
  \***********************************************************************************************************/
/*! exports provided: StandardTextareaComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StandardTextareaComponent", function() { return StandardTextareaComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _base_control_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../base/control.component */ "../livecharts/src/lib/editor/basic-editor/controls/base/control.component.ts");
/* harmony import */ var _livecharts_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../livecharts.service */ "../livecharts/src/lib/livecharts.service.ts");




let StandardTextareaComponent = class StandardTextareaComponent extends _base_control_component__WEBPACK_IMPORTED_MODULE_2__["ControlComponent"] {
    constructor(livechartsService) {
        super(livechartsService);
        this.livechartsService = livechartsService;
    }
};
StandardTextareaComponent.ctorParameters = () => [
    { type: _livecharts_service__WEBPACK_IMPORTED_MODULE_3__["LivechartsService"] }
];
StandardTextareaComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'lib-standard-textarea',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./standard-textarea.component.html */ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/controls/standard-textarea/standard-textarea.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./standard-textarea.component.scss */ "../livecharts/src/lib/editor/basic-editor/controls/standard-textarea/standard-textarea.component.scss")).default]
    })
], StandardTextareaComponent);

console.log('hier');


/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/playback/playback.component.scss":
/*!**********************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/playback/playback.component.scss ***!
  \**********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("#playback-wrapper {\n  margin: 5px;\n  display: flex;\n  justify-content: space-between;\n}\n\n#playback-buttons button {\n  min-width: 72px;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInByb2plY3RzL2xpdmVjaGFydHMvc3JjL2xpYi9lZGl0b3IvYmFzaWMtZWRpdG9yL3BsYXliYWNrL0M6XFxXZWJzdG9ybVByb2plY3RzXFxsaXZlY2hhcnRzRG9nZmlnaHQvcHJvamVjdHNcXGxpdmVjaGFydHNcXHNyY1xcbGliXFxlZGl0b3JcXGJhc2ljLWVkaXRvclxccGxheWJhY2tcXHBsYXliYWNrLmNvbXBvbmVudC5zY3NzIiwicHJvamVjdHMvbGl2ZWNoYXJ0cy9zcmMvbGliL2VkaXRvci9iYXNpYy1lZGl0b3IvcGxheWJhY2svcGxheWJhY2suY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxXQUFBO0VBQ0EsYUFBQTtFQUNBLDhCQUFBO0FDQ0Y7O0FERUU7RUFDRSxlQUFBO0FDQ0oiLCJmaWxlIjoicHJvamVjdHMvbGl2ZWNoYXJ0cy9zcmMvbGliL2VkaXRvci9iYXNpYy1lZGl0b3IvcGxheWJhY2svcGxheWJhY2suY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIjcGxheWJhY2std3JhcHBlciB7XHJcbiAgbWFyZ2luOiA1cHg7XHJcbiAgZGlzcGxheTogZmxleDtcclxuICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XHJcbn1cclxuI3BsYXliYWNrLWJ1dHRvbnMge1xyXG4gIGJ1dHRvbiB7XHJcbiAgICBtaW4td2lkdGg6IDcycHg7XHJcbiAgfVxyXG59XHJcbiIsIiNwbGF5YmFjay13cmFwcGVyIHtcbiAgbWFyZ2luOiA1cHg7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2Vlbjtcbn1cblxuI3BsYXliYWNrLWJ1dHRvbnMgYnV0dG9uIHtcbiAgbWluLXdpZHRoOiA3MnB4O1xufSJdfQ== */");

/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/playback/playback.component.ts":
/*!********************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/playback/playback.component.ts ***!
  \********************************************************************************/
/*! exports provided: PlaybackComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PlaybackComponent", function() { return PlaybackComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _livecharts_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../livecharts.service */ "../livecharts/src/lib/livecharts.service.ts");



let PlaybackComponent = class PlaybackComponent {
    constructor(livechartsService) {
        this.livechartsService = livechartsService;
        this.render = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.playing$ = this.livechartsService.playingObservable;
    }
    ngOnInit() { }
    play() {
        this.livechartsService.setPlaybackCommand('play');
    }
    pause() {
        this.livechartsService.setPlaybackCommand('pause');
    }
    restart() {
        this.livechartsService.setPlaybackCommand('restart');
    }
    playPause() {
        this.livechartsService.setPlaybackCommand('toggle');
    }
    stopForStill(label) {
        this.livechartsService.setPlaybackCommand('pause');
        this.livechartsService.setTime(label.time);
    }
    renderOfType(type) {
        this.render.emit(type);
    }
    outputType(type) {
        return this.metadata['outputTypes'].find(t => t === type);
    }
};
PlaybackComponent.ctorParameters = () => [
    { type: _livecharts_service__WEBPACK_IMPORTED_MODULE_2__["LivechartsService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], PlaybackComponent.prototype, "labelsForStills", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], PlaybackComponent.prototype, "metadata", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], PlaybackComponent.prototype, "render", void 0);
PlaybackComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'lib-playback',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./playback.component.html */ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/playback/playback.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./playback.component.scss */ "../livecharts/src/lib/editor/basic-editor/playback/playback.component.scss")).default]
    })
], PlaybackComponent);



/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/render-video-dialog/render-video-dialog.component.scss":
/*!********************************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/render-video-dialog/render-video-dialog.component.scss ***!
  \********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".wrapper {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.left {\n  flex: 1;\n  padding: 5px;\n  margin-bottom: 5px;\n}\n\n.right {\n  padding: 5px;\n  margin-bottom: 5px;\n}\n\n.right button {\n  width: 80px;\n}\n\n.top {\n  margin-bottom: 10px;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInByb2plY3RzL2xpdmVjaGFydHMvc3JjL2xpYi9lZGl0b3IvYmFzaWMtZWRpdG9yL3JlbmRlci12aWRlby1kaWFsb2cvQzpcXFdlYnN0b3JtUHJvamVjdHNcXGxpdmVjaGFydHNEb2dmaWdodC9wcm9qZWN0c1xcbGl2ZWNoYXJ0c1xcc3JjXFxsaWJcXGVkaXRvclxcYmFzaWMtZWRpdG9yXFxyZW5kZXItdmlkZW8tZGlhbG9nXFxyZW5kZXItdmlkZW8tZGlhbG9nLmNvbXBvbmVudC5zY3NzIiwicHJvamVjdHMvbGl2ZWNoYXJ0cy9zcmMvbGliL2VkaXRvci9iYXNpYy1lZGl0b3IvcmVuZGVyLXZpZGVvLWRpYWxvZy9yZW5kZXItdmlkZW8tZGlhbG9nLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBO0VBQ0UsYUFBQTtFQUNBLG1CQUFBO0VBQ0EsZUFBQTtBQ0RGOztBRElBO0VBQ0UsT0FBQTtFQUNBLFlBVlE7RUFXUixrQkFBQTtBQ0RGOztBREdBO0VBQ0UsWUFkUTtFQWVSLGtCQUFBO0FDQUY7O0FEQ0U7RUFDRSxXQUFBO0FDQ0o7O0FER0E7RUFDRSxtQkFBQTtBQ0FGIiwiZmlsZSI6InByb2plY3RzL2xpdmVjaGFydHMvc3JjL2xpYi9lZGl0b3IvYmFzaWMtZWRpdG9yL3JlbmRlci12aWRlby1kaWFsb2cvcmVuZGVyLXZpZGVvLWRpYWxvZy5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIiRwYWRkaW5nOiA1cHg7XHJcblxyXG4ud3JhcHBlciB7XHJcbiAgZGlzcGxheTogZmxleDtcclxuICBhbGlnbi1pdGVtczogY2VudGVyO1xyXG4gIGZsZXgtd3JhcDogd3JhcDtcclxufVxyXG5cclxuLmxlZnQge1xyXG4gIGZsZXg6IDE7XHJcbiAgcGFkZGluZzogJHBhZGRpbmc7XHJcbiAgbWFyZ2luLWJvdHRvbTogNXB4O1xyXG59XHJcbi5yaWdodCB7XHJcbiAgcGFkZGluZzogJHBhZGRpbmc7XHJcbiAgbWFyZ2luLWJvdHRvbTogNXB4O1xyXG4gIGJ1dHRvbiB7XHJcbiAgICB3aWR0aDogODBweDtcclxuICB9XHJcbn1cclxuXHJcbi50b3Age1xyXG4gIG1hcmdpbi1ib3R0b206IDEwcHg7XHJcbn1cclxuXHJcbi8vIC5tc2cge1xyXG4vLyB9XHJcbiIsIi53cmFwcGVyIHtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgZmxleC13cmFwOiB3cmFwO1xufVxuXG4ubGVmdCB7XG4gIGZsZXg6IDE7XG4gIHBhZGRpbmc6IDVweDtcbiAgbWFyZ2luLWJvdHRvbTogNXB4O1xufVxuXG4ucmlnaHQge1xuICBwYWRkaW5nOiA1cHg7XG4gIG1hcmdpbi1ib3R0b206IDVweDtcbn1cbi5yaWdodCBidXR0b24ge1xuICB3aWR0aDogODBweDtcbn1cblxuLnRvcCB7XG4gIG1hcmdpbi1ib3R0b206IDEwcHg7XG59Il19 */");

/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/render-video-dialog/render-video-dialog.component.ts":
/*!******************************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/render-video-dialog/render-video-dialog.component.ts ***!
  \******************************************************************************************************/
/*! exports provided: RenderVideoDialogComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RenderVideoDialogComponent", function() { return RenderVideoDialogComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material */ "../../node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! file-saver */ "../../node_modules/file-saver/dist/FileSaver.min.js");
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(file_saver__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _services_render_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../services/render.service */ "../livecharts/src/lib/services/render.service.ts");
/* harmony import */ var _livecharts_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../livecharts.service */ "../livecharts/src/lib/livecharts.service.ts");






let RenderVideoDialogComponent = class RenderVideoDialogComponent {
    constructor(dialogRef, data, renderService, livechartsService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.renderService = renderService;
        this.livechartsService = livechartsService;
        this.rendering = false;
        this.aborted = false; // When user aborts
        this.errored = false; // When the server sends an error
        this.finished = false;
        this.instance = data.instance;
    }
    ngOnInit() {
        this.errorSubscription = this.renderService.errorObservable.subscribe(errorMessage => {
            this.error = errorMessage;
            this.errored = true;
            this.rendering = false;
        });
    }
    ngOnDestroy() {
        // this.messageSubscription.unsubscribe();
        this.errorSubscription.unsubscribe();
    }
    renderOnServer(videoOutput) {
        let promise;
        this.rendering = true;
        this.instance.beforeRender();
        promise = this.renderService.renderVideoOnServer(this.livechartsService.settings, this.instance.animation, this.livechartsService.frameRate, videoOutput, this.instance.svgElement, this.instance.getParameterValue('size')[0], this.instance.getParameterValue('size')[1]);
        promise.then(({ blob, fileName }) => {
            // console.log(blob);
            this.rendering = false;
            this.finished = true;
            Object(file_saver__WEBPACK_IMPORTED_MODULE_3__["saveAs"])(blob, fileName);
            this.instance.afterRender();
        });
    }
    abort() {
        this.renderService.abort();
        this.aborted = true;
        this.rendering = false;
        // this.dialogRef.close();
    }
    close() {
        this.dialogRef.close();
    }
    renderWebM() {
        let promise;
        this.rendering = true;
        this.instance.beforeRender();
        promise = this.renderService.renderVideoInClient(this.livechartsService.settings, this.instance.animation, this.livechartsService.frameRate, this.instance.svgElement, this.instance.getParameterValue('size')[0], this.instance.getParameterValue('size')[1], 
        // this.data.canvas,
        null, this.instance.parameters.metadata.backgroundColor || '#FFF');
        promise.then(blob => {
            // console.log(blob);
            this.rendering = false;
            this.finished = true;
            Object(file_saver__WEBPACK_IMPORTED_MODULE_3__["saveAs"])(blob, 'video.webm');
            this.instance.afterRender();
        });
    }
    renderMP4() {
        this.renderOnServer('smallAndCompatible');
    }
    renderMov() {
        this.renderOnServer('highQualityAndTransparent');
    }
};
RenderVideoDialogComponent.ctorParameters = () => [
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_material__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"],] }] },
    { type: _services_render_service__WEBPACK_IMPORTED_MODULE_4__["RenderService"] },
    { type: _livecharts_service__WEBPACK_IMPORTED_MODULE_5__["LivechartsService"] }
];
RenderVideoDialogComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'lib-render-video-dialog',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./render-video-dialog.component.html */ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/render-video-dialog/render-video-dialog.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./render-video-dialog.component.scss */ "../livecharts/src/lib/editor/basic-editor/render-video-dialog/render-video-dialog.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](1, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_angular_material__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"]))
], RenderVideoDialogComponent);



/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/scrub/scrub.component.scss":
/*!****************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/scrub/scrub.component.scss ***!
  \****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("#lcs-progress-scrubber {\n  margin: 15px 5px 10px 5px;\n  display: flex;\n  flex-flow: row nowrap;\n  position: relative;\n  cursor: pointer;\n}\n\n#lcs-progress-scrubber-spacer {\n  flex-basis: 20px;\n  pointer-events: none;\n}\n\n#lcs-progress-scrubber-done {\n  height: 14px;\n  flex-basis: 70%;\n  pointer-events: none;\n}\n\n#lcs-progress-scrubber-todo {\n  height: 14px;\n  flex-grow: 1;\n  pointer-events: none;\n}\n\n#lcs-progress-thumb-container {\n  height: 10px;\n  width: 100%;\n  position: absolute;\n  top: 2px;\n  display: flex;\n  flex-flow: row nowrap;\n  pointer-events: none;\n}\n\n#lcs-progress-thumb-spacer {\n  flex-basis: calc(100% - 20px);\n  pointer-events: none;\n}\n\n#lcs-progress-thumb {\n  height: 10px;\n  width: 20px;\n  pointer-events: none;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/scrub/scrub.component.ts":
/*!**************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/scrub/scrub.component.ts ***!
  \**************************************************************************/
/*! exports provided: ScrubComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScrubComponent", function() { return ScrubComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _livecharts_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../livecharts.service */ "../livecharts/src/lib/livecharts.service.ts");
/* harmony import */ var d3__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! d3 */ "../../node_modules/d3/index.js");




// TODO: make the thumb draggable
let ScrubComponent = class ScrubComponent {
    constructor(livechartsService) {
        this.livechartsService = livechartsService;
    }
    ngOnInit() {
        // Dig up the elements that we need the sizes of
        // using D3... I know it would be cleaner to use the ComponentRef
        // but who cares?
        this.done = d3__WEBPACK_IMPORTED_MODULE_3__["select"]('#lcs-progress-scrubber-done');
        this.container = d3__WEBPACK_IMPORTED_MODULE_3__["select"]('#lcs-progress-thumb-container');
        this.spacer = d3__WEBPACK_IMPORTED_MODULE_3__["select"]('#lcs-progress-thumb-spacer');
        // When new progress values come in, set the scrubber to the correct position
        this.progressSubscription = this.livechartsService.getProgressObservable.subscribe(progress => {
            // this.value = progress.progress;
            this.progress = progress;
            this.setScrubberToProgress();
        });
    }
    ngOnDestroy() {
        this.progressSubscription.unsubscribe();
    }
    setScrubberToProgress() {
        // Please note that the 20px is hardcoded here and in the SCSS file
        this.done.style('flex-basis', `calc(${this.progress.progress * 100}% - 20px)`);
        this.spacer.style('flex-basis', `calc(${this.progress.progress * 100}% - 20px)`);
    }
    clickScrubber($event) {
        // When the user clicks the scrubber, figure out the progress and set it
        // NB - the complete width of the scrubber is used without taking into
        // account the width of the thumb
        let containerRect = this.container.node().getBoundingClientRect();
        let progress = $event.offsetX / containerRect.width;
        this.livechartsService.setProgress(progress);
    }
};
ScrubComponent.ctorParameters = () => [
    { type: _livecharts_service__WEBPACK_IMPORTED_MODULE_2__["LivechartsService"] }
];
ScrubComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'lib-scrub',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./scrub.component.html */ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/scrub/scrub.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./scrub.component.scss */ "../livecharts/src/lib/editor/basic-editor/scrub/scrub.component.scss")).default]
    })
], ScrubComponent);



/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/settings/frame-rate/frame-rate.component.scss":
/*!***********************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/settings/frame-rate/frame-rate.component.scss ***!
  \***********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".basic-editor-form-field {\n  display: flex;\n}\n\ndiv.lcs-framerate-slider {\n  display: flex;\n  align-items: center;\n}\n\ndiv.lcs-framerate-slider span {\n  padding-right: 5px;\n}\n\ndiv.lcs-framerate-slider mat-slider {\n  flex-grow: 1;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInByb2plY3RzL2xpdmVjaGFydHMvc3JjL2xpYi9lZGl0b3IvYmFzaWMtZWRpdG9yL3NldHRpbmdzL2ZyYW1lLXJhdGUvQzpcXFdlYnN0b3JtUHJvamVjdHNcXGxpdmVjaGFydHNEb2dmaWdodC9wcm9qZWN0c1xcbGl2ZWNoYXJ0c1xcc3JjXFxsaWJcXGVkaXRvclxcYmFzaWMtZWRpdG9yXFxzZXR0aW5nc1xcZnJhbWUtcmF0ZVxcZnJhbWUtcmF0ZS5jb21wb25lbnQuc2NzcyIsInByb2plY3RzL2xpdmVjaGFydHMvc3JjL2xpYi9lZGl0b3IvYmFzaWMtZWRpdG9yL3NldHRpbmdzL2ZyYW1lLXJhdGUvZnJhbWUtcmF0ZS5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGFBQUE7QUNDRjs7QURFQTtFQUNFLGFBQUE7RUFDQSxtQkFBQTtBQ0NGOztBREFFO0VBQ0Usa0JBQUE7QUNFSjs7QURBRTtFQUNFLFlBQUE7QUNFSiIsImZpbGUiOiJwcm9qZWN0cy9saXZlY2hhcnRzL3NyYy9saWIvZWRpdG9yL2Jhc2ljLWVkaXRvci9zZXR0aW5ncy9mcmFtZS1yYXRlL2ZyYW1lLXJhdGUuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuYmFzaWMtZWRpdG9yLWZvcm0tZmllbGQge1xyXG4gIGRpc3BsYXk6IGZsZXg7XHJcbn1cclxuXHJcbmRpdi5sY3MtZnJhbWVyYXRlLXNsaWRlciB7XHJcbiAgZGlzcGxheTogZmxleDtcclxuICBhbGlnbi1pdGVtczogY2VudGVyOyAvLyBWZXJ0aWNhbGx5IGFsaWduIGNvbnRlbnRcclxuICBzcGFuIHtcclxuICAgIHBhZGRpbmctcmlnaHQ6IDVweDsgLy8gTGVhdmUgc29tZSBzcGFjZSBiZXR3ZWVuIGxhYmVsIGFuZCBzbGlkZXJcclxuICB9XHJcbiAgbWF0LXNsaWRlciB7XHJcbiAgICBmbGV4LWdyb3c6IDE7IC8vIEdyb3cgdGhlIHNsaWRlciwgbm90IHRoZSBsYWJlbFxyXG4gIH1cclxufVxyXG4iLCIuYmFzaWMtZWRpdG9yLWZvcm0tZmllbGQge1xuICBkaXNwbGF5OiBmbGV4O1xufVxuXG5kaXYubGNzLWZyYW1lcmF0ZS1zbGlkZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xufVxuZGl2Lmxjcy1mcmFtZXJhdGUtc2xpZGVyIHNwYW4ge1xuICBwYWRkaW5nLXJpZ2h0OiA1cHg7XG59XG5kaXYubGNzLWZyYW1lcmF0ZS1zbGlkZXIgbWF0LXNsaWRlciB7XG4gIGZsZXgtZ3JvdzogMTtcbn0iXX0= */");

/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/settings/frame-rate/frame-rate.component.ts":
/*!*********************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/settings/frame-rate/frame-rate.component.ts ***!
  \*********************************************************************************************/
/*! exports provided: FrameRateComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FrameRateComponent", function() { return FrameRateComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "../../node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _livecharts_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../livecharts.service */ "../livecharts/src/lib/livecharts.service.ts");




let FrameRateComponent = class FrameRateComponent {
    constructor(livechartsService) {
        this.livechartsService = livechartsService;
        this.formControl = new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"]();
    }
    ngOnInit() {
        this.min = this.livechartsService.settings.frameRate.min;
        this.max = this.livechartsService.settings.frameRate.max;
        this.formControl.setValue(this.livechartsService.settings.frameRate.default);
        this.formValueSubscription = this.formControl.valueChanges.subscribe(value => {
            this.formValueChanged(value);
        });
    }
    ngOnDestroy() {
        this.formValueSubscription.unsubscribe();
    }
    formValueChanged(value) {
        this.livechartsService.frameRate = value;
    }
};
FrameRateComponent.ctorParameters = () => [
    { type: _livecharts_service__WEBPACK_IMPORTED_MODULE_3__["LivechartsService"] }
];
FrameRateComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'lib-frame-rate',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./frame-rate.component.html */ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/settings/frame-rate/frame-rate.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./frame-rate.component.scss */ "../livecharts/src/lib/editor/basic-editor/settings/frame-rate/frame-rate.component.scss")).default]
    })
], FrameRateComponent);



/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/settings/scalable/scalable.component.scss":
/*!*******************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/settings/scalable/scalable.component.scss ***!
  \*******************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJwcm9qZWN0cy9saXZlY2hhcnRzL3NyYy9saWIvZWRpdG9yL2Jhc2ljLWVkaXRvci9zZXR0aW5ncy9zY2FsYWJsZS9zY2FsYWJsZS5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/settings/scalable/scalable.component.ts":
/*!*****************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/settings/scalable/scalable.component.ts ***!
  \*****************************************************************************************/
/*! exports provided: ScalableComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScalableComponent", function() { return ScalableComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "../../node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _livecharts_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../livecharts.service */ "../livecharts/src/lib/livecharts.service.ts");




let ScalableComponent = class ScalableComponent {
    constructor(livechartsService) {
        this.livechartsService = livechartsService;
        this.formControl = new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"]();
    }
    ngOnInit() {
        this.formControl.setValue(this.livechartsService.settings.editor.scalable);
        this.formValueSubscription = this.formControl.valueChanges.subscribe(value => {
            this.formValueChanged(value);
        });
    }
    ngOnDestroy() {
        this.formValueSubscription.unsubscribe();
    }
    formValueChanged(value) {
        // console.log(value);
        this.livechartsService.setScalable(value);
    }
};
ScalableComponent.ctorParameters = () => [
    { type: _livecharts_service__WEBPACK_IMPORTED_MODULE_3__["LivechartsService"] }
];
ScalableComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'lib-scalable',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./scalable.component.html */ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/settings/scalable/scalable.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./scalable.component.scss */ "../livecharts/src/lib/editor/basic-editor/settings/scalable/scalable.component.scss")).default]
    })
], ScalableComponent);



/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/settings/settings.component.scss":
/*!**********************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/settings/settings.component.scss ***!
  \**********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".basic-editor-settings {\n  margin: 10px;\n  padding-left: 24px;\n  padding-right: 24px;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInByb2plY3RzL2xpdmVjaGFydHMvc3JjL2xpYi9lZGl0b3IvYmFzaWMtZWRpdG9yL3NldHRpbmdzL0M6XFxXZWJzdG9ybVByb2plY3RzXFxsaXZlY2hhcnRzRG9nZmlnaHQvcHJvamVjdHNcXGxpdmVjaGFydHNcXHNyY1xcbGliXFxlZGl0b3JcXGJhc2ljLWVkaXRvclxcc2V0dGluZ3NcXHNldHRpbmdzLmNvbXBvbmVudC5zY3NzIiwicHJvamVjdHMvbGl2ZWNoYXJ0cy9zcmMvbGliL2VkaXRvci9iYXNpYy1lZGl0b3Ivc2V0dGluZ3Mvc2V0dGluZ3MuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxZQUFBO0VBQ0Esa0JBQUE7RUFDQSxtQkFBQTtBQ0NGIiwiZmlsZSI6InByb2plY3RzL2xpdmVjaGFydHMvc3JjL2xpYi9lZGl0b3IvYmFzaWMtZWRpdG9yL3NldHRpbmdzL3NldHRpbmdzLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmJhc2ljLWVkaXRvci1zZXR0aW5ncyB7XHJcbiAgbWFyZ2luOiAxMHB4O1xyXG4gIHBhZGRpbmctbGVmdDogMjRweDtcclxuICBwYWRkaW5nLXJpZ2h0OiAyNHB4O1xyXG59XHJcbiIsIi5iYXNpYy1lZGl0b3Itc2V0dGluZ3Mge1xuICBtYXJnaW46IDEwcHg7XG4gIHBhZGRpbmctbGVmdDogMjRweDtcbiAgcGFkZGluZy1yaWdodDogMjRweDtcbn0iXX0= */");

/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/settings/settings.component.ts":
/*!********************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/settings/settings.component.ts ***!
  \********************************************************************************/
/*! exports provided: SettingsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SettingsComponent", function() { return SettingsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");


let SettingsComponent = class SettingsComponent {
    constructor() { }
    ngOnInit() {
        this.hasSlices =
            this.metadata['outputTypes'].find(type => type === 'pngs') &&
                this.metadata['frame'] &&
                this.metadata['slices'];
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], SettingsComponent.prototype, "metadata", void 0);
SettingsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'lib-settings',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./settings.component.html */ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/settings/settings.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./settings.component.scss */ "../livecharts/src/lib/editor/basic-editor/settings/settings.component.scss")).default]
    })
], SettingsComponent);



/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/settings/slices/slices.component.scss":
/*!***************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/settings/slices/slices.component.scss ***!
  \***************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJwcm9qZWN0cy9saXZlY2hhcnRzL3NyYy9saWIvZWRpdG9yL2Jhc2ljLWVkaXRvci9zZXR0aW5ncy9zbGljZXMvc2xpY2VzLmNvbXBvbmVudC5zY3NzIn0= */");

/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/settings/slices/slices.component.ts":
/*!*************************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/settings/slices/slices.component.ts ***!
  \*************************************************************************************/
/*! exports provided: SlicesComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SlicesComponent", function() { return SlicesComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "../../node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _livecharts_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../livecharts.service */ "../livecharts/src/lib/livecharts.service.ts");




let SlicesComponent = class SlicesComponent {
    constructor(livechartsService) {
        this.livechartsService = livechartsService;
        this.formControl = new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"]();
    }
    ngOnInit() {
        this.formControl.setValue(this.livechartsService.settings.editor.slices);
        this.formValueSubscription = this.formControl.valueChanges.subscribe(value => {
            this.formValueChanged(value);
        });
    }
    ngOnDestroy() {
        this.formValueSubscription.unsubscribe();
    }
    formValueChanged(value) {
        // console.log(value);
        this.livechartsService.setShowSlices(value);
    }
};
SlicesComponent.ctorParameters = () => [
    { type: _livecharts_service__WEBPACK_IMPORTED_MODULE_3__["LivechartsService"] }
];
SlicesComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'lib-slices',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./slices.component.html */ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/settings/slices/slices.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./slices.component.scss */ "../livecharts/src/lib/editor/basic-editor/settings/slices/slices.component.scss")).default]
    })
], SlicesComponent);



/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/timer/timer.component.scss":
/*!****************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/timer/timer.component.scss ***!
  \****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".lcs-timer-wrapper {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.lcs-timer-wrapper div {\n  margin: 5px;\n  flex-basis: 20%;\n  text-align: center;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInByb2plY3RzL2xpdmVjaGFydHMvc3JjL2xpYi9lZGl0b3IvYmFzaWMtZWRpdG9yL3RpbWVyL0M6XFxXZWJzdG9ybVByb2plY3RzXFxsaXZlY2hhcnRzRG9nZmlnaHQvcHJvamVjdHNcXGxpdmVjaGFydHNcXHNyY1xcbGliXFxlZGl0b3JcXGJhc2ljLWVkaXRvclxcdGltZXJcXHRpbWVyLmNvbXBvbmVudC5zY3NzIiwicHJvamVjdHMvbGl2ZWNoYXJ0cy9zcmMvbGliL2VkaXRvci9iYXNpYy1lZGl0b3IvdGltZXIvdGltZXIuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxhQUFBO0VBQ0EsOEJBQUE7RUFDQSxnQkFBQTtFQUNBLG1CQUFBO0FDQ0Y7QURBRTtFQUNFLFdBQUE7RUFDQSxlQUFBO0VBQ0Esa0JBQUE7QUNFSiIsImZpbGUiOiJwcm9qZWN0cy9saXZlY2hhcnRzL3NyYy9saWIvZWRpdG9yL2Jhc2ljLWVkaXRvci90aW1lci90aW1lci5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5sY3MtdGltZXItd3JhcHBlciB7XHJcbiAgZGlzcGxheTogZmxleDtcclxuICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XHJcbiAgbWFyZ2luLXRvcDogMTBweDtcclxuICBtYXJnaW4tYm90dG9tOiAxMHB4O1xyXG4gIGRpdiB7XHJcbiAgICBtYXJnaW46IDVweDtcclxuICAgIGZsZXgtYmFzaXM6IDIwJTtcclxuICAgIHRleHQtYWxpZ246IGNlbnRlcjtcclxuICB9XHJcbiAgLy8gLmxjcy10aW1lci1wcm9ncmVzcyB7XHJcbiAgLy8gICB0ZXh0LWFsaWduOiBsZWZ0O1xyXG4gIC8vIH1cclxuICAvLyAubGNzLXRpbWVyLXRpbWUge1xyXG4gIC8vICAgdGV4dC1hbGlnbjogY2VudGVyO1xyXG4gIC8vIH1cclxuICAvLyAubGNzLXRpbWVyLWR1cmF0aW9uIHtcclxuICAvLyAgIHRleHQtYWxpZ246IHJpZ2h0O1xyXG4gIC8vIH1cclxufVxyXG4iLCIubGNzLXRpbWVyLXdyYXBwZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gIG1hcmdpbi10b3A6IDEwcHg7XG4gIG1hcmdpbi1ib3R0b206IDEwcHg7XG59XG4ubGNzLXRpbWVyLXdyYXBwZXIgZGl2IHtcbiAgbWFyZ2luOiA1cHg7XG4gIGZsZXgtYmFzaXM6IDIwJTtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xufSJdfQ== */");

/***/ }),

/***/ "../livecharts/src/lib/editor/basic-editor/timer/timer.component.ts":
/*!**************************************************************************!*\
  !*** ../livecharts/src/lib/editor/basic-editor/timer/timer.component.ts ***!
  \**************************************************************************/
/*! exports provided: TimerComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TimerComponent", function() { return TimerComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _livecharts_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../livecharts.service */ "../livecharts/src/lib/livecharts.service.ts");



let TimerComponent = class TimerComponent {
    constructor(livechartsService, changeDetectorRef) {
        this.livechartsService = livechartsService;
        this.changeDetectorRef = changeDetectorRef;
    }
    ngOnInit() {
        this.progress$ = this.livechartsService.getProgressObservable;
        this.progressSubscription = this.livechartsService.getProgressObservable.subscribe(progress => {
            this.progress = progress.progress;
            this.time = progress.time;
            this.duration = progress.duration;
            this.changeDetectorRef.detectChanges();
        });
    }
    ngOnDestroy() {
        this.progressSubscription.unsubscribe();
    }
};
TimerComponent.ctorParameters = () => [
    { type: _livecharts_service__WEBPACK_IMPORTED_MODULE_2__["LivechartsService"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectorRef"] }
];
TimerComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'lib-timer',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./timer.component.html */ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/editor/basic-editor/timer/timer.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./timer.component.scss */ "../livecharts/src/lib/editor/basic-editor/timer/timer.component.scss")).default]
    })
], TimerComponent);



/***/ }),

/***/ "../livecharts/src/lib/livechart/livechart.component.ts":
/*!**************************************************************!*\
  !*** ../livecharts/src/lib/livechart/livechart.component.ts ***!
  \**************************************************************/
/*! exports provided: LivechartBaseComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LivechartBaseComponent", function() { return LivechartBaseComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _livecharts_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../livecharts.service */ "../livecharts/src/lib/livecharts.service.ts");
/* harmony import */ var _services_util_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../services/util.service */ "../livecharts/src/lib/services/util.service.ts");
/* harmony import */ var _services_svg_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../services/svg.service */ "../livecharts/src/lib/services/svg.service.ts");
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! gsap */ "../../node_modules/gsap/index.js");
/* harmony import */ var gsap_Draggable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! gsap/Draggable */ "../../node_modules/gsap/Draggable.js");
/* harmony import */ var d3__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! d3 */ "../../node_modules/d3/index.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! lodash */ "../../node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_8__);




// import { RenderService } from '../services/render.service';



// import { PixiPlugin } from 'gsap/PixiPlugin'; Register Plugin hier
// NB: to avoid tree shaking of required plugins, register them like so
// gsap.registerPlugin(MotionPathPlugin, ScrollToPlugin, TextPlugin);
// it seems it is enough to do this once here and then just import
// whatever plugins necessary in the components
gsap__WEBPACK_IMPORTED_MODULE_5__["gsap"].registerPlugin(gsap_Draggable__WEBPACK_IMPORTED_MODULE_6__["Draggable"]);
// gsap.registerPlugin(MotionPathPlugin);


let g, s;
let LivechartBaseComponent = class LivechartBaseComponent {
    constructor(livechartsService, utilService, svgService) {
        this.livechartsService = livechartsService;
        this.utilService = utilService;
        this.svgService = svgService;
        g = (id) => this.values[id]; // Method to succinctly dig-up a parameter
        s = (id, value) => {
            // Same but for setting a parameter value
            this.values[id] = value;
        };
    }
    ngOnInit() {
        this.id = this.utilService.generateID(10); // id is used to create unique id's in the SVG to avoid conflicts
        // Listen to the playbackObservable and play / pause / restart the animation when commands come in
        // TODO: for readability, move this to a method
        this.playbackCommandSubscription = this.livechartsService.playbackObservable.subscribe(command => {
            switch (command) {
                case 'play':
                    this.animation.play();
                    break;
                case 'pause':
                    this.animation.pause();
                    break;
                case 'restart':
                    this.animation.restart();
                    break;
                case 'toggle':
                    this.animation.paused()
                        ? this.animation.play()
                        : this.animation.pause();
                    break;
            }
        });
        this.progressSubscription = this.livechartsService.setProgressObservable.subscribe(progress => {
            this.animation.progress(progress);
        });
        this.timeSubscription = this.livechartsService.setTimeObservable.subscribe(time => {
            this.animation.time(time);
        });
        this.parameterSubscription = this.livechartsService.parameterObservable.subscribe(parameter => {
            // When a new value comes in, check to see if it belongs to the parameters or timings
            // and update the appriopriate object
            if (lodash__WEBPACK_IMPORTED_MODULE_8__["includes"](Object.keys(this.parameters.parameters), parameter.id)) {
                // console.log('param');
                this.values[parameter.id] = parameter.value;
                this.createLivechart();
            }
            else if (lodash__WEBPACK_IMPORTED_MODULE_8__["includes"](Object.keys(this.parameters.timings), parameter.id)) {
                // console.log('timing');
                this.timings[parameter.id] = parameter.value;
                this.createLivechart();
            }
        });
        this.scalableSubscription = this.livechartsService.scalableObservable.subscribe(scalable => {
            this.scalable = scalable;
        });
        this.showSlicesSubscription = this.livechartsService.showSlicesObservable.subscribe(showSlices => {
            this.showHideSlices(showSlices);
        });
        this.setAllDefaults();
    }
    ngOnDestroy() {
        this.kill();
        this.playbackCommandSubscription.unsubscribe();
        this.progressSubscription.unsubscribe();
        this.timeSubscription.unsubscribe();
        this.parameterSubscription.unsubscribe();
        this.scalableSubscription.unsubscribe();
        this.showSlicesSubscription.unsubscribe();
    }
    ngAfterViewInit() {
        this.svgElement = this.svgRef.nativeElement;
        this.svgSelection = d3__WEBPACK_IMPORTED_MODULE_7__["select"](this.svgElement);
        this.encodeFonts();
        this.createLivechart();
        this.drawSlices();
    }
    getDefaultValues(obj) {
        // Pull the defaults from the parameter file
        if (obj) {
            let defaultValues = {};
            Object.keys(obj).map(key => {
                defaultValues[key] = obj[key]['default'];
            });
            return defaultValues;
        }
    }
    setAllDefaults() {
        // The naming of this.values is a little awkward but this.parameters was already taken
        // and in the previous version this.values was the name we used so... it is what it is
        this.values = this.getDefaultValues(this.parameters.parameters);
        this.timings = this.getDefaultValues(this.parameters.timings);
        this.data = this.getDefaultValues(this.parameters.data);
    }
    getParameterValue(id) {
        return this.values[id];
    }
    kill() {
        // Kill animation here in order for animations to be stopped on destroy of LivechartComponents
        if (this.animation) {
            this.animation.kill();
        }
    }
    createLivechart() {
        // If we had an animation already, get the progress of that animation
        let currentProgress;
        if (this.animation) {
            currentProgress = this.animation.progress();
        }
        this.kill();
        this.initializeLivechart();
        this.createElements();
        this.createAnimation();
        // Set the progress on the animation back to what it was
        if (currentProgress) {
            this.animation.progress(currentProgress);
        }
        // Update the scrubber
        if (this.animation) {
            this.livechartsService.sendProgress({
                progress: this.animation.progress(),
                time: this.animation.time(),
                duration: this.animation.duration(),
            });
        }
        // Note: when the timing is being changed, we may not end up
        // at a spot that looks the same because progress is some percentage
        // on the timeline and that spot may look different... of course
    }
    initializeLivechart() {
        // Do initial setup and calculations here
    }
    createElements() {
        // Create all the SVG elements that make up the Livechart here
    }
    createAnimation() {
        // Create the GSAP animations here
        if (this.parameters['metadata']['category'] === 'animation') {
            // The onUpdate callback gets the animation bount to 'this' by GSAP
            // in order to access the livechartsService inside the function
            // an IIFE was used to create a closure around it
            let setProgress = (function (livechartsService) {
                return function () {
                    livechartsService.sendProgress({
                        progress: this.progress(),
                        time: this.time(),
                        duration: this.duration(),
                    });
                };
            })(this.livechartsService);
            this.animation = gsap__WEBPACK_IMPORTED_MODULE_5__["gsap"].timeline({
                repeat: -1,
                onUpdate: setProgress,
                // callbackScope: this.animation, // Default callbackScope IS the animation
                paused: !this.livechartsService.playing,
            });
        }
    }
    findLabelsForStills() {
        // Add labels in the GSAP timeline with the format: 'positionForStill-1'.
        // This method digs up a list of labels with that format,
        // buttons are then added to the UI to stop the animation in
        // those locations in order to generate stills...
        if (this.animation) {
            let labels = this.animation.labels; // Spits out an object with the labels as keys and the times as properties
            let regEx = /^positionForStill-[1-9][0-9]*$/; // Only match entire string with a number at the end without leading zeros
            let keys = Object.keys(this.animation.labels); // Get the keys
            let filteredKeys = lodash__WEBPACK_IMPORTED_MODULE_8__["filter"](keys, key => regEx.test(key)); // Filter out all the labels that do not match the pattern
            let filteredLabels = lodash__WEBPACK_IMPORTED_MODULE_8__["map"](filteredKeys, key => {
                return {
                    label: key,
                    time: labels[key],
                    nr: parseInt(key.replace('positionForStill-', ''), 10),
                };
            });
            return filteredLabels;
        }
    }
    encodeFonts() {
        // From the metadata get all the fonts that are used in this Livechart
        let fonts = lodash__WEBPACK_IMPORTED_MODULE_8__["get"](this.parameters, ['metadata', 'fonts']);
        if (fonts) {
            this.svgService.generateEmbeddedFontCSS(fonts).then(css => {
                this.fontCSS = css;
                // console.log(css);
            });
        }
    }
    beforeRender() {
        this.fontStyleSelection = this.svgSelection
            .append('style')
            .text(this.fontCSS)
            .lower();
        if (this.slices) {
            this.slices.attr('visibility', 'hidden');
        }
    }
    afterRender() {
        this.fontStyleSelection.remove();
        if (this.slices) {
            this.slices.attr('visibility', this.showSlices ? 'visible' : 'hidden');
        }
    }
    drawSlices() {
        // Check the parameters to see if all conditions are met for drawing some
        // sexy slices
        let hasPngs = lodash__WEBPACK_IMPORTED_MODULE_8__["get"](this.parameters, ['metadata', 'outputTypes']).find(type => type === 'pngs');
        let frame = lodash__WEBPACK_IMPORTED_MODULE_8__["get"](this.parameters, ['metadata', 'frame']);
        let slices = lodash__WEBPACK_IMPORTED_MODULE_8__["get"](this.parameters, ['metadata', 'slices']);
        // Draw those slices
        if (hasPngs && frame && slices) {
            this.slices = this.svgSelection
                .append('g')
                .attr('id', `slices-${this.id}`)
                .attr('visibility', this.showSlices ? 'visible' : 'hidden');
            for (let slice of slices) {
                this.slices
                    .append('rect')
                    .attr('x', slice[0])
                    .attr('y', slice[1])
                    .attr('width', frame[0])
                    .attr('height', frame[1])
                    .style('fill', this.livechartsService.settings.slices.fill)
                    .style('stroke', this.livechartsService.settings.slices.stroke)
                    .style('stroke-width', this.livechartsService.settings.slices.strokeWidth)
                    .style('stroke-dasharray', this.livechartsService.settings.slices.strokeDashArray);
            }
        }
        else {
            // throw new Error(
            //   `Do not call drawSlices on Livecharts that does not include 'pngs' in outputTypes and / or does not have 'frame' and 'slices' set on metadata.`,
            // );
        }
    }
    showHideSlices(show) {
        this.showSlices = show;
        if (this.slices) {
            this.slices.attr('visibility', this.showSlices ? 'visible' : 'hidden');
        }
    }
};
LivechartBaseComponent.ctorParameters = () => [
    { type: _livecharts_service__WEBPACK_IMPORTED_MODULE_2__["LivechartsService"] },
    { type: _services_util_service__WEBPACK_IMPORTED_MODULE_3__["UtilService"] },
    { type: _services_svg_service__WEBPACK_IMPORTED_MODULE_4__["SvgService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], LivechartBaseComponent.prototype, "parameters", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('svg', { static: false })
], LivechartBaseComponent.prototype, "svgRef", void 0);
LivechartBaseComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'lib-livechart-base',
        template: '',
    })
], LivechartBaseComponent);



/***/ }),

/***/ "../livecharts/src/lib/livecharts.module.ts":
/*!**************************************************!*\
  !*** ../livecharts/src/lib/livecharts.module.ts ***!
  \**************************************************/
/*! exports provided: LivechartsModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LivechartsModule", function() { return LivechartsModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "../../node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _material_material_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./material/material.module */ "../livecharts/src/lib/material/material.module.ts");
/* harmony import */ var _overview_basic_overview_basic_overview_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./overview/basic-overview/basic-overview.module */ "../livecharts/src/lib/overview/basic-overview/basic-overview.module.ts");
/* harmony import */ var _editor_basic_editor_basic_editor_module__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./editor/basic-editor/basic-editor.module */ "../livecharts/src/lib/editor/basic-editor/basic-editor.module.ts");
/* harmony import */ var _livecharts_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./livecharts.service */ "../livecharts/src/lib/livecharts.service.ts");
/* harmony import */ var _services_util_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./services/util.service */ "../livecharts/src/lib/services/util.service.ts");
/* harmony import */ var _services_render_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./services/render.service */ "../livecharts/src/lib/services/render.service.ts");
/* harmony import */ var _livechart_livechart_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./livechart/livechart.component */ "../livecharts/src/lib/livechart/livechart.component.ts");






// Services



// Components

let LivechartsModule = class LivechartsModule {
};
LivechartsModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [_livechart_livechart_component__WEBPACK_IMPORTED_MODULE_9__["LivechartBaseComponent"]],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _material_material_module__WEBPACK_IMPORTED_MODULE_3__["MaterialModule"],
            _overview_basic_overview_basic_overview_module__WEBPACK_IMPORTED_MODULE_4__["BasicOverviewModule"],
            _editor_basic_editor_basic_editor_module__WEBPACK_IMPORTED_MODULE_5__["BasicEditorModule"],
        ],
        exports: [_livechart_livechart_component__WEBPACK_IMPORTED_MODULE_9__["LivechartBaseComponent"], _overview_basic_overview_basic_overview_module__WEBPACK_IMPORTED_MODULE_4__["BasicOverviewModule"], _editor_basic_editor_basic_editor_module__WEBPACK_IMPORTED_MODULE_5__["BasicEditorModule"]],
        providers: [_livecharts_service__WEBPACK_IMPORTED_MODULE_6__["LivechartsService"], _services_util_service__WEBPACK_IMPORTED_MODULE_7__["UtilService"], _services_render_service__WEBPACK_IMPORTED_MODULE_8__["RenderService"]],
    })
], LivechartsModule);



/***/ }),

/***/ "../livecharts/src/lib/livecharts.service.ts":
/*!***************************************************!*\
  !*** ../livecharts/src/lib/livecharts.service.ts ***!
  \***************************************************/
/*! exports provided: LivechartsService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LivechartsService", function() { return LivechartsService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "../../node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lodash */ "../../node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./settings */ "../livecharts/src/lib/settings.ts");
/* harmony import */ var d3__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! d3 */ "../../node_modules/d3/index.js");






// Basically, this entire service wires up the application
// It contains methods to pass the implementation specific animations and settings to
// and it contains streams and observables that are used to pass all the necessary info around
let LivechartsService = class LivechartsService {
    // Recording
    constructor() {
        this.playing = true; // Animation state
        // Settings
        this.defaultSettings = _settings__WEBPACK_IMPORTED_MODULE_4__["settings"];
        this.scalableStream = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
        this.scalableObservable = this.scalableStream.asObservable();
        this.showSlicesStream = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
        this.showSlicesObservable = this.showSlicesStream.asObservable();
        // Parameters
        this.parameterStream = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"](); // New parameter values from controls
        this.parameterObservable = this.parameterStream.asObservable();
        this.timingStream = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"](); // New timing values from controls
        this.timingObservable = this.timingStream.asObservable();
        this.resetParameterStream = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"](); // Stream that tells all controls to reset themselves
        this.resetParameterObservable = this.resetParameterStream.asObservable();
        this.setParameterStream = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"](); // Used when parameters are set from a stored value
        this.setParameterObservable = this.setParameterStream.asObservable();
        this.settingsStream = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"](); // Used when the settings control emits new values
        this.settingObservable = this.settingsStream.asObservable();
        // Progress
        this.setProgressStream = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"](); // Call the setProgress method on this servive
        this.setProgressObservable = this.setProgressStream.asObservable(); // Only used by the animation
        this.setTimeStream = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"](); // Call the setTime method on this servive
        this.setTimeObservable = this.setTimeStream.asObservable(); // Only used by the animation
        this.getProgressStream = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
        this.getProgressObservable = this.getProgressStream.asObservable(); // Used by everything that needs to know the progress of the animation
        // Playback
        this.playbackStream = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"](); // Call the sendPlayBackCommand method to tell the animation to do something
        this.playbackObservable = this.playbackStream.asObservable(); // The animation observes this stream and this stream only for playback control
        // Check playingStream works as a Subject or whether it should be a BehaviorSubject (with the initial state being set through the settings)
        this.playingStream = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
        this.playingObservable = this.playingStream.asObservable();
    }
    setAnimations(animations) {
        this.animations = animations;
        // this.animationSubject.next(this.animations);
    }
    getAnimationsByGroup(group) {
        let result = this.animations[group];
        return result;
    }
    getAnimationById(id) {
        let animation = this.animations
            .map(obj => obj.values)
            .flatMap(arr => arr)
            .find(obj => obj['id'] === id);
        return animation;
    }
    setSettings(customSettings) {
        this.settings = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["merge"])(this.defaultSettings, customSettings);
        this.frameRate = this.settings.frameRate.default;
        this.injectAllFonts(); // Not so sure this is the best place, perhaps move to separate method, init() of some sort?
    }
    pushParameter(parameter) {
        this.parameterStream.next(parameter);
    }
    pushTiming(timing) {
        this.timingStream.next(timing);
    }
    resetParameters() {
        this.resetParameterStream.next(true);
    }
    setParameter(id, value) {
        this.setParameterStream.next({ id, value });
    }
    setProgress(progress) {
        // Method used by a control to tell the animation to go to some value for progress
        this.setProgressStream.next(progress);
    }
    setTime(progress) {
        // Method used by a control to tell the animation to go to some time in the timeline
        this.setTimeStream.next(progress);
    }
    setSetting(id, value) {
        this.settingsStream.next({ id, value });
    }
    setScalable(scalable) {
        this.scalableStream.next(scalable);
    }
    setShowSlices(showSlices) {
        this.showSlicesStream.next(showSlices);
    }
    sendProgress(progress) {
        // Method used by the animation to inform the rest of the app what the current progress is
        this.getProgressStream.next(progress);
    }
    setPlaybackCommand(command) {
        // Method used by controls to tell the animation what to do
        let playing = (p) => {
            this.playing = p;
            this.playingStream.next(p ? 'playing' : 'paused');
        };
        switch (command) {
            case 'play':
                playing(true);
                break;
            case 'pause':
                playing(false);
                break;
            case 'restart':
                playing(true);
                break;
            case 'toggle':
                playing(!this.playing);
                break;
        }
        this.playbackStream.next(command);
    }
    injectAllFonts() {
        // Inject the CSS for all the fonts into the head of the page
        // this is for presentation purposes in the app itself.
        // In order for images and animations to render properly the fonts
        // also need to be base64 encoded and stuck inside the SVG, that's done
        // by calling beforeRender() on the LC itself which calls encodeFonts().
        let fontSettings = this.settings['fonts'];
        let headSelection = d3__WEBPACK_IMPORTED_MODULE_5__["select"](document.head);
        for (let fontSetting of fontSettings) {
            switch (fontSetting.type) {
                case 'google':
                    headSelection
                        .append('link')
                        .attr('href', fontSetting.url)
                        .attr('rel', 'stylesheet');
                    break;
                case 'assets':
                    let fontCSS = `@font-face {
            font-family: '${fontSetting.fontFamily}';
            font-style: ${fontSetting.fontStyle};
            font-weight: ${fontSetting.fontWeight};
            font-display: swap;
            src: url(assets/fonts/${fontSetting.fileName}) format('woff2');
          }`;
                    headSelection.append('style').text(fontCSS);
                    break;
            }
        }
    }
};
LivechartsService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root',
    })
], LivechartsService);



/***/ }),

/***/ "../livecharts/src/lib/material/material.module.ts":
/*!*********************************************************!*\
  !*** ../livecharts/src/lib/material/material.module.ts ***!
  \*********************************************************/
/*! exports provided: MaterialModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MaterialModule", function() { return MaterialModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/button */ "../../node_modules/@angular/material/esm2015/button.js");
/* harmony import */ var _angular_material_tabs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/tabs */ "../../node_modules/@angular/material/esm2015/tabs.js");
/* harmony import */ var _angular_material_card__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/card */ "../../node_modules/@angular/material/esm2015/card.js");
/* harmony import */ var _angular_material_input__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/input */ "../../node_modules/@angular/material/esm2015/input.js");
/* harmony import */ var _angular_material_checkbox__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/checkbox */ "../../node_modules/@angular/material/esm2015/checkbox.js");
/* harmony import */ var _angular_material_slide_toggle__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material/slide-toggle */ "../../node_modules/@angular/material/esm2015/slide-toggle.js");
/* harmony import */ var _angular_material_slider__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/material/slider */ "../../node_modules/@angular/material/esm2015/slider.js");
/* harmony import */ var _angular_material_select__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/material/select */ "../../node_modules/@angular/material/esm2015/select.js");
/* harmony import */ var _angular_material_expansion__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/material/expansion */ "../../node_modules/@angular/material/esm2015/expansion.js");
/* harmony import */ var _angular_material_icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/material/icon */ "../../node_modules/@angular/material/esm2015/icon.js");
/* harmony import */ var _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @angular/material/tooltip */ "../../node_modules/@angular/material/esm2015/tooltip.js");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @angular/material/dialog */ "../../node_modules/@angular/material/esm2015/dialog.js");














let MaterialModule = class MaterialModule {
};
MaterialModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [
            _angular_material_button__WEBPACK_IMPORTED_MODULE_2__["MatButtonModule"],
            _angular_material_tabs__WEBPACK_IMPORTED_MODULE_3__["MatTabsModule"],
            _angular_material_card__WEBPACK_IMPORTED_MODULE_4__["MatCardModule"],
            _angular_material_input__WEBPACK_IMPORTED_MODULE_5__["MatInputModule"],
            _angular_material_checkbox__WEBPACK_IMPORTED_MODULE_6__["MatCheckboxModule"],
            _angular_material_slide_toggle__WEBPACK_IMPORTED_MODULE_7__["MatSlideToggleModule"],
            _angular_material_slider__WEBPACK_IMPORTED_MODULE_8__["MatSliderModule"],
            _angular_material_select__WEBPACK_IMPORTED_MODULE_9__["MatSelectModule"],
            _angular_material_expansion__WEBPACK_IMPORTED_MODULE_10__["MatExpansionModule"],
            _angular_material_icon__WEBPACK_IMPORTED_MODULE_11__["MatIconModule"],
            _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_12__["MatTooltipModule"],
            _angular_material_dialog__WEBPACK_IMPORTED_MODULE_13__["MatDialogModule"],
        ],
        exports: [
            _angular_material_button__WEBPACK_IMPORTED_MODULE_2__["MatButtonModule"],
            _angular_material_tabs__WEBPACK_IMPORTED_MODULE_3__["MatTabsModule"],
            _angular_material_card__WEBPACK_IMPORTED_MODULE_4__["MatCardModule"],
            _angular_material_input__WEBPACK_IMPORTED_MODULE_5__["MatInputModule"],
            _angular_material_checkbox__WEBPACK_IMPORTED_MODULE_6__["MatCheckboxModule"],
            _angular_material_slide_toggle__WEBPACK_IMPORTED_MODULE_7__["MatSlideToggleModule"],
            _angular_material_slider__WEBPACK_IMPORTED_MODULE_8__["MatSliderModule"],
            _angular_material_select__WEBPACK_IMPORTED_MODULE_9__["MatSelectModule"],
            _angular_material_expansion__WEBPACK_IMPORTED_MODULE_10__["MatExpansionModule"],
            _angular_material_icon__WEBPACK_IMPORTED_MODULE_11__["MatIconModule"],
            _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_12__["MatTooltipModule"],
            _angular_material_dialog__WEBPACK_IMPORTED_MODULE_13__["MatDialogModule"],
        ],
    })
], MaterialModule);



/***/ }),

/***/ "../livecharts/src/lib/overview/basic-overview/basic-overview-element/basic-overview-element.component.scss":
/*!******************************************************************************************************************!*\
  !*** ../livecharts/src/lib/overview/basic-overview/basic-overview-element/basic-overview-element.component.scss ***!
  \******************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".basic-overview-element {\n  max-width: 400px;\n  margin: 10px;\n  padding: 10px;\n  cursor: pointer;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInByb2plY3RzL2xpdmVjaGFydHMvc3JjL2xpYi9vdmVydmlldy9iYXNpYy1vdmVydmlldy9iYXNpYy1vdmVydmlldy1lbGVtZW50L0M6XFxXZWJzdG9ybVByb2plY3RzXFxsaXZlY2hhcnRzRG9nZmlnaHQvcHJvamVjdHNcXGxpdmVjaGFydHNcXHNyY1xcbGliXFxvdmVydmlld1xcYmFzaWMtb3ZlcnZpZXdcXGJhc2ljLW92ZXJ2aWV3LWVsZW1lbnRcXGJhc2ljLW92ZXJ2aWV3LWVsZW1lbnQuY29tcG9uZW50LnNjc3MiLCJwcm9qZWN0cy9saXZlY2hhcnRzL3NyYy9saWIvb3ZlcnZpZXcvYmFzaWMtb3ZlcnZpZXcvYmFzaWMtb3ZlcnZpZXctZWxlbWVudC9iYXNpYy1vdmVydmlldy1lbGVtZW50LmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsZ0JBQUE7RUFDQSxZQUFBO0VBQ0EsYUFBQTtFQUNBLGVBQUE7QUNDRiIsImZpbGUiOiJwcm9qZWN0cy9saXZlY2hhcnRzL3NyYy9saWIvb3ZlcnZpZXcvYmFzaWMtb3ZlcnZpZXcvYmFzaWMtb3ZlcnZpZXctZWxlbWVudC9iYXNpYy1vdmVydmlldy1lbGVtZW50LmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmJhc2ljLW92ZXJ2aWV3LWVsZW1lbnQge1xyXG4gIG1heC13aWR0aDogNDAwcHg7XHJcbiAgbWFyZ2luOiAxMHB4O1xyXG4gIHBhZGRpbmc6IDEwcHg7XHJcbiAgY3Vyc29yOiBwb2ludGVyO1xyXG59XHJcbiIsIi5iYXNpYy1vdmVydmlldy1lbGVtZW50IHtcbiAgbWF4LXdpZHRoOiA0MDBweDtcbiAgbWFyZ2luOiAxMHB4O1xuICBwYWRkaW5nOiAxMHB4O1xuICBjdXJzb3I6IHBvaW50ZXI7XG59Il19 */");

/***/ }),

/***/ "../livecharts/src/lib/overview/basic-overview/basic-overview-element/basic-overview-element.component.ts":
/*!****************************************************************************************************************!*\
  !*** ../livecharts/src/lib/overview/basic-overview/basic-overview-element/basic-overview-element.component.ts ***!
  \****************************************************************************************************************/
/*! exports provided: BasicOverviewElementComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BasicOverviewElementComponent", function() { return BasicOverviewElementComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _livecharts_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../livecharts.service */ "../livecharts/src/lib/livecharts.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "../../node_modules/@angular/router/fesm2015/router.js");

// import { Component, OnInit, Input } from '@angular/core';



let BasicOverviewElementComponent = class BasicOverviewElementComponent {
    constructor(componentFactoryResolver, changeDetectorRef, router, livechartsService) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.changeDetectorRef = changeDetectorRef;
        this.router = router;
        this.livechartsService = livechartsService;
    }
    ngOnInit() { }
    ngAfterViewInit() {
        let componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.animation['component']);
        this.viewContainerRef.clear();
        this.componentRef = this.viewContainerRef.createComponent(componentFactory);
        this.instance = this.componentRef.instance;
        this.instance.parameters = this.animation['params'];
        this.instance.scalable = this.livechartsService.settings.overview.scalable;
        this.instance.showHideSlices(this.livechartsService.settings.overview.slices);
        this.changeDetectorRef.detectChanges(); // Necessary for OnInit to fire
    }
    ngOnDestroy() {
        // this.instance.kill();
    }
    navigateToLivechart() {
        this.router.navigate([
            `/${this.livechartsService.settings.paths.editor}/`,
            this.animation.id,
        ]);
    }
};
BasicOverviewElementComponent.ctorParameters = () => [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ComponentFactoryResolver"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectorRef"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"] },
    { type: _livecharts_service__WEBPACK_IMPORTED_MODULE_2__["LivechartsService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], BasicOverviewElementComponent.prototype, "animation", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('anchor', { read: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewContainerRef"], static: false })
], BasicOverviewElementComponent.prototype, "viewContainerRef", void 0);
BasicOverviewElementComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'lib-basic-overview-element',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./basic-overview-element.component.html */ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/overview/basic-overview/basic-overview-element/basic-overview-element.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./basic-overview-element.component.scss */ "../livecharts/src/lib/overview/basic-overview/basic-overview-element/basic-overview-element.component.scss")).default]
    })
], BasicOverviewElementComponent);



/***/ }),

/***/ "../livecharts/src/lib/overview/basic-overview/basic-overview.component.scss":
/*!***********************************************************************************!*\
  !*** ../livecharts/src/lib/overview/basic-overview/basic-overview.component.scss ***!
  \***********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".basic-overview-wrapper {\n  margin: 10px;\n  display: flex;\n  flex-wrap: wrap;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInByb2plY3RzL2xpdmVjaGFydHMvc3JjL2xpYi9vdmVydmlldy9iYXNpYy1vdmVydmlldy9DOlxcV2Vic3Rvcm1Qcm9qZWN0c1xcbGl2ZWNoYXJ0c0RvZ2ZpZ2h0L3Byb2plY3RzXFxsaXZlY2hhcnRzXFxzcmNcXGxpYlxcb3ZlcnZpZXdcXGJhc2ljLW92ZXJ2aWV3XFxiYXNpYy1vdmVydmlldy5jb21wb25lbnQuc2NzcyIsInByb2plY3RzL2xpdmVjaGFydHMvc3JjL2xpYi9vdmVydmlldy9iYXNpYy1vdmVydmlldy9iYXNpYy1vdmVydmlldy5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLFlBQUE7RUFDQSxhQUFBO0VBQ0EsZUFBQTtBQ0NGIiwiZmlsZSI6InByb2plY3RzL2xpdmVjaGFydHMvc3JjL2xpYi9vdmVydmlldy9iYXNpYy1vdmVydmlldy9iYXNpYy1vdmVydmlldy5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5iYXNpYy1vdmVydmlldy13cmFwcGVyIHtcclxuICBtYXJnaW46IDEwcHg7XHJcbiAgZGlzcGxheTogZmxleDtcclxuICBmbGV4LXdyYXA6IHdyYXA7XHJcbn1cclxuIiwiLmJhc2ljLW92ZXJ2aWV3LXdyYXBwZXIge1xuICBtYXJnaW46IDEwcHg7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtd3JhcDogd3JhcDtcbn0iXX0= */");

/***/ }),

/***/ "../livecharts/src/lib/overview/basic-overview/basic-overview.component.ts":
/*!*********************************************************************************!*\
  !*** ../livecharts/src/lib/overview/basic-overview/basic-overview.component.ts ***!
  \*********************************************************************************/
/*! exports provided: BasicOverviewComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BasicOverviewComponent", function() { return BasicOverviewComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "../../node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _livecharts_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../livecharts.service */ "../livecharts/src/lib/livecharts.service.ts");




let BasicOverviewComponent = class BasicOverviewComponent {
    // private animationSubscription: any;
    constructor(livechartsService, route, router) {
        this.livechartsService = livechartsService;
        this.route = route;
        this.router = router;
    }
    ngOnInit() {
        // this.animations = this.livechartsService.getAnimations();
        // this.livechartsService.animationObservable.subscribe(animations => {
        //   if (animations) {
        //     this.animations = animations;
        //     this.init();
        //   }
        // });
        this.livechartsService.setPlaybackCommand(this.livechartsService.settings.overview.playing);
        this.animations = this.livechartsService.animations;
    }
    init() {
        // On being routed to a group show the animations for that group
        this.route.params.subscribe(params => {
            let groupID = params['overviewGroup'];
            if (groupID) {
                // Dig up the group if we have the overviewGroup parameter
                this.currentGroup = this.animations.find(group => group.id === groupID);
                // Show an error for unknown groups
                if (!this.currentGroup) {
                    this.errorMessage = `Please check your URL, unknown overview group: ${groupID}.`;
                }
            }
            else {
                // Route to the first group
                groupID = this.animations[0]['id'];
                this.router.navigate([
                    `/${this.livechartsService.defaultSettings.paths.overview}/`,
                    groupID,
                ]);
            }
        });
    }
    selectGroup(group) {
        this.router.navigate([
            `/${this.livechartsService.defaultSettings.paths.overview}/`,
            group.id,
        ]);
    }
};
BasicOverviewComponent.ctorParameters = () => [
    { type: _livecharts_service__WEBPACK_IMPORTED_MODULE_3__["LivechartsService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
BasicOverviewComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'lib-basic-overview',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./basic-overview.component.html */ "../../node_modules/raw-loader/dist/cjs.js!../livecharts/src/lib/overview/basic-overview/basic-overview.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./basic-overview.component.scss */ "../livecharts/src/lib/overview/basic-overview/basic-overview.component.scss")).default]
    })
], BasicOverviewComponent);



/***/ }),

/***/ "../livecharts/src/lib/overview/basic-overview/basic-overview.module.ts":
/*!******************************************************************************!*\
  !*** ../livecharts/src/lib/overview/basic-overview/basic-overview.module.ts ***!
  \******************************************************************************/
/*! exports provided: BasicOverviewModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BasicOverviewModule", function() { return BasicOverviewModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser */ "../../node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _material_material_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../material/material.module */ "../livecharts/src/lib/material/material.module.ts");
/* harmony import */ var _livecharts_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../livecharts.service */ "../livecharts/src/lib/livecharts.service.ts");
/* harmony import */ var _basic_overview_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./basic-overview.component */ "../livecharts/src/lib/overview/basic-overview/basic-overview.component.ts");
/* harmony import */ var _basic_overview_element_basic_overview_element_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./basic-overview-element/basic-overview-element.component */ "../livecharts/src/lib/overview/basic-overview/basic-overview-element/basic-overview-element.component.ts");




// Services

// Components


let BasicOverviewModule = class BasicOverviewModule {
};
BasicOverviewModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [_basic_overview_component__WEBPACK_IMPORTED_MODULE_5__["BasicOverviewComponent"], _basic_overview_element_basic_overview_element_component__WEBPACK_IMPORTED_MODULE_6__["BasicOverviewElementComponent"]],
        imports: [_angular_platform_browser__WEBPACK_IMPORTED_MODULE_2__["BrowserModule"], _material_material_module__WEBPACK_IMPORTED_MODULE_3__["MaterialModule"]],
        exports: [_basic_overview_component__WEBPACK_IMPORTED_MODULE_5__["BasicOverviewComponent"]],
        providers: [_livecharts_service__WEBPACK_IMPORTED_MODULE_4__["LivechartsService"]],
    })
], BasicOverviewModule);



/***/ }),

/***/ "../livecharts/src/lib/services/render.service.ts":
/*!********************************************************!*\
  !*** ../livecharts/src/lib/services/render.service.ts ***!
  \********************************************************/
/*! exports provided: RenderService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RenderService", function() { return RenderService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "../../node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _videoRecorder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./videoRecorder */ "../livecharts/src/lib/services/videoRecorder.ts");




let RenderService = class RenderService {
    constructor() {
        this.rendering = false;
        this.aborted = false;
        this.messageStream = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
        this.messageObservable = this.messageStream.asObservable();
        this.errorStream = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
        this.errorObservable = this.errorStream.asObservable();
    }
    createCanvasElement(width, height) {
        let canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    renderPNGToBlob(svgElement, width, height, canvas) {
        return this.renderSVGToPNG(this.getSVGClone(width, height, svgElement), this.getCanvas(width, height, canvas));
        // return this.renderSVGToPNGNew(
        //   this.getSVGClone(width, height, svgElement),
        //   this.getCanvas(width, height, canvas),
        //   'blob',
        // );
    }
    getSVGClone(width, height, svgElement) {
        // Copy SVG Element because it will be modified
        let svgCopy = svgElement.cloneNode(true); // Type asserion necessary because inferred type is Node(?)
        // Give the copy of the SVG Element the correct width and height
        svgCopy.setAttribute('width', width.toString());
        svgCopy.setAttribute('height', height.toString());
        return svgCopy;
    }
    getCanvas(width, height, canvas) {
        // A canvas can be passed in (and shown on the screen) or just created
        // for rendering purposes only
        if (!canvas) {
            canvas = document.createElement('canvas');
        }
        // Correct width and height set to canvas
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    renderSVGToPNG(svgElement, canvas) {
        // Older method to create a PNG, figure out which one is better
        // renderPNGToBlob or renderPNG
        let promise = new Promise(function (resolve, reject) {
            let context = canvas.getContext('2d');
            let svgString = new XMLSerializer().serializeToString(svgElement);
            // TODO: unescape seems to be deprecated and I can't remember why it
            // was included here. But it breaks when I take it out so...
            // Figure that shit out at some point (see link for a starting point).
            // https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/btoa#Unicode_strings
            let imgSrc = 'data:image/svg+xml;base64,' +
                btoa(unescape(encodeURIComponent(svgString))); // It really doesn't work without unescape
            let image = document.createElement('img');
            image.onload = () => {
                context.drawImage(image, 0, 0);
                canvas.toBlob(resolve);
            };
            image.setAttribute('src', imgSrc);
            image.onerror = function () {
                reject('Creating png from image failed');
            };
        });
        return promise;
    }
    renderSVGToPNGNew(
    // New method to render to PNG
    // In Chrome it seems the created URL's are not removed when revoked
    // don't know if this results in a memory leak.
    svgElement, canvas, output) {
        let promise = new Promise(function (resolve, reject) {
            let context = canvas.getContext('2d');
            let svgString = new XMLSerializer().serializeToString(svgElement);
            let img = new Image();
            let svg = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
            let url = URL.createObjectURL(svg);
            img.onload = function () {
                context.drawImage(img, 0, 0);
                switch (output) {
                    case 'url':
                        let png = canvas.toDataURL('image/png');
                        resolve(png);
                        break;
                    case 'blob':
                        canvas.toBlob(resolve);
                        break;
                }
                URL.revokeObjectURL(url);
            };
            img.src = url;
        });
        return promise;
    }
    renderSlicesToBlobs(svgElement, inputWidth, inputHeight, outputWidth, outputHeight, frame, slices, canvas) {
        if (outputWidth / outputHeight !== frame[0] / frame[1]) {
            throw new Error('The proportion of the output width and height should be equal to the proportion of the frame width and height, please check parameters.');
        }
        let promises = [];
        for (let slice of slices) {
            let svgCopy = this.getSVGClone(inputWidth, inputHeight, svgElement);
            svgCopy.setAttribute('x', (-1 * slice[0]).toString());
            svgCopy.setAttribute('y', (-1 * slice[1]).toString());
            let svgFrame = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svgFrame.setAttribute('width', outputWidth.toString());
            svgFrame.setAttribute('height', outputHeight.toString());
            svgFrame.setAttribute('viewBox', `0 0 ${frame[0]} ${frame[1]}`);
            svgFrame.appendChild(svgCopy);
            let p = this.renderPNGToBlob(svgFrame, outputWidth, outputHeight, canvas);
            promises.push(p);
        }
        let promise = Promise.all(promises);
        return promise;
    }
    abort() {
        this.rendering = false;
        this.aborted = true;
        if (this.videoRecorder) {
            this.videoRecorder.abort();
        }
    }
    renderVideoInClient(settings, // Not being used at the moment but passed in just in case :)
    timeline, frameRate, svgElement, width, height, canvas, backgroundColor) {
        // VideoRecorder is a fairly old class from the CBS Livecharts implementation
        this.videoRecorder = new _videoRecorder__WEBPACK_IMPORTED_MODULE_3__["VideoRecorder"](svgElement, timeline, frameRate, width, height, canvas, backgroundColor);
        let progressSubscription = this.videoRecorder.progressObservable.subscribe(p => {
            // console.log(p);
            let progressString = (p * 100).toFixed();
            // Progress info is passed from the progressObservable to the messageStream here
            this.messageStream.next(`Rendering video, progress: ${progressString}%.`);
            // this.progressEmitter.emit(p);
        });
        // record() records the video in real time
        // recordFramesToCache() first stores all images in an array and then records the canvas
        let promise = this.videoRecorder.record().then(blob => {
            progressSubscription.unsubscribe();
            return blob;
        });
        return promise;
    }
    renderVideoOnServer(settings, timeline, frameRate, videoOutput, svgElement, width, height, canvas) {
        // This method opens a WebSocket, sends a Manifest object and then the first frame of the animation
        // once the frame has been stored on the server, the server sends a 'nextFrame' message until
        // the last frame has been sent, the client then sends a 'render' message, this prompts the
        // server to start creating the video with FFmpeg, when it is done is sends a 'save' message to the client
        // this message is currently superfluous, after the save message the server sends a blob with the video...
        // NB - all frames are sent sequentially, not sure if it's possible or better to send them parallel
        this.rendering = true;
        this.aborted = false;
        let playing = timeline.playing; // Hold on to the state of the timeline and set back when done
        let progress = timeline.progress(); // Same with progress
        let currentFrame = 0;
        let time = timeline.duration();
        let frames = time * frameRate;
        // The manifest is an object sent to the server to announce what's coming
        let manifest = {
            type: 'manifest',
            client: settings.client,
            project: settings.project,
            frameRate,
            videoOutput,
            frames,
            width,
            height,
        };
        let promise = new Promise((resolve, reject) => {
            let fileName;
            fileName =
                videoOutput === 'smallAndCompatible'
                    ? 'livechart.mp4'
                    : 'livechart.mov';
            let nextFrame = () => {
                // Method called when server is ready to receive a new frame
                // if there are still frames to be sent and shizzle has not been cancelled,
                // send the next one
                if (!this.aborted) {
                    if (currentFrame < frames) {
                        // Go to the progress for the next frame
                        let p = currentFrame / frames;
                        sendProgress(currentFrame, frames, p);
                        timeline.progress(p);
                        // Create an image
                        let pngPromise = this.renderPNGToBlob(svgElement, width, height, 
                        // 'blob',
                        canvas);
                        // When the image has been hatched, send it over the WebSocket
                        pngPromise.then((png) => {
                            ws.send(png);
                            currentFrame++;
                        });
                    }
                    else {
                        // Send message to the server to start rendering the video
                        let msg = {
                            type: 'render',
                        };
                        ws.send(JSON.stringify(msg));
                        // Reset the timeline to where it was before
                        timeline.progress(progress);
                        // If it was playing before, set it to playing again
                        if (playing) {
                            timeline.play();
                        }
                    }
                }
                else {
                    let msg = {
                        type: 'abort',
                    };
                    ws.send(JSON.stringify(msg));
                    if (playing) {
                        timeline.play();
                    }
                    // this.aborted = false;
                }
            };
            let sendProgress = (frm, frms, prgrs) => {
                let progressString = (prgrs * 100).toFixed();
                let msg = `Sending frame ${frm +
                    1} of ${frms}, progress: ${progressString}%.`;
                this.messageStream.next(msg);
            };
            let showMessage = msg => {
                // console.log(msg);
                this.messageStream.next(msg);
            };
            let showError = err => {
                // console.log(err);
                this.rendering = false;
                this.aborted = true;
                this.errorStream.next(err);
            };
            // WebSocket bits starts here
            let ws = new WebSocket(settings.urls.renderVideoOnServer);
            ws.onopen = function (event) {
                // Stop the timeline
                if (playing) {
                    timeline.pause();
                }
                // Kick it all off with the manifest object
                ws.send(JSON.stringify(manifest));
            };
            // The onMessage callback is called whenever any message is received,
            // depending on the type of message (string / blob) a different
            // function is called
            let onMessage = event => {
                // console.log(typeof event.data);
                switch (typeof event.data) {
                    case 'string':
                        onString(event.data);
                        break;
                    case 'object':
                        onBlob(event.data);
                        break;
                }
            };
            // Called when a string message (JSON) is received
            let onString = jsonString => {
                let msg = JSON.parse(jsonString);
                // console.log(msg);
                switch (msg.action) {
                    case 'nextFrame':
                        nextFrame();
                        break;
                    case 'save':
                        // In an earlier implementation the fileName was set based on the 'save' message
                        // coming back from the server, it is now set on initialisation on the client
                        // fileName = msg.fileName;
                        break;
                    case 'message':
                        showMessage(msg.message);
                        break;
                    case 'error':
                        showError(msg.error);
                        break;
                    default:
                        throw new Error(`Unknown action: ${msg.action}`);
                        break;
                }
            };
            // Called when a blob is received (that's the video)
            let onBlob = data => {
                // console.log(data);
                let blob = new Blob([data]);
                // saveAs(blob, fileName);
                resolve({ blob, fileName });
                this.rendering = false;
            };
            ws.onmessage = onMessage;
        });
        return promise;
    }
};
RenderService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root',
    })
], RenderService);



/***/ }),

/***/ "../livecharts/src/lib/services/svg.service.ts":
/*!*****************************************************!*\
  !*** ../livecharts/src/lib/services/svg.service.ts ***!
  \*****************************************************/
/*! exports provided: SvgService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SvgService", function() { return SvgService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "../../node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _livecharts_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../livecharts.service */ "../livecharts/src/lib/livecharts.service.ts");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lodash */ "../../node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);



// import { FontDescriptor } from '../../lib/types/types';


let SvgService = class SvgService {
    constructor(livechartsService, http) {
        this.livechartsService = livechartsService;
        this.http = http;
    }
    splitText(text, removeEmptyLines) {
        let singleReturn = /\r\n|\n|\f/g;
        let lines = text.split(singleReturn);
        if (removeEmptyLines) {
            lines = lodash__WEBPACK_IMPORTED_MODULE_4__["filter"](lines, l => (l ? true : false));
        }
        return lines;
    }
    drawText({ selection, id, text, label, x = 0, y = 0, width = 500, lineHeightFactor = 1.2, bulletChar = '•', bulletIndent = 0, styles = {
        normal: {
            fill: '#000',
            'font-size': 18,
            'font-weight': '400',
            'text-anchor': 'start',
        },
        heading: {
        // '1': { 'font-size': 36 },
        // '2': { 'font-size': 32 },
        // '3': { 'font-size': 28 },
        // '4': { 'font-size': 24 },
        },
        star: {},
        dollar: {},
        hash: {},
        underscore: {},
    }, }) {
        let parseString = str => {
            // console.log(str);
            let acc = '';
            let remaining = str.trim();
            let list = [];
            let push = (type, nr) => {
                if (acc.length > 0) {
                    list.push({ type: 'text', value: acc });
                }
                acc = '';
                list.push({ type });
                remaining = remaining.slice(nr);
            };
            while (remaining.length > 0) {
                if (remaining.slice(0, 1) === ' ') {
                    push('space', 1);
                }
                else if (remaining.slice(0, 2) === '**') {
                    push('star', 2);
                }
                else if (remaining.slice(0, 2) === '$$') {
                    push('dollar', 2);
                }
                else if (remaining.slice(0, 2) === '##') {
                    push('hash', 2);
                }
                else if (remaining.slice(0, 2) === '__') {
                    push('underscore', 2);
                }
                else {
                    acc = acc + remaining.slice(0, 1);
                    remaining = remaining.slice(1);
                }
            }
            if (acc.length > 0) {
                // console.log(`acc: ${acc}, length: ${acc.length}`);
                list.push({ type: 'text', value: acc });
            }
            return list;
        };
        let renderBlocks = (selection, blocks) => {
            let state = {
                star: false,
                dollar: false,
                hash: false,
                underscore: false,
            };
            let lineY = y;
            // for (let block of blocks) {
            let index = 0;
            for (let i = 0; i < blocks.length; i++) {
                let block = blocks[i];
                // console.log(block);
                // console.log(i);
                // console.log(block.type);
                let fontSize;
                let textElement;
                let applyStyles = (element, styleObject) => {
                    lodash__WEBPACK_IMPORTED_MODULE_4__["map"](styleObject, (value, key) => {
                        element.style(key, key === 'font-size' ? `${value}px` : value);
                    });
                };
                let applyAllStyles = element => {
                    if (block.type === 'paragraph' || block.type === 'bullet') {
                        applyStyles(textElement, styles['normal']);
                    }
                    else if (block.type === 'heading') {
                        let style = styles['heading'][block.level];
                        applyStyles(textElement, styles['normal']);
                        applyStyles(textElement, style);
                    }
                    lodash__WEBPACK_IMPORTED_MODULE_4__["map"](Object.keys(state).sort(), key => {
                        let value = state[key];
                        if (value) {
                            element.classed(key, true);
                            applyStyles(element, styles[key]);
                        }
                    });
                };
                let stepLine = (color) => {
                    // selection.append('circle').attr('cx', x).attr('cy', lineY).attr('r', 2).style('fill', color || '#c00');
                    lineY = lineY + lineHeightFactor * styles.normal['font-size'];
                };
                if (block.type === 'empty') {
                    stepLine('#0c0');
                }
                else {
                    textElement = selection
                        .append('text')
                        .attr('x', x)
                        .attr('y', lineY)
                        .attr('id', `text-line-${label}-${index}`)
                        .attr('data-index', index)
                        .classed(`text-line-${label}-${id}`, true);
                    index++;
                    let currentElement;
                    let previousElement;
                    let bulletStep;
                    let justDrewBullet = false;
                    if (block.type === 'bullet') {
                        currentElement = textElement
                            .append('tspan')
                            .attr('dx', styles.normal['text-anchor'] === 'start' ? bulletIndent : 0)
                            .text(`${bulletChar}`);
                        applyAllStyles(currentElement);
                        currentElement = textElement
                            .append('tspan')
                            .attr('opacity', 0)
                            .text(`_`);
                        applyAllStyles(currentElement);
                        bulletStep = textElement.node().getBBox().width;
                        // console.log(bulletStep);
                    }
                    for (let segment of block.value) {
                        if (segment.type === 'text') {
                            currentElement = textElement.append('tspan').text(segment.value);
                            applyAllStyles(currentElement);
                            if (previousElement) {
                                let box = textElement.node().getBBox();
                                if (styles.normal['text-anchor'] === 'middle'
                                    ? box.width > width
                                    : box.x - x + box.width > width) {
                                    currentElement.remove();
                                    stepLine('#00c');
                                    textElement = selection
                                        .append('text')
                                        .attr('id', `text-line-${label}-${index}`)
                                        .attr('data-index', index)
                                        .classed(`text-line-${label}-${id}`, true)
                                        // .attr('x', block.type === 'bullet' ? bulletStep + x : x)
                                        .attr('x', block.type === 'bullet' &&
                                        styles.normal['text-anchor'] === 'start'
                                        ? bulletStep + x
                                        : x)
                                        .attr('y', lineY);
                                    index++;
                                    currentElement = textElement
                                        .append('tspan')
                                        .text(segment.value);
                                    applyAllStyles(currentElement);
                                }
                            }
                        }
                        else if (segment.type === 'space') {
                            currentElement = textElement.append('tspan').text(' ');
                            applyAllStyles(currentElement);
                        }
                        else if (segment.type === 'star') {
                            state.star = !state.star;
                        }
                        else if (segment.type === 'dollar') {
                            state.dollar = !state.dollar;
                        }
                        else if (segment.type === 'underscore') {
                            state.underscore = !state.underscore;
                        }
                        else if (segment.type === 'hash') {
                            state.hash = !state.hash;
                        }
                        previousElement = currentElement;
                    }
                }
                if (block.type !== 'empty') {
                    stepLine('#c00');
                }
            }
        };
        if (text) {
            let blocks = this.splitText(text);
            // console.log(blocks);
            blocks = lodash__WEBPACK_IMPORTED_MODULE_4__["map"](blocks, block => {
                if (block === '') {
                    return { type: 'empty', value: null };
                }
                else if (block.slice(0, 2) === '* ') {
                    return { type: 'bullet', value: parseString(block.slice(2)) };
                }
                else if (block.slice(0, 2) === '# ') {
                    return {
                        type: 'heading',
                        level: '1',
                        value: parseString(block.slice(2)),
                    };
                }
                else if (block.slice(0, 3) === '## ') {
                    return {
                        type: 'heading',
                        level: '2',
                        value: parseString(block.slice(3)),
                    };
                }
                else if (block.slice(0, 4) === '### ') {
                    return {
                        type: 'heading',
                        level: '3',
                        value: parseString(block.slice(4)),
                    };
                }
                else {
                    return { type: 'paragraph', value: parseString(block) };
                }
            });
            // console.log(blocks);
            renderBlocks(selection, blocks);
        }
    }
    generateEmbeddedFontCSS(fonts) {
        // Top level method to create a stylesheet with all the required font CSS
        // with the fonts base64 encoded in the CSS for the fonts in the parameters
        let promises = [];
        for (let font of fonts) {
            promises.push(this.generateFontStylesheet(font));
        }
        let promise = Promise.all(promises).then(stylesheets => {
            let stylesheetString = stylesheets.join('\n');
            return stylesheetString;
        });
        return promise;
    }
    generateFontStylesheet(font) {
        // For each font in this animation, dig up the information from the settings and
        // generate the stylesheet (this is different depending on where the font
        // comes from).
        let stylesheetPromise;
        let fontSettings = this.livechartsService.settings['fonts'];
        // Throw an error if the font information is not found
        let fontSetting = lodash__WEBPACK_IMPORTED_MODULE_4__["find"](fontSettings, fS => fS.fontFamily === font.fontFamily);
        if (!fontSetting) {
            throw new Error(`Font-family: ${font.fontFamily} not found in settings.`);
        }
        switch (fontSetting.type) {
            case 'google':
                // When it is a Google font call the appropriate method
                stylesheetPromise = this.generateGoogleFontCSS(font, fontSetting);
                break;
            case 'assets':
                // When it is a local font call the appropriate method
                stylesheetPromise = this.generateAssetFontCSS(font, fontSetting);
                break;
        }
        // Return the stylesheetPromise that was generated
        return stylesheetPromise;
    }
    generateGoogleFontCSS(font, setting) {
        // console.log(font);
        // console.log(setting);
        let promise = this.http
            .get(setting.url, { responseType: 'text' }) // Get the stylesheet from Google Fonts
            .toPromise()
            .then(css => {
            // console.log(css);
            let fontRegex = /\/*.*?}\n?/gms; // Split the stylesheet into chunks per @font-face declaration
            let allFonts = css.match(fontRegex);
            // console.log(allFonts);
            let promises = [];
            // Loop through all the fonts that should be embedded
            for (let stylesAndWeight of font.stylesAndWeights) {
                let regexString = `.*?font-family: '${font.fontFamily}';.*?font-style: ${stylesAndWeight.style};.*?font-weight: ${stylesAndWeight.weight};.*?}\n?`;
                let regex = new RegExp(regexString, 'gms');
                // Pull out only the fonts that we need
                let list = lodash__WEBPACK_IMPORTED_MODULE_4__["filter"](allFonts, str => regex.test(str));
                // console.log(list);
                for (let fontFace of list) {
                    // console.log(fontFace);
                    let urlRegex = /url\((.*?)\)/gms;
                    let match = urlRegex.exec(fontFace);
                    let url = match[1];
                    // console.log(match);
                    promises.push(this.downloadAndEncodeWoff2(url).then(fontString => {
                        // console.log(fontFace);
                        // console.log(match);
                        // console.log(url);
                        // console.log(fontString.length);
                        let replacementRegex = /url\(.*?\)/gms;
                        let cssString = fontFace.replace(replacementRegex, `url('${fontString}')`);
                        // console.log(cssString);
                        return cssString;
                    }));
                }
            }
            return Promise.all(promises).then(l => {
                let result = l.join('\n');
                return result;
            });
        });
        return promise;
    }
    downloadAndEncodeWoff2(url) {
        // console.log(url);
        let promise = this.http
            .get(url, { responseType: 'blob' })
            .toPromise()
            .then(blob => {
            let promise2 = new Promise(function (resolve, reject) {
                let reader = new FileReader();
                reader.onloadend = function () {
                    // It seems Typescript doesn't infer automatically that readAsDataURL
                    // returns a base64 encoded string...
                    let base64data = reader.result;
                    resolve(base64data);
                };
                reader.onerror = function (event) {
                    reject(new Error(`Base64 encoding failed`));
                };
                reader.readAsDataURL(blob);
            });
            return promise2;
        });
        return promise;
    }
    generateAssetFontCSS(font, setting) {
        // console.log('generateAssetFontCSS');
        let urlString = `assets/fonts/${setting.fileName}`;
        let promise = this.downloadAndEncodeWoff2(urlString).then(base64data => {
            let cssString = `@font-face {
        font-family: '${setting.fontFamily}';
        font-style: ${setting.fontStyle};
        font-weight: ${setting.fontWeight};
        font-display: swap;
        src: url('${base64data}');
      }`;
            return cssString;
        });
        return promise;
    }
};
SvgService.ctorParameters = () => [
    { type: _livecharts_service__WEBPACK_IMPORTED_MODULE_3__["LivechartsService"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
SvgService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root',
    })
], SvgService);



/***/ }),

/***/ "../livecharts/src/lib/services/util.service.ts":
/*!******************************************************!*\
  !*** ../livecharts/src/lib/services/util.service.ts ***!
  \******************************************************/
/*! exports provided: UtilService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UtilService", function() { return UtilService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");


let UtilService = class UtilService {
    constructor() { }
    generateID(length) {
        let text = '';
        let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
        for (let i = 0; i < length; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return text;
    }
    test() {
        // https://gist.github.com/viljamis/c4016ff88745a0846b94
        // https://github.com/Fetten/woff2base64/blob/master/src/woff2base64.js
        // let promise = this.http
        //   .get('assets/fonts/AkkoPro-Regular.woff2', { responseType: 'blob' })
        //   .toPromise()
        //   .then(blob => {
        //     // console.log(blob);
        //     let promise2 = new Promise(function(resolve, reject) {
        //       let reader = new FileReader();
        //       reader.onloadend = function() {
        //         let base64data = reader.result;
        //         resolve(base64data);
        //         // console.log(base64data);
        //       };
        //       reader.onerror = function(event) {
        //         reject(new Error(`Base64 encoding failed`));
        //       };
        //       reader.readAsDataURL(blob);
        //     });
        //     return promise2;
        //   });
        // return promise;
    }
};
UtilService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root',
    })
], UtilService);



/***/ }),

/***/ "../livecharts/src/lib/services/videoRecorder.ts":
/*!*******************************************************!*\
  !*** ../livecharts/src/lib/services/videoRecorder.ts ***!
  \*******************************************************/
/*! exports provided: VideoRecorder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VideoRecorder", function() { return VideoRecorder; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! rxjs */ "../../node_modules/rxjs/_esm2015/index.js");
/// <reference types="@types/dom-mediacapture-record" />
// TODO: there must be a better way to reference the types for the MediaRecorder, figure it out


class VideoRecorder {
    constructor(svgElement, timeline, frameRate, width, height, canvas, backgroundColor) {
        this.svgElement = svgElement;
        this.timeline = timeline;
        this.frameRate = frameRate;
        this.width = width;
        this.height = height;
        this.canvas = canvas;
        this.backgroundColor = backgroundColor;
        this.recorderData = [];
        this.aborted = false;
        this.progressSubject = new rxjs__WEBPACK_IMPORTED_MODULE_1__["BehaviorSubject"](null);
        this.progressObservable = this.progressSubject.asObservable();
        this.log = {
            elapsedAverage: 0,
            elapsedList: [],
            elapsedTotal: 0,
            endTime: null,
            frames: 0,
            lastFrame: null,
            logFrame(frameNr) {
                let now = performance.now();
                this.frames++;
                if (!this.startTime) {
                    this.startTime = now;
                }
                this.elapsedTotal = now - this.startTime;
                if (this.previousTime) {
                    let elapsed = now - this.previousTime;
                    this.elapsedList.push(elapsed);
                    this.elapsedAverage = this.elapsedTotal / this.frames;
                }
                if (this.lastFrame !== null && frameNr - this.lastFrame > 1) {
                    this.skippedFrames += frameNr - this.lastFrame - 1;
                }
                this.lastFrame = frameNr;
                this.previousTime = now;
            },
            log() {
                console.log(`${this.frames} frames rendered`);
                console.log(`${this.skippedFrames} frames skipped`);
                console.log(`${this.elapsedTotal.toFixed(0)}ms total`);
            },
            logObject() {
                return {
                    elapsedAverage: this.elapsedAverage,
                    elapsedList: this.elapsedList,
                    elapsedTotal: this.elapsedTotal,
                    endTime: this.endTime,
                    frames: this.frames,
                    skippedFrames: this.skippedFrames,
                    startTime: this.startTime,
                };
            },
            previousTime: null,
            skippedFrames: 0,
            startTime: null,
            stop() {
                this.endTime = performance.now();
                this.elapsedTotal = this.endTime - this.startTime;
            },
        };
        // Store the state of the timeline
        this.previousProgress = timeline.progress();
        this.timelineWasPaused = timeline.paused();
        // Pause the timeline
        timeline.paused(true);
        // Calculate the nr of frames to be rendered
        this.frames = Math.floor(timeline.duration() * frameRate);
        this.duration = timeline.duration() * 1000;
        // Create the canvas from which to record
        if (!this.canvas) {
            this.canvas = document.createElement('canvas');
            this.canvas.width = this.width;
            this.canvas.height = this.height;
        }
        else {
            this.canvas.width = width;
            this.canvas.height = height;
        }
        this.context = this.canvas.getContext('2d');
        // console.log(`frameRate: ${frameRate}`);
        // console.log(`frames: ${this.frames}`);
        // console.log(`duration: ${this.duration}`);
    }
    record(bps) {
        let drawBackgroundColor = () => {
            // console.log(this.backgroundColor);
            if (this.backgroundColor) {
                this.context.fillStyle = this.backgroundColor;
                this.context.fillRect(0, 0, this.width, this.height);
            }
        };
        let drawFrameToCanvas = (frame) => {
            this.currentFramePromise = new Promise((resolve, reject) => {
                this.log.logFrame(frame);
                this.currentFrame = frame;
                let progressForFrame = frame / this.frames;
                this.timeline.progress(progressForFrame);
                let xml = new XMLSerializer().serializeToString(this.svgElement);
                let blob = new Blob([xml], { type: 'image/svg+xml' });
                let img = new Image();
                img.crossOrigin = 'Anonymous';
                img.onload = () => {
                    drawBackgroundColor();
                    this.context.drawImage(img, 0, 0, this.context.canvas.width, this.context.canvas.height);
                    this.progressSubject.next(progressForFrame);
                    resolve(img);
                };
                img.onerror = () => {
                    reject(new Error(`Failed to load image for frame ${frame}`));
                };
                img.src = URL.createObjectURL(blob);
            });
            return this.currentFramePromise;
        };
        let nextFrame = () => {
            let now = performance.now();
            this.elapsedTime = now - this.startTime;
            let progress = this.elapsedTime / this.duration;
            let frame = Math.ceil(this.frames * progress);
            if (this.currentFrame === frame || progress === 0) {
                this.timeOutReference = setTimeout(() => nextFrame(), 5);
            }
            else if (this.elapsedTime > this.duration) {
                drawFrameToCanvas(this.frames).then(() => {
                    this.timeOutReference = setTimeout(() => {
                        this.recorder.stop();
                        this.log.stop();
                        // this.log.log();
                        // console.log(this.log.logObject());
                    }, 5);
                });
            }
            else if (this.currentFrame !== null && this.currentFrame < frame) {
                if (!this.aborted) {
                    drawFrameToCanvas(frame).then(() => {
                        nextFrame();
                    });
                }
                else {
                    this.recorder.stop();
                    this.log.stop();
                }
            }
        };
        let promise = drawFrameToCanvas(1).then(img => {
            return new Promise((resolve, reject) => {
                // console.log(this.frameRate);
                // @ts-ignore
                let stream = this.canvas.captureStream(this.frameRate);
                let recorderOptions = { mimeType: 'video/webm' };
                if (bps) {
                    recorderOptions['videoBitsPerSecond'] = bps;
                }
                this.recorder = new MediaRecorder(stream, recorderOptions);
                this.recorder.ondataavailable = event => {
                    if (event.data && event.data.size) {
                        this.recorderData.push(event.data);
                    }
                };
                this.recorder.onstop = () => {
                    let blob = new Blob(this.recorderData, { type: 'video/webm' });
                    this.timeline.paused(this.timelineWasPaused);
                    this.timeline.progress(this.previousProgress);
                    resolve(blob);
                };
                this.startTime = performance.now();
                this.recorder.start();
                nextFrame();
            });
        });
        return promise;
    }
    recordFramesToCache(bps) {
        // This is the method being used at the moment, first all images are cached
        // only then are they recorded from the canvas
        let drawBackgroundColor = () => {
            // Drawing a transparent PNG to the canvas results in a non-transparent
            // video with a black background and a buggy looking animation,
            // set a background color in the metadata of the parameters to be drawn with this method.
            if (this.backgroundColor) {
                this.context.fillStyle = this.backgroundColor;
                this.context.fillRect(0, 0, this.width, this.height);
            }
        };
        return new Promise((resolve, reject) => {
            let images = [];
            let currentFrame = 1;
            let nextFrameToImage = () => {
                if (this.aborted) {
                    resolve(null);
                }
                else if (currentFrame <= this.frames) {
                    let progress = currentFrame / this.frames;
                    this.timeline.progress(progress);
                    let xml = new XMLSerializer().serializeToString(this.svgElement);
                    let blob = new Blob([xml], { type: 'image/svg+xml' });
                    let img = new Image();
                    img.crossOrigin = 'Anonymous';
                    img.onload = () => {
                        images.push(img);
                        let p = currentFrame / (this.frames * 2);
                        this.progressSubject.next(p);
                        if (!this.aborted) {
                            nextFrameToImage();
                        }
                    };
                    img.src = URL.createObjectURL(blob);
                    currentFrame++;
                }
                else {
                    resolve(images);
                }
            };
            nextFrameToImage();
        }).then(images => {
            if (!images) {
                return;
            }
            else {
                return new Promise((resolve, reject) => {
                    let currentFrame = 1;
                    let nextFrame = () => {
                        let now = performance.now();
                        this.elapsedTime = now - this.startTime;
                        let progress = this.elapsedTime / this.duration;
                        let frame = Math.ceil(this.frames * progress);
                        // console.log(`elapsed: ${this.elapsedTime}, frame: ${frame}, frame < frames ${frame < this.frames}`);
                        if (currentFrame === frame || progress === 0) {
                            this.timeOutReference = setTimeout(() => nextFrame(), 5);
                        }
                        else if (this.elapsedTime > this.duration) {
                            this.log.logFrame(frame);
                            drawBackgroundColor();
                            let img = images[this.frames - 1];
                            this.context.drawImage(img, 0, 0, this.context.canvas.width, this.context.canvas.height);
                            this.recorder.stop();
                            this.log.stop();
                            this.log.log();
                            // console.log(this.log.logObject());
                        }
                        else if (currentFrame !== null && currentFrame < frame) {
                            this.log.logFrame(frame);
                            drawBackgroundColor();
                            let img = images[frame - 1];
                            this.context.drawImage(img, 0, 0, this.context.canvas.width, this.context.canvas.height);
                            currentFrame = frame;
                            this.progressSubject.next(0.5 + frame / (this.frames * 2));
                            this.timeOutReference = setTimeout(() => nextFrame(), 5);
                        }
                    };
                    drawBackgroundColor();
                    this.context.drawImage(images[0], 0, 0, this.context.canvas.width, this.context.canvas.height);
                    // console.log(this.frameRate);
                    // @ts-ignore
                    let stream = this.canvas.captureStream(this.frameRate);
                    let recorderOptions = { mimeType: 'video/webm' };
                    if (bps) {
                        recorderOptions['videoBitsPerSecond'] = bps;
                    }
                    this.recorder = new MediaRecorder(stream, recorderOptions);
                    this.recorder.ondataavailable = event => {
                        if (event.data && event.data.size) {
                            this.recorderData.push(event.data);
                        }
                    };
                    this.recorder.onstop = () => {
                        let blob = new Blob(this.recorderData, { type: 'video/webm' });
                        this.timeline.paused(this.timelineWasPaused);
                        this.timeline.progress(this.previousProgress);
                        resolve(blob);
                    };
                    this.startTime = performance.now();
                    this.recorder.start();
                    nextFrame();
                    // images.forEach((image) => document.body.appendChild(image));
                });
            }
        });
    }
    abort() {
        this.aborted = true;
        if (this.timeOutReference) {
            clearTimeout(this.timeOutReference);
        }
        return;
    }
}


/***/ }),

/***/ "../livecharts/src/lib/settings.ts":
/*!*****************************************!*\
  !*** ../livecharts/src/lib/settings.ts ***!
  \*****************************************/
/*! exports provided: settings */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "settings", function() { return settings; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");

// Default settings, can be overridden in the projects
let settings = {
    client: 'The Brighthouse',
    project: 'Livecharts',
    urls: {
        renderVideoOnServer: 'wss://render.livecharts.nl',
    },
    frameRate: {
        min: 24,
        max: 60,
        default: 30,
    },
    editor: {
        scalable: true,
        playing: 'pause',
        slices: true,
    },
    overview: {
        scalable: true,
        playing: 'pause',
        slices: false,
    },
    // scalable: {
    //   overview: true,
    //   editor: true,
    // },
    showSlices: true,
    slices: {
        fill: 'none',
        stroke: '#D00',
        strokeWidth: '1',
        strokeDashArray: '4',
    },
    // playing: {
    //   overview: 'pause',
    //   editor: 'pause',
    // },
    paths: {
        overview: 'overview',
        editor: 'editor',
    },
    fonts: [],
};


/***/ }),

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./src/app/animations/animations.module.ts":
/*!*************************************************!*\
  !*** ./src/app/animations/animations.module.ts ***!
  \*************************************************/
/*! exports provided: AnimationsModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimationsModule", function() { return AnimationsModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _test_test_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./test/test.component */ "./src/app/animations/test/test.component.ts");
var AnimationsModule_1;

// import { NgModule } from '@angular/core';


const components = [_test_test_component__WEBPACK_IMPORTED_MODULE_2__["TestComponent"]];
let AnimationsModule = AnimationsModule_1 = class AnimationsModule {
    static forRoot() {
        return {
            ngModule: AnimationsModule_1,
        };
    }
};
AnimationsModule = AnimationsModule_1 = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: components,
        entryComponents: components,
        exports: components,
    })
], AnimationsModule);



/***/ }),

/***/ "./src/app/animations/animations.ts":
/*!******************************************!*\
  !*** ./src/app/animations/animations.ts ***!
  \******************************************/
/*! exports provided: animations */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "animations", function() { return animations; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _test_test_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./test/test.component */ "./src/app/animations/test/test.component.ts");
/* harmony import */ var _test_test_params__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./test/test.params */ "./src/app/animations/test/test.params.ts");



let animations = [
    {
        id: 'overlays',
        label: 'Video overlays',
        values: [
            {
                id: 'test-component-01',
                name: 'Test component T01',
                component: _test_test_component__WEBPACK_IMPORTED_MODULE_1__["TestComponent"],
                params: _test_test_params__WEBPACK_IMPORTED_MODULE_2__["params"],
            },
        ],
    },
];


/***/ }),

/***/ "./src/app/animations/test/test.component.scss":
/*!*****************************************************!*\
  !*** ./src/app/animations/test/test.component.scss ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJwcm9qZWN0cy9kb2dmaWdodC9zcmMvYXBwL2FuaW1hdGlvbnMvdGVzdC90ZXN0LmNvbXBvbmVudC5zY3NzIn0= */");

/***/ }),

/***/ "./src/app/animations/test/test.component.ts":
/*!***************************************************!*\
  !*** ./src/app/animations/test/test.component.ts ***!
  \***************************************************/
/*! exports provided: TestComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TestComponent", function() { return TestComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _livecharts_src_lib_livechart_livechart_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../../livecharts/src/lib/livechart/livechart.component */ "../livecharts/src/lib/livechart/livechart.component.ts");
/* harmony import */ var _livecharts_src_lib_livecharts_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../../livecharts/src/lib/livecharts.service */ "../livecharts/src/lib/livecharts.service.ts");
/* harmony import */ var _livecharts_src_lib_services_util_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../../livecharts/src/lib/services/util.service */ "../livecharts/src/lib/services/util.service.ts");
/* harmony import */ var _livecharts_src_lib_services_svg_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../../livecharts/src/lib/services/svg.service */ "../livecharts/src/lib/services/svg.service.ts");





// import { RenderService } from '../../../../../livecharts/src/lib/services/render.service';

let g, s;
let TestComponent = class TestComponent extends _livecharts_src_lib_livechart_livechart_component__WEBPACK_IMPORTED_MODULE_2__["LivechartBaseComponent"] {
    constructor(livechartsService, utilService, svgService) {
        super(livechartsService, utilService, svgService);
        this.livechartsService = livechartsService;
        this.utilService = utilService;
        this.svgService = svgService;
        this.blurme = '#noblur';
        g = (id) => this.values[id]; // Method to succinctly dig-up a parameter
        s = (id, value) => {
            // Same but for setting a parameter value
            this.values[id] = value;
        };
    }
    initializeLivechart() {
        super.initializeLivechart();
    }
    createElements() {
        super.createElements();
        let contentGroup = this.svgSelection.select(`#content-${this.id}`);
        contentGroup.selectAll('*').remove();
        // Draw background image
        let backgroundGroup = this.svgSelection.select(`#background-${this.id}`);
        backgroundGroup.select(`#backgroundblur-${this.id}`);
        backgroundGroup.selectAll('*').remove();
        let patternGroup = this.svgSelection.select(`#pattern-${this.id}`);
        patternGroup.selectAll('*').remove();
        let box = contentGroup.node().getBBox();
        let photoOptions = {
            selection: patternGroup,
            id: this.id,
            url: g('photo'),
            label: 'main-foto',
            x: 0,
            y: 0,
            width: 1080,
            height: 1080,
        };
        if (g('photo')) {
            this.drawImageInPattern(patternGroup, photoOptions, true);
            this.drawBackgroundImage(backgroundGroup);
        }
        else {
            let rect = backgroundGroup.append('rect')
                .attr('id', `backgroundLogo-${this.id}`)
                .attr('x', 0)
                .attr('y', 0)
                .style('opacity', 0)
                .attr('width', g('width'))
                .attr('height', g('height'))
                .attr('fill', `#ffffff`);
        }
        let rectangleGroup = contentGroup.append('g');
        let textGroup = contentGroup.append('g');
        let textSubGroup = textGroup.append('g');
        let styles = {
            normal: {
                fill: g('textColor'),
                'font-size': 40,
                'font-weight': '400',
                'text-anchor': g('textAnchor'),
                'font-family': g('fontFamily'),
            },
            heading: {},
            star: {},
            dollar: {},
            hash: {},
            underscore: {},
        };
        let widthTextRect = g('widthRect') - (g('rectangleMarginSide'));
        console.log(widthTextRect);
        let xValueText = g('textAnchor') === 'middle' ? g('widthRect') / 2 : g('textAnchor') === 'start' ? g('rectangleMarginSide') : g('widthRect') - g('rectangleMarginSide');
        // To do: align right
        let options = {
            selection: textSubGroup,
            id: this.id,
            text: g('text'),
            label: 'main-text',
            x: xValueText,
            y: 200,
            width: widthTextRect,
            styles,
        };
        this.svgService.drawText(options);
        let firstText = textSubGroup.select('text:first-child');
        box = firstText.node().getBBox();
        let deltaX = 30;
        let deltaY = 20;
        // textSubGroup
        //   .append('g')
        //   .attr('transform', `rotate(180 ${box.x - deltaX} ${box.y - deltaY})`)
        //   .append('text')
        //   .attr('x', box.x - deltaX)
        //   .attr('y', box.y - deltaY)
        //   .style('fill', '#FFF')
        //   .style('text-anchor', 'end')
        //   .style('letter-spacing', 3)
        //   .style('font-size', 80)
        //   .style('font-weight', 500)
        //   .style('font-style', 'italic')
        //   .style('font-family', 'Open Sans')
        //   .style('dominant-baseline', 'middle')
        //   .text("''");
        // let lastText = textSubGroup.select('text:last-child');
        // Position text
        box = contentGroup.node().getBBox();
        console.log(box.width);
        textSubGroup.attr('transform', `translate(0 ${g('height') -
            box.y -
            box.height -
            g('distanceFromBottom')})`);
        box = textGroup.node().getBBox();
        // Do some math
        let boxHeight = box.height + 2 * g('rectangleMargin');
        let boxWidth = box.width;
        let rectHeight;
        if (g('rectangleAngle') === 0) {
            rectHeight = boxHeight;
        }
        else {
            let a = boxHeight / 2 / Math.tan(Math.abs(g('rectangleAngle') * Math.PI) / 180);
            let a1 = a + boxWidth / 2;
            let b1 = ((boxHeight / 2) * a1) / a;
            rectHeight =
                2 * Math.cos(Math.abs(g('rectangleAngle') * Math.PI) / 180) * b1;
        }
        // console.log(`rectHeight: ${rectHeight}`);
        // Draw rectangle
        let yTopOfRectangle = box.y + box.height / 2 - rectHeight / 2;
        this.yLogo = yTopOfRectangle - 190 / 1.2;
        // let rectangel fill whole width from livechart
        let rectFill = g('widthRect') === g('width') ? 200 : 0;
        console.log(('widthRect'));
        console.log(rectFill);
        rectangleGroup
            .append('rect')
            .attr('x', -rectFill)
            .attr('y', yTopOfRectangle)
            .attr('width', g('widthRect') + 2 * rectFill)
            .attr('height', rectHeight)
            .style('fill', g('rectangleColor'));
        rectangleGroup.attr('transform', `rotate(${g('rectangleAngle')} ${g('width') / 2} ${box.y +
            box.height / 2})`);
    }
    drawImageInPattern(selection, imageData, embedImage) {
        let g = (k) => this.values[k];
        let id = `pattern-${this.id}`;
        let url = imageData['url'];
        let scaleX = g('width') / imageData['width'];
        let scaleY = g('height') / imageData['height'];
        let scale = Math.max(scaleX, scaleY);
        let factor = (g('scaleBg') || 1) * scale;
        // Center the image horizontally
        let tlX = ((g('width') - factor * imageData['width']) / 2) + (g('translateBgX') || 0);
        // Avoid moving the image off the screen
        tlX = Math.min(0, tlX);
        tlX = Math.max(-factor * imageData['width'] + g('width'), tlX);
        // Center the image vertically
        let tlY = ((g('height') - factor * imageData['height']) / 2) + (g('translateBgY') || 0);
        // Avoid moving the image off the screen
        tlY = Math.min(0, tlY);
        tlY = Math.max(-factor * imageData['height'] + g('height'), tlY);
        let image = selection.append('image')
            .attr('xlink:href', url)
            .attr('x', tlX)
            .attr('y', tlY)
            .attr('width', factor * imageData['width'])
            .attr('height', factor * imageData['height']);
    }
    drawBackgroundImage(selection) {
        let g = (k) => this.values[k];
        let rect = selection.append('rect')
            .attr('id', `image-${this.id}`)
            .attr('x', 0)
            .attr('y', 0)
            .style('opacity', 1)
            .attr('width', g('width'))
            .attr('height', g('height'))
            .attr('fill', `url(#pattern-${this.id})`);
    }
    createAnimation() {
        super.createAnimation();
        // let serializer = new XMLSerializer();
        // let str = serializer.serializeToString(this.svgSelection.node());
        this.xLogo = -190 / 2 + Number(g('width')) / 2;
        if (g('animationMic') === 'slideFromTop') {
            this.animation.set({}, {}, '+=2');
            this.animation.set({}, {}, 'positionForStill-1');
            this.animation.fromTo(`#mic-${this.id}`, 1, { attr: { x: this.xLogo, y: -200 } }, { attr: { y: this.yLogo, x: this.xLogo } });
            this.animation.set({}, {}, 'positionForStill-2');
            this.animation.set({}, {}, '+=2');
        }
        if (g('animationMic') === 'slideFromLeft') {
            this.animation.set({}, {}, '+=2');
            this.animation.set({}, {}, 'positionForStill-1');
            this.animation.fromTo(`#mic-${this.id}`, 1, { attr: { x: -200, y: this.yLogo } }, { attr: { y: this.yLogo, x: this.xLogo } });
            this.animation.set({}, {}, 'positionForStill-2');
            this.animation.set({}, {}, '+=2');
        }
        if (g('animationMic') === 'bounceFromTop') {
            let bounces = 5;
            let height = -400;
            let time = 0.5;
            let yDecay = height / bounces;
            let tDecay = time / bounces;
            // let timeline = new TimelineMax({ repeat: -1, repeatDelay: 2 });
            //  this.animation.from(`#mic-${this.id}` , time, { attr: { x: this.xLogo , y: -this.yLogo - 200} })
            // this.animation.to(`#mic-${this.id}` , time, { ease: 'sine.out', y: 0 });
            this.animation.fromTo(`#micGroup-${this.id}`, time, { y: -this.yLogo - 200, opacity: 0 }, { ease: 'sine.out', y: 0, opacity: 1 });
            for (let i = 0; i < bounces; i++) {
                this.animation.to(`#micGroup-${this.id}`, time -= tDecay, {
                    y: height -= yDecay,
                    ease: 'sine.in',
                    repeat: 1,
                    yoyo: true
                });
            }
            this.animation.set({}, {}, '+=2');
        }
        if (g('animationMic') === 'none') {
            this.animation.set({}, {}, '+=5');
        }
        if (true) {
            this.animation.set({}, {}, '+=2');
            this.animation.to(`#micGroup-${this.id}`, { opacity: 0 });
            this.animation.to(`#content-${this.id}`, { opacity: 0 });
            this.animation.to(`#image-${this.id}`, { opacity: 0 });
            if (g('backgroundLogo') !== 'none') {
                this.animation.to(`#backgroundLogo-${this.id}`, { opacity: 1, fill: g('backgroundLogo') });
            }
            this.animation.fromTo(`#logo-${this.id}`, 2.5, { opacity: 0 }, { opacity: 1 });
            // this.animation.to(`#background-${this.id}` , {filter: 'url(#blur)'}, 'clear');
        }
        if (false) {}
    }
};
TestComponent.ctorParameters = () => [
    { type: _livecharts_src_lib_livecharts_service__WEBPACK_IMPORTED_MODULE_3__["LivechartsService"] },
    { type: _livecharts_src_lib_services_util_service__WEBPACK_IMPORTED_MODULE_4__["UtilService"] },
    { type: _livecharts_src_lib_services_svg_service__WEBPACK_IMPORTED_MODULE_5__["SvgService"] }
];
TestComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-test',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./test.component.html */ "../../node_modules/raw-loader/dist/cjs.js!./src/app/animations/test/test.component.html")).default,
        encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].None,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./test.component.scss */ "./src/app/animations/test/test.component.scss")).default]
    })
], TestComponent);



/***/ }),

/***/ "./src/app/animations/test/test.params.ts":
/*!************************************************!*\
  !*** ./src/app/animations/test/test.params.ts ***!
  \************************************************/
/*! exports provided: params */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "params", function() { return params; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");

let params = {
    parameters: {
        size: {
            default: [1080, 1080],
            label: 'Afmeting',
            values: [
                {
                    value: [1080, 1080],
                    label: '1080 x 1080',
                },
                {
                    value: [600, 600],
                    label: '600 x 600',
                },
            ],
            control: 'standard-select',
            description: 'Afmeting',
        },
        width: {
            default: 1080,
            label: 'Breedte',
        },
        height: {
            default: 1080,
            label: 'Hoogte',
        },
        photo: {
            default: null,
            label: 'Foto',
            control: 'standard-photo',
        },
        text: {
            default: 'HET IS DIGITAL, HET IS EEN DIGITALE ACTIVITEIT, EN DAT MAAKT HET ZO ANDERS IN DE BENADERING.',
            label: 'Textarea',
            control: 'standard-textarea',
        },
        textAnchor: {
            default: 'middle',
            label: 'Uitlijning tekst',
            values: [
                {
                    value: 'middle',
                    label: 'midden',
                },
                {
                    value: 'start',
                    label: 'links',
                },
            ],
            control: 'standard-select',
        },
        textColor: {
            label: 'Kleur tekst',
            default: '#FFFFFF',
            required: true,
            control: 'standard-control',
        },
        fontFamily: {
            default: 'Open Sans',
            label: 'Font tekst',
            values: [
                {
                    value: 'Open Sans',
                    label: 'Open Sans',
                },
            ],
            control: 'standard-select',
        },
        blurImage: {
            label: 'Blur image',
            default: 15,
            required: false,
            min: 0,
            max: 30,
            step: 1,
            control: 'standard-number',
        },
        distanceFromBottom: {
            label: 'Afstand vanaf onderkant ',
            default: 100,
            required: true,
            min: 0,
            max: 1080,
            step: 10,
            control: 'standard-number',
        },
        rectangleAngle: {
            label: 'Hoek achtergrond',
            default: -3,
            min: -15,
            max: 15,
            step: 1,
            thumbLabel: true,
            control: 'standard-slider',
        },
        widthRect: {
            label: 'Breede banner ',
            default: 1080,
            required: true,
            min: 500,
            max: 1080,
            step: 10,
            control: 'standard-number',
        },
        rectangleMargin: {
            label: 'Marge rond tekst boven en onder',
            default: 30,
            required: true,
            min: 0,
            max: 200,
            step: 10,
            control: 'standard-number',
        },
        rectangleMarginSide: {
            label: 'Marge rond tekst rechts en links',
            default: 200,
            required: true,
            min: 50,
            max: 350,
            step: 10,
            control: 'standard-number',
        },
        rectangleColor: {
            label: 'Kleur achtergrond',
            default: '#a12422',
            required: true,
            control: 'standard-control',
        },
        fillLogo: {
            default: false,
            label: 'Kleur Dogfight logo',
            values: [
                {
                    value: false,
                    label: 'kleur',
                },
                {
                    value: true,
                    label: 'wit',
                },
            ],
            control: 'standard-select',
        },
        backgroundLogo: {
            default: 'none',
            label: 'Kies achtergrond Dogfight logo',
            values: [
                {
                    value: 'none',
                    label: 'geen',
                },
                {
                    value: '#b10f1f',
                    label: 'rood',
                },
                {
                    value: '#00609c',
                    label: 'blauw',
                },
            ],
            control: 'standard-select',
        },
        animationMic: {
            default: 'slideFromTop',
            label: 'Select settings microfoon',
            values: [
                {
                    value: 'slideFromTop',
                    label: 'Animatie: Slide van boven',
                },
                {
                    value: 'slideFromLeft',
                    label: 'Animatie: Slide van links',
                },
                {
                    value: 'bounceFromTop',
                    label: 'Animatie: Stuiter van boven',
                },
                {
                    value: 'none',
                    label: 'Animatie: Geen',
                },
                {
                    value: 'doNotShowAtAll',
                    label: 'Niet tonen',
                },
            ],
            control: 'standard-select',
        },
        bla: {
            label: 'Bla',
            default: 'Some text...',
            // description: 'Tooltip with a description of what this parameter does.',
            // hint: 'This is a hint! Get it?',
            required: true,
            // TODO: implement validation below!
            validations: [
                value => value.length >= 5
                    ? null
                    : `Value: ${value} of length ${value.length} too short, minimum length is 5.`,
            ],
            control: 'standard-control',
        },
        check: {
            label: 'Check',
            default: false,
            control: 'standard-checkbox',
            description: 'NOT IMPLEMENTED',
            hint: 'NOT IMPLEMENTED',
        },
        slide: {
            label: 'Slide me',
            default: true,
            color: 'accent',
            control: 'standard-slide',
            labelPosition: 'before',
            description: 'NOT IMPLEMENTED',
            hint: 'NOT IMPLEMENTED',
        },
        slider: {
            label: 'Slider me',
            default: 44,
            min: 20,
            max: 60,
            step: 1,
            thumbLabel: true,
            // tickInterval: 'auto',
            control: 'standard-slider',
            description: 'NOT IMPLEMENTED',
            hint: 'NOT IMPLEMENTED',
        },
    },
    timings: {
        scene1: {
            label: 'Scene 1',
            default: 1,
            min: 0,
            step: 0.25,
            control: 'standard-number',
        },
        pause1: {
            label: 'Pause 1',
            default: 2,
            min: 0,
            step: 0.25,
            control: 'standard-number',
        },
        scene2: {
            label: 'Scene 2',
            default: 1.5,
            min: 0,
            step: 0.25,
            control: 'standard-number',
        },
    },
    parameterGroups: [
        {
            title: 'Primair',
            // description: 'More info on this control group',
            collapsed: false,
            ids: [
                'size',
                'photo',
                'text',
                'textAnchor',
                'rectangleColor',
                'distanceFromBottom',
                'rectangleAngle',
                'widthRect',
                'animationMic',
                'fillLogo',
                'backgroundLogo'
            ],
        },
        {
            title: 'Secundair',
            collapsed: true,
            ids: ['rectangleMarginSide'],
        },
    ],
    timingGroups: [
        {
            title: 'Group 1',
            collapsed: false,
            ids: ['scene1', 'pause1', 'scene2'],
        },
    ],
    metadata: {
        category: 'animation',
        outputTypes: ['png', 'video'],
        fonts: [
            {
                fontFamily: 'Open Sans',
                stylesAndWeights: [{ style: 'normal', weight: 400 }],
            },
        ],
        backgroundColor: '#FF1',
    },
};


/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _livecharts_src_lib_livecharts_module__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../livecharts/src/lib/livecharts.module */ "../livecharts/src/lib/livecharts.module.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "../../node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _livecharts_src_lib_overview_basic_overview_basic_overview_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../livecharts/src/lib/overview/basic-overview/basic-overview.component */ "../livecharts/src/lib/overview/basic-overview/basic-overview.component.ts");
/* harmony import */ var _livecharts_src_lib_editor_basic_editor_basic_editor_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../livecharts/src/lib/editor/basic-editor/basic-editor.component */ "../livecharts/src/lib/editor/basic-editor/basic-editor.component.ts");




// TOGGLE_LCS_HERE
// import { BasicOverviewComponent } from 'livecharts';
// import { BasicEditorComponent } from 'livecharts';


// You can change the routing, just also change the routing in the settings
const routes = [
    { path: 'editor', component: _livecharts_src_lib_editor_basic_editor_basic_editor_component__WEBPACK_IMPORTED_MODULE_5__["BasicEditorComponent"] },
    { path: 'editor/:animationID', component: _livecharts_src_lib_editor_basic_editor_basic_editor_component__WEBPACK_IMPORTED_MODULE_5__["BasicEditorComponent"] },
    { path: 'overview', component: _livecharts_src_lib_overview_basic_overview_basic_overview_component__WEBPACK_IMPORTED_MODULE_4__["BasicOverviewComponent"] },
    { path: 'overview/:overviewGroup', component: _livecharts_src_lib_overview_basic_overview_basic_overview_component__WEBPACK_IMPORTED_MODULE_4__["BasicOverviewComponent"] },
    { path: '', redirectTo: '/overview', pathMatch: 'full' },
];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_livecharts_src_lib_livecharts_module__WEBPACK_IMPORTED_MODULE_2__["LivechartsModule"], _angular_router__WEBPACK_IMPORTED_MODULE_3__["RouterModule"].forRoot(routes)],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_3__["RouterModule"]],
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.scss":
/*!************************************!*\
  !*** ./src/app/app.component.scss ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("#livecharts-home {\n  cursor: pointer;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInByb2plY3RzL2RvZ2ZpZ2h0L3NyYy9hcHAvQzpcXFdlYnN0b3JtUHJvamVjdHNcXGxpdmVjaGFydHNEb2dmaWdodC9wcm9qZWN0c1xcZG9nZmlnaHRcXHNyY1xcYXBwXFxhcHAuY29tcG9uZW50LnNjc3MiLCJwcm9qZWN0cy9kb2dmaWdodC9zcmMvYXBwL2FwcC5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGVBQUE7QUNDRiIsImZpbGUiOiJwcm9qZWN0cy9kb2dmaWdodC9zcmMvYXBwL2FwcC5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIiNsaXZlY2hhcnRzLWhvbWUge1xyXG4gIGN1cnNvcjogcG9pbnRlcjtcclxufVxyXG4iLCIjbGl2ZWNoYXJ0cy1ob21lIHtcbiAgY3Vyc29yOiBwb2ludGVyO1xufSJdfQ== */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "../../node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _livecharts_src_lib_livecharts_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../livecharts/src/lib/livecharts.service */ "../livecharts/src/lib/livecharts.service.ts");
/* harmony import */ var _animations_animations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./animations/animations */ "./src/app/animations/animations.ts");
/* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./settings */ "./src/app/settings.ts");



// TOGGLE_LCS_HERE
// import { LivechartsService } from 'livecharts';



let AppComponent = class AppComponent {
    constructor(livechartsService, router) {
        this.livechartsService = livechartsService;
        this.router = router;
        this.title = 'Livecharts';
        this.livechartsService.setAnimations(_animations_animations__WEBPACK_IMPORTED_MODULE_4__["animations"]);
        this.livechartsService.setSettings(_settings__WEBPACK_IMPORTED_MODULE_5__["settings"]);
    }
    home() {
        this.router.navigate(['/']);
    }
};
AppComponent.ctorParameters = () => [
    { type: _livecharts_src_lib_livecharts_service__WEBPACK_IMPORTED_MODULE_3__["LivechartsService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "../../node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.scss */ "./src/app/app.component.scss")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser */ "../../node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "../../node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _material_material_module__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./material/material.module */ "./src/app/material/material.module.ts");
/* harmony import */ var _animations_animations_module__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./animations/animations.module */ "./src/app/animations/animations.module.ts");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/platform-browser/animations */ "../../node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _livecharts_src_lib_livecharts_module__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../livecharts/src/lib/livecharts.module */ "../livecharts/src/lib/livecharts.module.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");








// TOGGLE_LCS_HERE
// import { LivechartsModule } from 'livecharts';


let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [_app_component__WEBPACK_IMPORTED_MODULE_9__["AppComponent"]],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_2__["BrowserModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClientModule"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_4__["AppRoutingModule"],
            _material_material_module__WEBPACK_IMPORTED_MODULE_5__["MaterialModule"],
            _animations_animations_module__WEBPACK_IMPORTED_MODULE_6__["AnimationsModule"].forRoot(),
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_7__["BrowserAnimationsModule"],
            _livecharts_src_lib_livecharts_module__WEBPACK_IMPORTED_MODULE_8__["LivechartsModule"],
        ],
        providers: [],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_9__["AppComponent"]],
    })
], AppModule);



/***/ }),

/***/ "./src/app/material/material.module.ts":
/*!*********************************************!*\
  !*** ./src/app/material/material.module.ts ***!
  \*********************************************/
/*! exports provided: MaterialModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MaterialModule", function() { return MaterialModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material_toolbar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/toolbar */ "../../node_modules/@angular/material/esm2015/toolbar.js");



let MaterialModule = class MaterialModule {
};
MaterialModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_material_toolbar__WEBPACK_IMPORTED_MODULE_2__["MatToolbarModule"]],
        exports: [_angular_material_toolbar__WEBPACK_IMPORTED_MODULE_2__["MatToolbarModule"]],
    })
], MaterialModule);



/***/ }),

/***/ "./src/app/settings.ts":
/*!*****************************!*\
  !*** ./src/app/settings.ts ***!
  \*****************************/
/*! exports provided: settings */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "settings", function() { return settings; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");

let settings = {
    client: 'Dogfight',
    project: 'Livecharts',
    fonts: [
        {
            type: 'google',
            url: 'https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i,800,800i&display=swap',
            fontFamily: 'Open Sans',
        },
    ],
};


/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! hammerjs */ "../../node_modules/hammerjs/hammer.js");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(hammerjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "../../node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");






if (_environments_environment__WEBPACK_IMPORTED_MODULE_5__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_3__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_4__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! C:\WebstormProjects\livechartsDogfight\projects\dogfight\src\main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map